"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3690],{

/***/ 1269:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24802);





var Icon = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        viewBox: "0 0 96 96"
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                cx: "48",
                cy: "48",
                r: "48",
                fill: "#F0B90B"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M30.9008 25.9057L47.8088 16.0637L64.7169 25.9057L58.5007 29.5416L47.8088 23.3355L37.117 29.5416L30.9008 25.9057ZM64.7169 38.3179L58.5007 34.682L47.8088 40.8881L37.117 34.682L30.9008 38.3179V45.5897L41.5926 51.7958V64.2079L47.8088 67.8438L54.0251 64.2079V51.7958L64.7169 45.5897V38.3179ZM64.7169 58.0018V50.7301L58.5007 54.366V61.6377L64.7169 58.0018ZM69.1305 60.572L58.4386 66.7781V74.0499L75.3467 64.2079V44.524L69.1305 48.1599V60.572ZM62.9143 32.1118L69.1305 35.7477V43.0195L75.3467 39.3836V32.1118L69.1305 28.4759L62.9143 32.1118ZM41.5926 69.411V76.6828L47.8088 80.3187L54.0251 76.6828V69.411L47.8088 73.0469L41.5926 69.411ZM30.9008 58.0018L37.117 61.6377V54.366L30.9008 50.7301V58.0018ZM41.5926 32.1118L47.8088 35.7477L54.0251 32.1118L47.8088 28.4759L41.5926 32.1118ZM26.4872 35.7477L32.7034 32.1118L26.4872 28.4759L20.271 32.1118V39.3836L26.4872 43.0195V35.7477ZM26.4872 48.1599L20.271 44.524V64.2079L37.1791 74.0499V66.7781L26.4872 60.572V48.1599Z",
                fill: "white"
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 80718:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24802);





var Icon = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        width: "30",
        height: "32",
        viewBox: "0 0 30 32",
        fill: "none"
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fill: "none",
                d: "M15.1769 20.2134C17.4774 20.2134 19.3423 18.3486 19.3423 16.0481C19.3423 13.7477 17.4774 11.8828 15.1769 11.8828C12.8765 11.8828 11.0116 13.7477 11.0116 16.0481C11.0116 18.3486 12.8765 20.2134 15.1769 20.2134Z",
                stroke: "#494949",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fill: "none",
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M28.986 10.0031L27.3166 7.11822C26.6197 5.91887 25.0962 5.51369 23.8969 6.21061L23.0703 6.68063C21.4009 7.63687 19.3264 6.43751 19.3264 4.50882V3.55259C19.3264 2.17496 18.208 1.05664 16.8304 1.05664H13.4917C12.114 1.05664 10.9958 2.17496 10.9958 3.55259V4.50882C10.9958 6.43751 8.92116 7.63687 7.2518 6.68063L6.42525 6.21061C5.2259 5.51369 3.70237 5.93508 3.00545 7.11822L1.33608 10.0031C0.639164 11.2025 1.06055 12.726 2.2437 13.4229L3.07029 13.8929C4.73966 14.8492 4.73966 17.2641 3.07029 18.2203L2.2437 18.6903C1.04435 19.3873 0.639164 20.9108 1.33608 22.1101L3.00545 24.995C3.70237 26.1944 5.2259 26.5996 6.42525 25.9027L7.2518 25.4327C8.92116 24.4764 10.9958 25.6758 10.9958 27.6044V28.5607C10.9958 29.9383 12.114 31.0566 13.4917 31.0566H16.8304C18.208 31.0566 19.3264 29.9383 19.3264 28.5607V27.6044C19.3264 25.6758 21.4009 24.4764 23.0703 25.4327L23.8969 25.9027C25.0962 26.5996 26.6197 26.1782 27.3166 24.995L28.986 22.1101C29.6829 20.9108 29.2615 19.3873 28.0784 18.6903L27.2518 18.2203C25.5825 17.2641 25.5825 14.8492 27.2518 13.8929L28.0784 13.4229C29.2777 12.726 29.6829 11.1863 28.986 10.0031Z",
                stroke: "#494949",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 21926:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24802);



var Icon = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 29 32",
        fill: "none",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M14.3297 31.0002C21.6915 31.0002 27.6595 25.0323 27.6595 17.6705C27.6595 10.3087 21.6915 4.34076 14.3297 4.34076C6.96792 4.34076 1 10.3087 1 17.6705C1 25.0323 6.96792 31.0002 14.3297 31.0002Z",
                fill: "none",
                stroke: "#494949",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M14.3301 1V4.34054",
                stroke: "#494949",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M2.54114 5.88098L4.32488 7.66478",
                stroke: "#494949",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M26.1193 5.88098L24.3356 7.66478",
                stroke: "#494949",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M14.3294 19.3402C15.2519 19.3402 15.9997 18.5924 15.9997 17.67C15.9997 16.7475 15.2519 15.9997 14.3294 15.9997C13.407 15.9997 12.6592 16.7475 12.6592 17.67C12.6592 18.5924 13.407 19.3402 14.3294 19.3402Z",
                stroke: "#494949",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M14.3291 17.67L18.4967 13.5024",
                stroke: "#494949",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M12.6595 1H16.0001",
                stroke: "#494949",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 68492:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _ethersproject_units__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61744);
/* harmony import */ var _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1505);


// try to parse a user entered amount for a given token
function tryParseAmount(value, currency) {
    if (!value || !currency) {
        return undefined;
    }
    try {
        var typedValueParsed = (0,_ethersproject_units__WEBPACK_IMPORTED_MODULE_1__.parseUnits)(value, currency.decimals).toString();
        if (typedValueParsed !== "0") {
            return _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .CurrencyAmount.fromRawAmount */ .ih.fromRawAmount(currency, _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .JSBI.BigInt */ .QA.BigInt(typedValueParsed));
        }
    } catch (error) {
        // should fail if the user specifies too many decimal places of precision (or maybe exceed max uint?)
        console.debug('Failed to parse input amount: "'.concat(value, '"'), error);
    }
    // necessary for all paths to return a value
    return undefined;
}
/* harmony default export */ __webpack_exports__["Z"] = (tryParseAmount);


/***/ }),

/***/ 4278:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ uriToHttp; }
/* harmony export */ });
/* eslint-disable no-case-declarations */ /**
 * Given a URI that may be ipfs, ipns, http, or https protocol, return the fetch-able http(s) URLs for the same content
 * @param uri to convert to fetch-able http url
 */ function uriToHttp(uri) {
    var protocol = uri.split(":")[0].toLowerCase();
    switch(protocol){
        case "https":
            return [
                uri
            ];
        case "http":
            return [
                "https".concat(uri.substring(4)),
                uri
            ];
        case "ipfs":
            var ref;
            var hash = (ref = uri.match(/^ipfs:(\/\/)?(.*)$/i)) === null || ref === void 0 ? void 0 : ref[2];
            return [
                "https://cloudflare-ipfs.com/ipfs/".concat(hash, "/"),
                "https://ipfs.io/ipfs/".concat(hash, "/")
            ];
        case "ipns":
            var ref1;
            var name = (ref1 = uri.match(/^ipns:(\/\/)?(.*)$/i)) === null || ref1 === void 0 ? void 0 : ref1[2];
            return [
                "https://cloudflare-ipfs.com/ipns/".concat(name, "/"),
                "https://ipfs.io/ipns/".concat(name, "/")
            ];
        default:
            return [];
    }
}


/***/ }),

/***/ 26364:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ App_Transactions; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./packages/uikit/src/widgets/Modal/useModal.ts
var useModal = __webpack_require__(62255);
// EXTERNAL MODULE: ./packages/uikit/src/components/Button/IconButton.tsx
var IconButton = __webpack_require__(66354);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/History.tsx
var History = __webpack_require__(21926);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/hooks/useActiveWeb3React.ts
var useActiveWeb3React = __webpack_require__(97477);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Flex.tsx
var Flex = __webpack_require__(29439);
// EXTERNAL MODULE: ./packages/uikit/src/widgets/Modal/Modal.tsx
var Modal = __webpack_require__(86876);
// EXTERNAL MODULE: ./packages/uikit/src/widgets/Modal/styles.tsx
var styles = __webpack_require__(51944);
// EXTERNAL MODULE: ./packages/uikit/src/components/Text/Text.tsx
var Text = __webpack_require__(74566);
// EXTERNAL MODULE: ./packages/uikit/src/components/Button/Button.tsx + 2 modules
var Button = __webpack_require__(45388);
// EXTERNAL MODULE: ./packages/localization/src/index.tsx + 1 modules
var src = __webpack_require__(68486);
// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ./node_modules/lodash/groupBy.js
var groupBy = __webpack_require__(7739);
var groupBy_default = /*#__PURE__*/__webpack_require__.n(groupBy);
// EXTERNAL MODULE: ./src/state/transactions/hooks.tsx
var hooks = __webpack_require__(56906);
// EXTERNAL MODULE: ./src/state/index.ts + 32 modules
var state = __webpack_require__(106);
// EXTERNAL MODULE: ./src/state/transactions/actions.ts
var actions = __webpack_require__(44824);
// EXTERNAL MODULE: ./src/utils/wagmi.ts + 131 modules
var wagmi = __webpack_require__(25121);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./src/components/Layout/Row.tsx
var Row = __webpack_require__(30445);
// EXTERNAL MODULE: ./packages/uikit/src/components/Link/LinkExternal.tsx
var LinkExternal = __webpack_require__(68304);
// EXTERNAL MODULE: ./src/utils/index.ts
var utils = __webpack_require__(97119);
;// CONCATENATED MODULE: ./src/components/App/Transactions/Transaction.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  text-decoration: none !important;\n  border-radius: 0.5rem;\n  padding: 0.25rem 0rem;\n  font-weight: 500;\n  font-size: 0.825rem;\n  color: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




var TransactionState = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e847b7cd-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.text;
});
var IconWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e847b7cd-1"
})(_templateObject1(), function(param) {
    var pending = param.pending, success = param.success, theme = param.theme;
    return pending ? theme.colors.primary : success ? theme.colors.success : theme.colors.failure;
});
function Transaction(param) {
    var tx = param.tx, chainId = param.chainId;
    var ref, ref1;
    var summary = tx === null || tx === void 0 ? void 0 : tx.summary;
    var pending = !(tx === null || tx === void 0 ? void 0 : tx.receipt);
    var success = !pending && tx && (((ref = tx.receipt) === null || ref === void 0 ? void 0 : ref.status) === 1 || typeof ((ref1 = tx.receipt) === null || ref1 === void 0 ? void 0 : ref1.status) === "undefined");
    if (!chainId) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TransactionState, {
        pending: pending,
        success: success,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkExternal/* default */.Z, {
            href: (0,utils/* getBlockExploreLink */.C)(tx.hash, "transaction", chainId),
            children: summary !== null && summary !== void 0 ? summary : tx.hash
        })
    });
}

// EXTERNAL MODULE: ./src/components/ConnectWalletButton.tsx
var ConnectWalletButton = __webpack_require__(7447);
;// CONCATENATED MODULE: ./src/components/App/Transactions/TransactionsModal.tsx


function TransactionsModal_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  color: ",
        ";\n  text-transform:uppercase;\n  @media(max-width:600px){\n    padding: 0 16px;\n    margin-top: 8px;\n  }\n"
    ]);
    TransactionsModal_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function TransactionsModal_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  min-width: 320px;\n  width:450px;\n  height: 100%;\n  min-height: 250px;\n  align-items: center;\n  ",
        "{\n    padding:0px !important;\n  }\n  @media(max-width:600px){\n    width:100%;\n  }\n"
    ]);
    TransactionsModal_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}















function renderTransactions(transactions, chainId) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
        flexDirection: "column",
        children: transactions.map(function(tx) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Transaction, {
                tx: tx,
                chainId: chainId
            }, tx.hash + tx.addedTime);
        })
    });
}
var TransactionsModal = function(param) {
    var onDismiss = param.onDismiss;
    var account = (0,useActiveWeb3React/* default */.Z)().account;
    var dispatch = (0,state/* useAppDispatch */.TL)();
    var sortedRecentTransactions = (0,hooks/* useAllSortedRecentTransactions */.Fn)();
    var t = (0,src/* useTranslation */.$G)().t;
    var hasTransactions = !isEmpty_default()(sortedRecentTransactions);
    var clearAllTransactionsCallback = (0,react.useCallback)(function() {
        dispatch((0,actions/* clearAllTransactions */.fY)());
    }, [
        dispatch
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.ZP, {
        title: t("Recent Transactions"),
        headerBackground: "gradientCardHeader",
        onDismiss: onDismiss,
        children: account ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CsContainer, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* ModalBody */.fe, {
                children: hasTransactions ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* AutoRow */.BA, {
                            mb: "1rem",
                            style: {
                                justifyContent: "space-between"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    style: {
                                        textAlign: "center"
                                    },
                                    children: t("Recent Transactions")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CsButtonClearAll, {
                                    scale: "md",
                                    onClick: clearAllTransactionsCallback,
                                    children: t("Clear all")
                                })
                            ]
                        }),
                        Object.entries(sortedRecentTransactions).map(function(param) {
                            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), chainId = _param[0], transactions = _param[1];
                            var ref;
                            var chainIdNumber = Number(chainId);
                            var groupedTransactions = groupBy_default()(Object.values(transactions), function(trxDetails) {
                                return Boolean(trxDetails.receipt);
                            });
                            var _true;
                            var confirmed = (_true = groupedTransactions.true) !== null && _true !== void 0 ? _true : [];
                            var _false;
                            var pending = (_false = groupedTransactions.false) !== null && _false !== void 0 ? _false : [];
                            var ref1;
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        color: "text",
                                        mb: "4px",
                                        children: (ref1 = (ref = wagmi/* chains.find */.p5.find(function(c) {
                                            return c.id === chainIdNumber;
                                        })) === null || ref === void 0 ? void 0 : ref.name) !== null && ref1 !== void 0 ? ref1 : "Unknown network"
                                    }),
                                    renderTransactions(pending, chainIdNumber),
                                    renderTransactions(confirmed, chainIdNumber)
                                ]
                            }, "transactions#".concat(chainIdNumber));
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    width: "100%",
                    textAlign: "center",
                    children: t("No recent transactions")
                })
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(CsContainer, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                width: "100%",
                justifyContent: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ConnectWalletButton/* default */.Z, {})
            })
        })
    });
};
/* harmony default export */ var Transactions_TransactionsModal = (TransactionsModal);
var CsButtonClearAll = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    componentId: "sc-336634bd-0"
})(TransactionsModal_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.text;
}, function(param) {
    var theme = param.theme;
    return theme.colors.background;
});
var CsContainer = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-336634bd-1"
})(TransactionsModal_templateObject1(), styles/* ModalBody */.fe);

;// CONCATENATED MODULE: ./src/components/App/Transactions/index.tsx




var Transactions = function(param) {
    var iconColors = param.iconColors;
    var ref = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(Transactions_TransactionsModal, {})), 1), onPresentTransactionsModal = ref[0];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
            scale: "sm",
            variant: "text",
            onClick: onPresentTransactionsModal,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(History/* default */.Z, {
                color: iconColors || "textSubtle",
                width: "24px"
            })
        })
    });
};
/* harmony default export */ var App_Transactions = (Transactions);


/***/ }),

/***/ 941:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Tz": function() { return /* binding */ AutoColumn; },
/* harmony export */   "lg": function() { return /* binding */ ColumnCenter; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19521);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  align-items: center;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: grid;\n  grid-auto-rows: auto;\n  grid-row-gap: ",
        ";\n  justify-items: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

var Column = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-91e5cc43-0"
})(_templateObject());
var ColumnCenter = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(Column).withConfig({
    componentId: "sc-91e5cc43-1"
})(_templateObject1());
var AutoColumn = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-91e5cc43-2"
})(_templateObject2(), function(param) {
    var gap = param.gap;
    return gap === "sm" && "8px" || gap === "md" && "12px" || gap === "lg" && "24px" || gap;
}, function(param) {
    var justify = param.justify;
    return justify;
});
/* harmony default export */ __webpack_exports__["ZP"] = (Column);


/***/ }),

/***/ 30445:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BA": function() { return /* binding */ AutoRow; },
/* harmony export */   "DA": function() { return /* binding */ RowFixed; },
/* harmony export */   "m0": function() { return /* binding */ RowBetween; }
/* harmony export */ });
/* unused harmony export RowFlat */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19521);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6538);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: ",
        ";\n  display: flex;\n  align-items: ",
        ";\n  justify-content: ",
        ";\n  padding: ",
        ";\n  border: ",
        ";\n  border-radius: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  justify-content: space-between;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: flex-end;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  flex-wrap: wrap;\n  margin: ",
        ";\n  justify-content: ",
        ";\n\n  & > * {\n    margin: ",
        " !important;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: fit-content;\n  margin: ",
        ";\n\n  & > * {\n    margin: ",
        " !important;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}


var Row = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-a99b64d2-0"
})(_templateObject(), function(param) {
    var width = param.width;
    return width !== null && width !== void 0 ? width : "100%";
}, function(param) {
    var align = param.align;
    return align !== null && align !== void 0 ? align : "center";
}, function(param) {
    var justify = param.justify;
    return justify !== null && justify !== void 0 ? justify : "flex-start";
}, function(param) {
    var padding = param.padding;
    return padding !== null && padding !== void 0 ? padding : "0";
}, function(param) {
    var border = param.border;
    return border;
}, function(param) {
    var borderRadius = param.borderRadius;
    return borderRadius;
});
var RowBetween = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(Row).withConfig({
    componentId: "sc-a99b64d2-1"
})(_templateObject1());
var RowFlat = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-a99b64d2-2"
})(_templateObject2());
var AutoRow = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(Row).withConfig({
    componentId: "sc-a99b64d2-3"
})(_templateObject3(), function(param) {
    var gap = param.gap;
    return gap && "-".concat(gap);
}, function(param) {
    var justify = param.justify;
    return justify;
}, function(param) {
    var gap = param.gap;
    return gap;
});
var RowFixed = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(Row).withConfig({
    componentId: "sc-a99b64d2-4"
})(_templateObject4(), function(param) {
    var gap = param.gap;
    return gap && "-".concat(gap);
}, function(param) {
    var gap = param.gap;
    return gap;
});
/* harmony default export */ __webpack_exports__["ZP"] = (Row);


/***/ }),

/***/ 96459:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CurrencyLogo; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(82670);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./packages/swap-sdk/src/index.ts + 21 modules
var src = __webpack_require__(1505);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Binance.tsx
var Binance = __webpack_require__(1269);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./packages/tokens/src/index.ts + 8 modules
var tokens_src = __webpack_require__(30693);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./src/hooks/useHttpLocations.ts
var useHttpLocations = __webpack_require__(40182);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
;// CONCATENATED MODULE: ./src/utils/getTokenLogoURL.ts


var _obj;
var mapping = (_obj = {}, (0,_define_property/* default */.Z)(_obj, src/* ChainId.BSC */.a_.BSC, "smartchain"), (0,_define_property/* default */.Z)(_obj, src/* ChainId.ETHEREUM */.a_.ETHEREUM, "ethereum"), _obj);
var getTokenLogoURL = function(token) {
    if (token && mapping[token.chainId]) {
        return "https://assets-cdn.trustwallet.com/blockchains/".concat(mapping[token.chainId], "/assets/").concat(token.address, "/logo.png");
    }
    return null;
};
/* harmony default export */ var utils_getTokenLogoURL = (getTokenLogoURL);

// EXTERNAL MODULE: ./src/components/Logo/Logo.tsx
var Logo = __webpack_require__(52175);
;// CONCATENATED MODULE: ./src/components/Logo/CurrencyLogo.tsx



function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: ",
        ";\n  height: ",
        ";\n  border-radius: 50%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}









var StyledLogo = (0,styled_components_browser_esm/* default */.ZP)(Logo/* default */.Z).withConfig({
    componentId: "sc-4861fb15-0"
})(_templateObject(), function(param) {
    var size = param.size;
    return size;
}, function(param) {
    var size = param.size;
    return size;
});
function CurrencyLogo(param) {
    var currency = param.currency, _size = param.size, size = _size === void 0 ? "24px" : _size, style = param.style;
    var uriLocations = (0,useHttpLocations/* default */.Z)((0,_instanceof/* default */.Z)(currency, tokens_src/* WrappedTokenInfo */.DT) ? currency.logoURI : undefined);
    var srcs = (0,react.useMemo)(function() {
        if (currency === null || currency === void 0 ? void 0 : currency.isNative) return [];
        if (currency === null || currency === void 0 ? void 0 : currency.isToken) {
            var tokenLogoURL = utils_getTokenLogoURL(currency);
            if ((0,_instanceof/* default */.Z)(currency, tokens_src/* WrappedTokenInfo */.DT)) {
                if (!tokenLogoURL) return (0,_to_consumable_array/* default */.Z)(uriLocations);
                return (0,_to_consumable_array/* default */.Z)(uriLocations).concat([
                    tokenLogoURL
                ]);
            }
            if (!tokenLogoURL) return [];
            return [
                tokenLogoURL
            ];
        }
        return [];
    }, [
        currency,
        uriLocations
    ]);
    if (currency === null || currency === void 0 ? void 0 : currency.isNative) {
        if (currency.chainId === src/* ChainId.BSC */.a_.BSC) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Binance/* default */.Z, {
                width: size,
                style: style
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLogo, {
            size: size,
            srcs: [
                "/images/chains/".concat(currency.chainId, ".png")
            ],
            width: size,
            style: style
        });
    }
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLogo, {
        size: size,
        srcs: srcs,
        alt: "".concat((ref = currency === null || currency === void 0 ? void 0 : currency.symbol) !== null && ref !== void 0 ? ref : "token", " logo"),
        style: style
    });
}


/***/ }),

/***/ 52175:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ BAD_SRCS; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(17664);






var BAD_SRCS = {};
/**
 * Renders an image by sequentially trying a list of URIs, and then eventually a fallback triangle alert
 */ var Logo = function(_param) {
    var srcs = _param.srcs, alt = _param.alt, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "srcs",
        "alt"
    ]);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0), refresh = ref[1];
    var src = srcs.find(function(s) {
        return !BAD_SRCS[s];
    });
    if (src) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest), {
            alt: alt,
            src: src,
            onError: function() {
                if (src) BAD_SRCS[src] = true;
                refresh(function(i) {
                    return i + 1;
                });
            }
        }));
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest));
};
/* harmony default export */ __webpack_exports__["Z"] = (Logo);


/***/ }),

/***/ 19259:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Xw": function() { return /* reexport */ CurrencyLogo/* default */.Z; },
  "ge": function() { return /* reexport */ DoubleCurrencyLogo; },
  "_r": function() { return /* reexport */ ListLogo; }
});

// EXTERNAL MODULE: ./src/components/Logo/CurrencyLogo.tsx + 1 modules
var CurrencyLogo = __webpack_require__(96459);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./src/components/Logo/DoubleLogo.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  margin-right: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b339c6de-0"
})(_templateObject(), function(param) {
    var margin = param.margin;
    return margin && "4px";
});
function DoubleCurrencyLogo(param) {
    var currency0 = param.currency0, currency1 = param.currency1, _size = param.size, size = _size === void 0 ? 20 : _size, _margin = param.margin, margin = _margin === void 0 ? false : _margin;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        margin: margin,
        children: [
            currency0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrencyLogo/* default */.Z, {
                currency: currency0,
                size: "".concat(size.toString(), "px"),
                style: {
                    marginRight: "4px"
                }
            }),
            currency1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrencyLogo/* default */.Z, {
                currency: currency1,
                size: "".concat(size.toString(), "px")
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/hooks/useHttpLocations.ts
var useHttpLocations = __webpack_require__(40182);
// EXTERNAL MODULE: ./src/components/Logo/Logo.tsx
var Logo = __webpack_require__(52175);
;// CONCATENATED MODULE: ./src/components/Logo/ListLogo.tsx

function ListLogo_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: ",
        ";\n  height: ",
        ";\n"
    ]);
    ListLogo_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var StyledListLogo = (0,styled_components_browser_esm/* default */.ZP)(Logo/* default */.Z).withConfig({
    componentId: "sc-60793395-0"
})(ListLogo_templateObject(), function(param) {
    var size = param.size;
    return size;
}, function(param) {
    var size = param.size;
    return size;
});
function ListLogo(param) {
    var logoURI = param.logoURI, style = param.style, _size = param.size, size = _size === void 0 ? "24px" : _size, alt = param.alt;
    var srcs = (0,useHttpLocations/* default */.Z)(logoURI);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledListLogo, {
        alt: alt,
        size: size,
        srcs: srcs,
        style: style
    });
}

;// CONCATENATED MODULE: ./src/components/Logo/index.ts





/***/ }),

/***/ 24673:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ GlobalSettings_SettingsModal; },
  "h": function() { return /* binding */ withCustomOnDismiss; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Flex.tsx
var Flex = __webpack_require__(29439);
// EXTERNAL MODULE: ./packages/uikit/src/widgets/Modal/Modal.tsx
var Modal = __webpack_require__(86876);
// EXTERNAL MODULE: ./src/state/user/hooks/index.tsx
var hooks = __webpack_require__(921);
// EXTERNAL MODULE: ./src/state/swap/useSwapActionHandlers.ts
var useSwapActionHandlers = __webpack_require__(1999);
// EXTERNAL MODULE: ./src/hooks/useActiveChainId.ts
var useActiveChainId = __webpack_require__(56797);
// EXTERNAL MODULE: ./packages/localization/src/index.tsx + 1 modules
var src = __webpack_require__(68486);
// EXTERNAL MODULE: ./src/hooks/useTheme.ts
var useTheme = __webpack_require__(63850);
// EXTERNAL MODULE: ./src/utils/index.ts
var utils = __webpack_require__(97119);
// EXTERNAL MODULE: ./packages/uikit/src/components/Text/Text.tsx
var Text = __webpack_require__(74566);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Box.tsx
var Box = __webpack_require__(6538);
// EXTERNAL MODULE: ./packages/uikit/src/components/Button/Button.tsx + 2 modules
var Button = __webpack_require__(45388);
// EXTERNAL MODULE: ./packages/uikit/src/components/Input/Input.tsx
var Input = __webpack_require__(43605);
// EXTERNAL MODULE: ./src/components/QuestionHelper/index.tsx
var QuestionHelper = __webpack_require__(72566);
;// CONCATENATED MODULE: ./src/components/Menu/GlobalSettings/TransactionSettings.tsx


function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height:58px;\n  background-color: ",
        ";\n  color:",
        ";\n  border-radius:0px;\n  box-shadow:none;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding:8px 12px 8px 12px!important;\n  height: 58px;\n  color:",
        ";\n  background:transparent;\n  border:none;\n  box-shadow:none!important;\n  ::placeholder {\n    color: ",
        "; \n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: 1px solid ",
        ";\n  align-items: center;\n  height: 58px;\n  padding-right:10px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}








var SlippageError;
(function(SlippageError) {
    SlippageError["InvalidInput"] = "InvalidInput";
    SlippageError["RiskyLow"] = "RiskyLow";
    SlippageError["RiskyHigh"] = "RiskyHigh";
})(SlippageError || (SlippageError = {}));
var DeadlineError;
(function(DeadlineError) {
    DeadlineError["InvalidInput"] = "InvalidInput";
})(DeadlineError || (DeadlineError = {}));
var inputRegex = RegExp("^\\d*(?:\\\\[.])?\\d*$") // match escaped "." characters via in a non-capturing group
;
var THREE_DAYS_IN_SECONDS = 60 * 60 * 24 * 3;
var SlippageTabs = function() {
    var ref = (0,_sliced_to_array/* default */.Z)((0,hooks/* useUserSlippageTolerance */.$2)(), 2), userSlippageTolerance = ref[0], setUserSlippageTolerance = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,hooks/* useUserTransactionTTL */.A6)(), 2), ttl = ref1[0], setTtl = ref1[1];
    var ref2 = (0,react.useState)(""), slippageInput = ref2[0], setSlippageInput = ref2[1];
    var ref3 = (0,react.useState)(""), deadlineInput = ref3[0], setDeadlineInput = ref3[1];
    var t = (0,src/* useTranslation */.$G)().t;
    var slippageInputIsValid = slippageInput === "" || (userSlippageTolerance / 100).toFixed(2) === Number.parseFloat(slippageInput).toFixed(2);
    var deadlineInputIsValid = deadlineInput === "" || (ttl / 60).toString() === deadlineInput;
    var slippageError;
    if (slippageInput !== "" && !slippageInputIsValid) {
        slippageError = SlippageError.InvalidInput;
    } else if (slippageInputIsValid && userSlippageTolerance < 50) {
        slippageError = SlippageError.RiskyLow;
    } else if (slippageInputIsValid && userSlippageTolerance > 500) {
        slippageError = SlippageError.RiskyHigh;
    } else {
        slippageError = undefined;
    }
    var deadlineError;
    if (deadlineInput !== "" && !deadlineInputIsValid) {
        deadlineError = DeadlineError.InvalidInput;
    } else {
        deadlineError = undefined;
    }
    var parseCustomSlippage = function(value) {
        if (value === "" || inputRegex.test((0,utils/* escapeRegExp */.hr)(value))) {
            setSlippageInput(value);
            try {
                var valueAsIntFromRoundedFloat = Number.parseInt((Number.parseFloat(value) * 100).toString());
                if (!Number.isNaN(valueAsIntFromRoundedFloat) && valueAsIntFromRoundedFloat < 5000) {
                    setUserSlippageTolerance(valueAsIntFromRoundedFloat);
                }
            } catch (error) {
                console.error(error);
            }
        }
    };
    var parseCustomDeadline = function(value) {
        setDeadlineInput(value);
        try {
            var valueAsInt = Number.parseInt(value) * 60;
            if (!Number.isNaN(valueAsInt) && valueAsInt > 60 && valueAsInt < THREE_DAYS_IN_SECONDS) {
                setTtl(valueAsInt);
            } else {
                deadlineError = DeadlineError.InvalidInput;
            }
        } catch (error) {
            console.error(error);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        flexDirection: "column",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                flexDirection: "column",
                mb: "24px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        mb: "12px",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                children: t("Slippage Tolerance")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(QuestionHelper/* default */.Z, {
                                text: t("Setting a high slippage tolerance can help transactions succeed, but you may not get such a good price. Use with caution."),
                                placement: "top-start",
                                ml: "4px"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        flexWrap: "wrap",
                        style: {
                            gap: "10px"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                width: "100%",
                                justifyContent: "space-between",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomButton, {
                                        onClick: function() {
                                            setSlippageInput("");
                                            setUserSlippageTolerance(10);
                                        },
                                        isActive: userSlippageTolerance === 10 ? !false : false,
                                        children: "0.1%"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomButton, {
                                        onClick: function() {
                                            setSlippageInput("");
                                            setUserSlippageTolerance(50);
                                        },
                                        isActive: userSlippageTolerance === 50 ? !false : false,
                                        children: "0.5%"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomButton, {
                                        onClick: function() {
                                            setSlippageInput("");
                                            setUserSlippageTolerance(100);
                                        },
                                        isActive: userSlippageTolerance === 100 ? !false : false,
                                        children: "1.0%"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CsFlex, {
                                alignItems: "center",
                                width: "100%",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                        width: "100%",
                                        mt: "4px",
                                        style: {
                                            flex: 1
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomInput, {
                                            scale: "sm",
                                            inputMode: "decimal",
                                            pattern: "^[0-9]*[.,]?[0-9]{0,2}$",
                                            placeholder: (userSlippageTolerance / 100).toFixed(2),
                                            value: slippageInput,
                                            onBlur: function() {
                                                parseCustomSlippage((userSlippageTolerance / 100).toFixed(2));
                                            },
                                            onChange: function(event) {
                                                if (event.currentTarget.validity.valid) {
                                                    parseCustomSlippage(event.target.value.replace(/,/g, "."));
                                                }
                                            },
                                            isWarning: !slippageInputIsValid,
                                            isSuccess: ![
                                                10,
                                                50,
                                                100
                                            ].includes(userSlippageTolerance)
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        color: "text",
                                        bold: true,
                                        ml: "2px",
                                        children: "%"
                                    })
                                ]
                            })
                        ]
                    }),
                    !!slippageError && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        fontSize: "14px",
                        color: slippageError === SlippageError.InvalidInput ? "red" : "#FF592C",
                        mt: "8px",
                        children: slippageError === SlippageError.InvalidInput ? t("Enter a valid slippage percentage") : slippageError === SlippageError.RiskyLow ? t("Your transaction may fail") : t("Your transaction may be frontrun")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                justifyContent: "space-between",
                alignItems: "center",
                mb: "24px",
                flexWrap: "wrap",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        alignItems: "center",
                        width: "100%",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                children: t("Transaction deadline (mins)")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(QuestionHelper/* default */.Z, {
                                text: t("Your transaction will revert if it is left confirming for longer than this time."),
                                placement: "top-start",
                                ml: "4px"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CsFlex, {
                        width: "100%",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            width: "100%",
                            mt: "4px",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomInput, {
                                scale: "sm",
                                inputMode: "numeric",
                                pattern: "^[0-9]+$",
                                isWarning: !!deadlineError,
                                onBlur: function() {
                                    parseCustomDeadline((ttl / 60).toString());
                                },
                                placeholder: (ttl / 60).toString(),
                                value: deadlineInput,
                                onChange: function(event) {
                                    if (event.currentTarget.validity.valid) {
                                        parseCustomDeadline(event.target.value);
                                    }
                                }
                            })
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var TransactionSettings = (SlippageTabs);
var CustomButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    componentId: "sc-46ec84cd-0"
})(_templateObject(), function(param) {
    var theme = param.theme, isActive = param.isActive;
    return isActive ? theme.colors.text : "transparent";
}, function(param) {
    var theme = param.theme, isActive = param.isActive;
    return isActive ? theme.colors.background : theme.colors.text;
});
var CustomInput = (0,styled_components_browser_esm/* default */.ZP)(Input/* default */.Z).withConfig({
    componentId: "sc-46ec84cd-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.text;
}, function(param) {
    var theme = param.theme;
    return theme.colors.text;
});
var CsFlex = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-46ec84cd-2"
})(_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.colors.text;
});

// EXTERNAL MODULE: ./packages/uikit/src/contexts/MatchBreakpoints/useMatchBreakpoints.ts
var useMatchBreakpoints = __webpack_require__(78258);
// EXTERNAL MODULE: ./packages/uikit/src/components/Message/Message.tsx + 1 modules
var Message = __webpack_require__(67405);
// EXTERNAL MODULE: ./packages/uikit/src/components/Checkbox/Checkbox.tsx
var Checkbox = __webpack_require__(68434);
;// CONCATENATED MODULE: ./src/components/Menu/GlobalSettings/ExpertModal.tsx






var ExpertModal = function(param) {
    var setShowConfirmExpertModal = param.setShowConfirmExpertModal, setShowExpertModeAcknowledgement = param.setShowExpertModeAcknowledgement;
    var ref = (0,_sliced_to_array/* default */.Z)((0,hooks/* useExpertModeManager */.DG)(), 2), toggleExpertMode = ref[1];
    var ref1 = (0,react.useState)(false), isRememberChecked = ref1[0], setIsRememberChecked = ref1[1];
    var isMobile = (0,useMatchBreakpoints/* default */.Z)().isMobile;
    var t = (0,src/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.ZP, {
        title: t("Expert Mode"),
        onBack: function() {
            return setShowConfirmExpertModal(false);
        },
        onDismiss: function() {
            return setShowConfirmExpertModal(false);
        },
        headerBackground: "gradientCardHeader",
        style: {
            width: isMobile ? "100%" : "436px"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Message/* default */.Z, {
                variant: "warning",
                mb: "24px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    children: t("Expert mode turns off the 'Confirm' transaction prompt, and allows high slippage trades that often result in bad rates and lost funds.")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                mb: "24px",
                children: t("Only use this mode if you know what you’re doing.")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                alignItems: "center",
                mb: "24px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                        name: "confirmed",
                        type: "checkbox",
                        checked: isRememberChecked,
                        onChange: function() {
                            return setIsRememberChecked(!isRememberChecked);
                        },
                        scale: "sm"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        ml: "10px",
                        color: "textSubtle",
                        style: {
                            userSelect: "none"
                        },
                        children: t("Don’t show this again")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                mb: "8px",
                id: "confirm-expert-mode",
                onClick: function() {
                    // eslint-disable-next-line no-alert
                    if (window.prompt('Please type the word "confirm" to enable expert mode.') === "confirm") {
                        toggleExpertMode();
                        setShowConfirmExpertModal(false);
                        if (isRememberChecked) {
                            setShowExpertModeAcknowledgement(false);
                        }
                    }
                },
                children: t("Turn On Expert Mode")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                variant: "secondary",
                onClick: function() {
                    setShowConfirmExpertModal(false);
                },
                children: t("Cancel")
            })
        ]
    });
};
/* harmony default export */ var GlobalSettings_ExpertModal = (ExpertModal);

// EXTERNAL MODULE: ./src/components/Menu/GlobalSettings/types.ts
var types = __webpack_require__(47756);
;// CONCATENATED MODULE: ./src/components/Menu/GlobalSettings/SettingsModal.tsx





function SettingsModal_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-direction: column;\n  height: auto;\n  ",
        " {\n    max-height: 90vh;\n  }\n  ",
        " {\n    max-height: none;\n  }\n"
    ]);
    SettingsModal_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SettingsModal_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n\n"
    ]);
    SettingsModal_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}












var ScrollableContainer = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-cccd8ecf-0"
})(SettingsModal_templateObject(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.xs;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
});
var CustomModal = (0,styled_components_browser_esm/* default */.ZP)(Modal/* default */.ZP).withConfig({
    componentId: "sc-cccd8ecf-1"
})(SettingsModal_templateObject1());
var withCustomOnDismiss = function(Component) {
    return function(_param) {
        var onDismiss = _param.onDismiss, customOnDismiss = _param.customOnDismiss, mode = _param.mode, props = (0,_object_without_properties/* default */.Z)(_param, [
            "onDismiss",
            "customOnDismiss",
            "mode"
        ]);
        var handleDismiss = (0,react.useCallback)(function() {
            onDismiss === null || onDismiss === void 0 ? void 0 : onDismiss();
            if (customOnDismiss) {
                customOnDismiss();
            }
        }, [
            customOnDismiss,
            onDismiss
        ]);
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
            mode: mode,
            onDismiss: handleDismiss
        }));
    };
};
var SettingsModal = function(param) {
    var onDismiss = param.onDismiss, mode = param.mode;
    var ref = (0,react.useState)(false), showConfirmExpertModal = ref[0], setShowConfirmExpertModal = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,hooks/* useUserExpertModeAcknowledgementShow */.wX)(), 2), showExpertModeAcknowledgement = ref1[0], setShowExpertModeAcknowledgement = ref1[1];
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,hooks/* useExpertModeManager */.DG)(), 2), expertMode = ref2[0], toggleExpertMode = ref2[1];
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,hooks/* useUserSingleHopOnly */.RO)(), 2), singleHopOnly = ref3[0], setSingleHopOnly = ref3[1];
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,hooks/* useAudioModeManager */.TO)(), 2), audioPlay = ref4[0], toggleSetAudioMode = ref4[1];
    var ref5 = (0,_sliced_to_array/* default */.Z)((0,hooks/* useZapModeManager */.$f)(), 2), zapMode = ref5[0], toggleZapMode = ref5[1];
    var ref6 = (0,_sliced_to_array/* default */.Z)((0,hooks/* useSubgraphHealthIndicatorManager */.YF)(), 2), subgraphHealth = ref6[0], setSubgraphHealth = ref6[1];
    var onChangeRecipient = (0,useSwapActionHandlers/* useSwapActionHandlers */._)().onChangeRecipient;
    var chainId = (0,useActiveChainId/* useActiveChainId */.g)().chainId;
    var t = (0,src/* useTranslation */.$G)().t;
    var ref7 = (0,useTheme/* default */.ZP)(), isDark = ref7.isDark, setTheme = ref7.setTheme;
    if (showConfirmExpertModal) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalSettings_ExpertModal, {
            setShowConfirmExpertModal: setShowConfirmExpertModal,
            onDismiss: onDismiss,
            setShowExpertModeAcknowledgement: setShowExpertModeAcknowledgement
        });
    }
    var handleExpertModeToggle = function() {
        if (expertMode) {
            onChangeRecipient(null);
            toggleExpertMode();
        } else if (!showExpertModeAcknowledgement) {
            onChangeRecipient(null);
            toggleExpertMode();
        } else {
            setShowConfirmExpertModal(true);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomModal, {
        title: t("Settings"),
        headerBackground: "gradientCardHeader",
        minWidth: "320px",
        onDismiss: onDismiss,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollableContainer, {
            children: mode === types/* SettingsMode.SWAP_LIQUIDITY */.a.SWAP_LIQUIDITY && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                    pt: "3px",
                    flexDirection: "column",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TransactionSettings, {})
                })
            })
        })
    });
};
/* harmony default export */ var GlobalSettings_SettingsModal = (SettingsModal);


/***/ }),

/***/ 69425:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(828);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62255);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(29439);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(66354);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(80718);
/* harmony import */ var _SettingsModal__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24673);




var GlobalSettings = function(param) {
    var color = param.color, _mr = param.mr, mr = _mr === void 0 ? "8px" : _mr, mode = param.mode;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SettingsModal__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        mode: mode
    })), 1), onPresentSettingsModal = ref[0];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            onClick: onPresentSettingsModal,
            variant: "text",
            scale: "sm",
            mr: mr,
            id: "open-settings-dialog-button-".concat(mode),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                height: 24,
                width: 24,
                color: color || "text"
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (GlobalSettings);


/***/ }),

/***/ 47756:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ SettingsMode; }
/* harmony export */ });
var SettingsMode;
(function(SettingsMode) {
    SettingsMode["GLOBAL"] = "GLOBAL";
    SettingsMode["SWAP_LIQUIDITY"] = "SWAP_LIQUIDITY";
})(SettingsMode || (SettingsMode = {}));


/***/ }),

/***/ 21281:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(19521);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(29439);
/* harmony import */ var _pancakeswap_localization__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68486);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_4__);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-bottom: 0px;\n  justify-content: center;\n  text-align: center;\n  display: flex;\n  overflow: hidden;\n  flex-direction: row;\n  width: 100%;\n  box-sizing: border-box;\n  margin-left: auto;\n  margin-right: auto;\n  ",
        " {\n    flex-direction: row;\n    width: 550px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width:100%;\n  display: flex;\n  flex-direction:row;\n  align-items: center;\n  justify-content: space-around;\n  max-width: 400px;\n  height:auto;\n  margin-top:2rem;\n  margin-bottom:1rem;\n  @media screen and (max-width: 600px) {\n    padding: 0 20px;    \n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: ",
        ";\n  display: flex ;\n  align-items: center ;\n  justify-content: center ;\n  padding-bottom: 20px ;\n  font-family: 'Marcellus';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 32px;\n  width: 100%;\n  text-align: center;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 150px;\n  border-bottom:2px solid ",
        ";\n  cursor:pointer;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}






var StyledNav = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].nav.withConfig */ .ZP.nav.withConfig({
    componentId: "sc-bd6a85cf-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
});
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-bd6a85cf-1"
})(_templateObject1());
var CustomNavLink = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].p.withConfig */ .ZP.p.withConfig({
    componentId: "sc-bd6a85cf-2"
})(_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.colors.text;
});
var WrapLink = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z).withConfig({
    componentId: "sc-bd6a85cf-3"
})(_templateObject3(), function(param) {
    var theme = param.theme, isActive = param.isActive;
    return isActive ? theme.colors.text : "none";
});
var getActiveIndex = function(pathname) {
    if (pathname.includes("/liquidity") || pathname.includes("/add") || pathname.includes("/find") || pathname.includes("/remove")) {
        return 1;
    }
    return 0;
};
var Nav = function() {
    var pathname = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)().pathname;
    var t = (0,_pancakeswap_localization__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)().t;
    var activeIndex = getActiveIndex(pathname);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        width: "100%",
        justifyContent: "center",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Wrapper, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(WrapLink, {
                    isActive: activeIndex === 0 ? !false : false,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                        href: "/swap",
                        passHref: true,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CustomNavLink, {
                            children: t("Swap")
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(WrapLink, {
                    isActive: activeIndex === 1 ? !false : false,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                        href: "/liquidity",
                        passHref: true,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CustomNavLink, {
                            children: t("Liquidity")
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Nav);


/***/ }),

/***/ 72566:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(10759);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6538);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(17664);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  :hover,\n  :focus {\n    opacity: 0.7;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var QuestionWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-3f13654-0"
})(_templateObject());
var QuestionHelper = function(_param) {
    var text = _param.text, _placement = _param.placement, placement = _placement === void 0 ? "right-end" : _placement, _size = _param.size, size = _size === void 0 ? "16px" : _size, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "text",
        "placement",
        "size"
    ]);
    var ref = (0,_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(text, {
        placement: placement
    }), targetRef = ref.targetRef, tooltip = ref.tooltip, tooltipVisible = ref.tooltipVisible;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, props), {
        children: [
            tooltipVisible && tooltip,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(QuestionWrapper, {
                ref: targetRef,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                    color: "text",
                    width: size
                })
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (QuestionHelper);


/***/ }),

/***/ 94293:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "mP": function() { return /* binding */ useIsTransactionUnsupported; },
  "uK": function() { return /* binding */ useIsTransactionWarning; },
  "AU": function() { return /* binding */ useTradeExactIn; },
  "in": function() { return /* binding */ useTradeExactOut; }
});

// UNUSED EXPORTS: useAllCommonPairs

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
// EXTERNAL MODULE: ./src/config/constants/exchange.ts
var exchange = __webpack_require__(56974);
;// CONCATENATED MODULE: ./src/utils/trades.ts

// returns whether tradeB is better than tradeA by at least a threshold percentage amount
function isTradeBetter(tradeA, tradeB) {
    var minimumDelta = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : exchange/* ZERO_PERCENT */.fI;
    if (tradeA && !tradeB) return false;
    if (tradeB && !tradeA) return true;
    if (!tradeA || !tradeB) return undefined;
    if (tradeA.tradeType !== tradeB.tradeType || !tradeA.inputAmount.currency.equals(tradeB.inputAmount.currency) || !tradeA.outputAmount.currency.equals(tradeB.outputAmount.currency)) {
        throw new Error("Trades are not comparable");
    }
    if (minimumDelta.equalTo(exchange/* ZERO_PERCENT */.fI)) {
        return tradeA.executionPrice.lessThan(tradeB.executionPrice);
    }
    return tradeA.executionPrice.asFraction.multiply(minimumDelta.add(exchange/* ONE_HUNDRED_PERCENT */.yC)).lessThan(tradeB.executionPrice);
}
/* harmony default export */ var trades = ((/* unused pure expression or super */ null && (isTradeBetter)));

// EXTERNAL MODULE: ./packages/swap-sdk/src/index.ts + 21 modules
var src = __webpack_require__(1505);
// EXTERNAL MODULE: ./node_modules/lodash/flatMap.js
var flatMap = __webpack_require__(94654);
var flatMap_default = /*#__PURE__*/__webpack_require__.n(flatMap);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/hooks/useActiveWeb3React.ts
var useActiveWeb3React = __webpack_require__(97477);
// EXTERNAL MODULE: ./src/state/user/hooks/index.tsx
var hooks = __webpack_require__(921);
// EXTERNAL MODULE: ./src/hooks/usePairs.ts
var usePairs = __webpack_require__(71633);
// EXTERNAL MODULE: ./src/utils/wrappedCurrency.ts
var wrappedCurrency = __webpack_require__(73938);
// EXTERNAL MODULE: ./src/hooks/Tokens.ts
var Tokens = __webpack_require__(41166);
;// CONCATENATED MODULE: ./src/hooks/Trades.ts
/* eslint-disable no-param-reassign */ 











function useAllCommonPairs(currencyA, currencyB) {
    var chainId = (0,useActiveWeb3React/* default */.Z)().chainId;
    var ref = (0,_sliced_to_array/* default */.Z)(chainId ? [
        (0,wrappedCurrency/* wrappedCurrency */.pu)(currencyA, chainId),
        (0,wrappedCurrency/* wrappedCurrency */.pu)(currencyB, chainId)
    ] : [
        undefined,
        undefined
    ], 2), tokenA = ref[0], tokenB = ref[1];
    var bases = (0,react.useMemo)(function() {
        var ref, ref1;
        if (!chainId) return [];
        var _chainId;
        var common = (_chainId = exchange/* BASES_TO_CHECK_TRADES_AGAINST */.lM[chainId]) !== null && _chainId !== void 0 ? _chainId : [];
        var ref2;
        var additionalA = tokenA ? (ref2 = (ref = exchange/* ADDITIONAL_BASES */.ck[chainId]) === null || ref === void 0 ? void 0 : ref[tokenA.address]) !== null && ref2 !== void 0 ? ref2 : [] : [];
        var ref3;
        var additionalB = tokenB ? (ref3 = (ref1 = exchange/* ADDITIONAL_BASES */.ck[chainId]) === null || ref1 === void 0 ? void 0 : ref1[tokenB.address]) !== null && ref3 !== void 0 ? ref3 : [] : [];
        return (0,_to_consumable_array/* default */.Z)(common).concat((0,_to_consumable_array/* default */.Z)(additionalA), (0,_to_consumable_array/* default */.Z)(additionalB));
    }, [
        chainId,
        tokenA,
        tokenB
    ]);
    var basePairs = (0,react.useMemo)(function() {
        return flatMap_default()(bases, function(base) {
            return bases.map(function(otherBase) {
                return [
                    base,
                    otherBase
                ];
            });
        });
    }, [
        bases
    ]);
    var allPairCombinations = (0,react.useMemo)(function() {
        return tokenA && tokenB ? [
            // the direct pair
            [
                tokenA,
                tokenB
            ], 
        ].concat(// token A against all bases
        (0,_to_consumable_array/* default */.Z)(bases.map(function(base) {
            return [
                tokenA,
                base
            ];
        })), // token B against all bases
        (0,_to_consumable_array/* default */.Z)(bases.map(function(base) {
            return [
                tokenB,
                base
            ];
        })), // each base against all bases
        (0,_to_consumable_array/* default */.Z)(basePairs)).filter(function(tokens) {
            return Boolean(tokens[0] && tokens[1]);
        }).filter(function(param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), t0 = _param[0], t1 = _param[1];
            return t0.address !== t1.address;
        }).filter(function(param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), tokenA_ = _param[0], tokenB_ = _param[1];
            if (!chainId) return true;
            var customBases = exchange/* CUSTOM_BASES */.IP[chainId];
            var customBasesA = customBases === null || customBases === void 0 ? void 0 : customBases[tokenA_.address];
            var customBasesB = customBases === null || customBases === void 0 ? void 0 : customBases[tokenB_.address];
            if (!customBasesA && !customBasesB) return true;
            if (customBasesA && !customBasesA.find(function(base) {
                return tokenB_.equals(base);
            })) return false;
            if (customBasesB && !customBasesB.find(function(base) {
                return tokenA_.equals(base);
            })) return false;
            return true;
        }) : [];
    }, [
        tokenA,
        tokenB,
        bases,
        basePairs,
        chainId
    ]);
    var allPairs = (0,usePairs/* usePairs */.z$)(allPairCombinations);
    // only pass along valid pairs, non-duplicated pairs
    return (0,react.useMemo)(function() {
        return Object.values(allPairs// filter out invalid pairs
        .filter(function(result) {
            return Boolean(result[0] === usePairs/* PairState.EXISTS */._G.EXISTS && result[1]);
        })// filter out duplicated pairs
        .reduce(function(memo, param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), curr = _param[1];
            var _address;
            memo[curr.liquidityToken.address] = (_address = memo[curr.liquidityToken.address]) !== null && _address !== void 0 ? _address : curr;
            return memo;
        }, {}));
    }, [
        allPairs
    ]);
}
var MAX_HOPS = 3;
/**
 * Returns the best trade for the exact amount of tokens in to the given token out
 */ function useTradeExactIn(currencyAmountIn, currencyOut) {
    var allowedPairs = useAllCommonPairs(currencyAmountIn === null || currencyAmountIn === void 0 ? void 0 : currencyAmountIn.currency, currencyOut);
    var ref = (0,_sliced_to_array/* default */.Z)((0,hooks/* useUserSingleHopOnly */.RO)(), 1), singleHopOnly = ref[0];
    return (0,react.useMemo)(function() {
        if (currencyAmountIn && currencyOut && allowedPairs.length > 0) {
            if (singleHopOnly) {
                var ref;
                return (ref = src/* Trade.bestTradeExactIn */.ho.bestTradeExactIn(allowedPairs, currencyAmountIn, currencyOut, {
                    maxHops: 1,
                    maxNumResults: 1
                })[0]) !== null && ref !== void 0 ? ref : null;
            }
            // search through trades with varying hops, find best trade out of them
            var bestTradeSoFar = null;
            for(var i = 1; i <= MAX_HOPS; i++){
                var ref1;
                var currentTrade = (ref1 = src/* Trade.bestTradeExactIn */.ho.bestTradeExactIn(allowedPairs, currencyAmountIn, currencyOut, {
                    maxHops: i,
                    maxNumResults: 1
                })[0]) !== null && ref1 !== void 0 ? ref1 : null;
                // if current trade is best yet, save it
                if (isTradeBetter(bestTradeSoFar, currentTrade, exchange/* BETTER_TRADE_LESS_HOPS_THRESHOLD */.Ru)) {
                    bestTradeSoFar = currentTrade;
                }
            }
            return bestTradeSoFar;
        }
        return null;
    }, [
        allowedPairs,
        currencyAmountIn,
        currencyOut,
        singleHopOnly
    ]);
}
/**
 * Returns the best trade for the token in to the exact amount of token out
 */ function useTradeExactOut(currencyIn, currencyAmountOut) {
    var allowedPairs = useAllCommonPairs(currencyIn, currencyAmountOut === null || currencyAmountOut === void 0 ? void 0 : currencyAmountOut.currency);
    var ref = (0,_sliced_to_array/* default */.Z)((0,hooks/* useUserSingleHopOnly */.RO)(), 1), singleHopOnly = ref[0];
    return (0,react.useMemo)(function() {
        if (currencyIn && currencyAmountOut && allowedPairs.length > 0) {
            if (singleHopOnly) {
                var ref;
                return (ref = src/* Trade.bestTradeExactOut */.ho.bestTradeExactOut(allowedPairs, currencyIn, currencyAmountOut, {
                    maxHops: 1,
                    maxNumResults: 1
                })[0]) !== null && ref !== void 0 ? ref : null;
            }
            // search through trades with varying hops, find best trade out of them
            var bestTradeSoFar = null;
            for(var i = 1; i <= MAX_HOPS; i++){
                var ref1;
                var currentTrade = (ref1 = src/* Trade.bestTradeExactOut */.ho.bestTradeExactOut(allowedPairs, currencyIn, currencyAmountOut, {
                    maxHops: i,
                    maxNumResults: 1
                })[0]) !== null && ref1 !== void 0 ? ref1 : null;
                if (isTradeBetter(bestTradeSoFar, currentTrade, exchange/* BETTER_TRADE_LESS_HOPS_THRESHOLD */.Ru)) {
                    bestTradeSoFar = currentTrade;
                }
            }
            return bestTradeSoFar;
        }
        return null;
    }, [
        currencyIn,
        currencyAmountOut,
        allowedPairs,
        singleHopOnly
    ]);
}
function useIsTransactionUnsupported(currencyIn, currencyOut) {
    var unsupportedTokens = (0,Tokens/* useUnsupportedTokens */.l6)();
    var chainId = (0,useActiveWeb3React/* default */.Z)().chainId;
    var tokenIn = (0,wrappedCurrency/* wrappedCurrency */.pu)(currencyIn, chainId);
    var tokenOut = (0,wrappedCurrency/* wrappedCurrency */.pu)(currencyOut, chainId);
    // if unsupported list loaded & either token on list, mark as unsupported
    if (unsupportedTokens) {
        if (tokenIn && Object.keys(unsupportedTokens).includes(tokenIn.address)) {
            return true;
        }
        if (tokenOut && Object.keys(unsupportedTokens).includes(tokenOut.address)) {
            return true;
        }
    }
    return false;
}
function useIsTransactionWarning(currencyIn, currencyOut) {
    var unsupportedTokens = (0,Tokens/* useWarningTokens */.zd)();
    var chainId = (0,useActiveWeb3React/* default */.Z)().chainId;
    var tokenIn = (0,wrappedCurrency/* wrappedCurrency */.pu)(currencyIn, chainId);
    var tokenOut = (0,wrappedCurrency/* wrappedCurrency */.pu)(currencyOut, chainId);
    // if unsupported list loaded & either token on list, mark as unsupported
    if (unsupportedTokens) {
        if (tokenIn && Object.keys(unsupportedTokens).includes(tokenIn.address)) {
            return true;
        }
        if (tokenOut && Object.keys(unsupportedTokens).includes(tokenOut.address)) {
            return true;
        }
    }
    return false;
}


/***/ }),

/***/ 40182:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useHttpLocations; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _pancakeswap_utils_uriToHttp__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4278);


function useHttpLocations(uri) {
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        return uri ? (0,_pancakeswap_utils_uriToHttp__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(uri) : [];
    }, [
        uri
    ]);
}


/***/ }),

/***/ 25840:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "jj": function() { return /* binding */ useDefaultsFromURLSearch; },
  "SM": function() { return /* binding */ useDerivedSwapInfo; },
  "aT": function() { return /* binding */ useLPApr; },
  "yF": function() { return /* binding */ useSingleTokenSwapInfo; },
  "dU": function() { return /* binding */ useSwapState; }
});

// UNUSED EXPORTS: queryParametersToSwapState, useFetchPairPrices

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var src_async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var src_sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./packages/wagmi/src/index.ts + 3 modules
var src = __webpack_require__(29315);
// EXTERNAL MODULE: ./packages/swap-sdk/src/index.ts + 21 modules
var swap_sdk_src = __webpack_require__(1505);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/config/constants/index.ts
var constants = __webpack_require__(42918);
// EXTERNAL MODULE: ./src/config/constants/exchange.ts
var exchange = __webpack_require__(56974);
// EXTERNAL MODULE: ./node_modules/swr/immutable/dist/index.mjs
var dist = __webpack_require__(49770);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./src/hooks/useActiveWeb3React.ts
var useActiveWeb3React = __webpack_require__(97477);
// EXTERNAL MODULE: ./src/hooks/Trades.ts + 1 modules
var Trades = __webpack_require__(94293);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./packages/localization/src/index.tsx + 1 modules
var localization_src = __webpack_require__(68486);
// EXTERNAL MODULE: ./src/utils/index.ts
var utils = __webpack_require__(97119);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/getUnixTime/index.js + 1 modules
var esm_getUnixTime = __webpack_require__(28401);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/startOfMinute/index.js
var startOfMinute = __webpack_require__(18717);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/subDays/index.js
var subDays = __webpack_require__(7069);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/subWeeks/index.js + 1 modules
var subWeeks = __webpack_require__(85899);
;// CONCATENATED MODULE: ./src/utils/getDeltaTimestamps.ts

/**
 * Returns UTC timestamps for 24h ago, 48h ago, 7d ago and 14d ago relative to current date and time
 */ var getDeltaTimestamps_getDeltaTimestamps = function() {
    var utcCurrentTime = (0,esm_getUnixTime/* default */.Z)(new Date()) * 1000;
    var t24h = (0,esm_getUnixTime/* default */.Z)((0,startOfMinute/* default */.Z)((0,subDays/* default */.Z)(utcCurrentTime, 1)));
    var t48h = (0,esm_getUnixTime/* default */.Z)((0,startOfMinute/* default */.Z)((0,subDays/* default */.Z)(utcCurrentTime, 2)));
    var t7d = (0,esm_getUnixTime/* default */.Z)((0,startOfMinute/* default */.Z)((0,subWeeks/* default */.Z)(utcCurrentTime, 1)));
    var t14d = (0,esm_getUnixTime/* default */.Z)((0,startOfMinute/* default */.Z)((0,subWeeks/* default */.Z)(utcCurrentTime, 2)));
    return [
        t24h,
        t48h,
        t7d,
        t14d
    ];
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/graphql-request/build/esm/index.js + 28 modules
var esm = __webpack_require__(66858);
// EXTERNAL MODULE: ./node_modules/lodash/orderBy.js
var orderBy = __webpack_require__(75472);
var orderBy_default = /*#__PURE__*/__webpack_require__.n(orderBy);
// EXTERNAL MODULE: ./src/state/info/constant.ts
var constant = __webpack_require__(56313);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./src/utils/graphql.ts
var graphql = __webpack_require__(61417);
;// CONCATENATED MODULE: ./src/utils/requestWithTimeout.ts
var requestWithTimeout = function(graphQLClient, request, variables) {
    var timeout = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 30000;
    return Promise.race([
        variables ? graphQLClient.request(request, variables) : graphQLClient.request(request),
        new Promise(function(_, reject) {
            setTimeout(function() {
                reject(new Error("Request timed out after ".concat(timeout, " milliseconds")));
            }, timeout);
        }), 
    ]);
};
/* harmony default export */ var utils_requestWithTimeout = (requestWithTimeout);

;// CONCATENATED MODULE: ./src/views/Info/utils/infoQueryHelpers.ts






/**
 * Helper function to get large amount GraphQL subqueries
 * @param queryConstructor constructor function that combines subqueries
 * @param subqueries individual queries
 * @param endpoint GraphQL endpoint
 * @param skipCount how many subqueries to fire at a time
 * @returns
 */ var multiQuery = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(queryConstructor, subqueries, endpoint) {
        var skipCount, fetchedData, allFound, skip, client, end, subqueriesSlice, result, error;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    skipCount = _arguments.length > 3 && _arguments[3] !== void 0 ? _arguments[3] : 1000;
                    fetchedData = {};
                    allFound = false;
                    skip = 0;
                    client = new esm/* GraphQLClient */.g6(endpoint, {
                        headers: (0,graphql/* getGQLHeaders */.vA)(endpoint)
                    });
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    if (!!allFound) return [
                        3,
                        3
                    ];
                    end = subqueries.length;
                    if (skip + skipCount < subqueries.length) {
                        end = skip + skipCount;
                    }
                    subqueriesSlice = subqueries.slice(skip, end);
                    return [
                        4,
                        utils_requestWithTimeout(client, queryConstructor(subqueriesSlice))
                    ];
                case 2:
                    result = _state.sent();
                    fetchedData = (0,_object_spread/* default */.Z)({}, fetchedData, result);
                    allFound = Object.keys(result).length < skipCount || skip + skipCount > subqueries.length;
                    skip += skipCount;
                    return [
                        3,
                        1
                    ];
                case 3:
                    return [
                        2,
                        fetchedData
                    ];
                case 4:
                    error = _state.sent();
                    console.error("Failed to fetch info data", error);
                    return [
                        2,
                        null
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return function multiQuery(queryConstructor, subqueries, endpoint) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./src/utils/getBlocksFromTimestamps.ts



function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "query blocks {\n    ",
        "\n  }"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var getBlockSubqueries = function(timestamps) {
    return timestamps.map(function(timestamp) {
        return "t".concat(timestamp, ":blocks(first: 1, orderBy: timestamp, orderDirection: desc, where: { timestamp_gt: ").concat(timestamp, ", timestamp_lt: ").concat(timestamp + 600, " }) {\n      number\n    }");
    });
};
var blocksQueryConstructor = function(subqueries) {
    return (0,esm/* gql */.Ps)(_templateObject(), subqueries);
};
/**
 * @notice Fetches block objects for an array of timestamps.
 * @param {Array} timestamps
 */ var getBlocksFromTimestamps_getBlocksFromTimestamps = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(timestamps) {
        var sortDirection, skipCount, chainName, fetchedData, blocks, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, key;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    sortDirection = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : "desc", skipCount = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : 500, chainName = _arguments.length > 3 && _arguments[3] !== void 0 ? _arguments[3] : "BSC";
                    if ((timestamps === null || timestamps === void 0 ? void 0 : timestamps.length) === 0) {
                        return [
                            2,
                            []
                        ];
                    }
                    return [
                        4,
                        multiQuery(blocksQueryConstructor, getBlockSubqueries(timestamps), constant/* multiChainBlocksClient */.OO[chainName], skipCount)
                    ];
                case 1:
                    fetchedData = _state.sent();
                    blocks = [];
                    if (fetchedData) {
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            // eslint-disable-next-line no-restricted-syntax
                            for(_iterator = Object.keys(fetchedData)[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                key = _step.value;
                                if (fetchedData[key].length > 0) {
                                    blocks.push({
                                        timestamp: key.split("t")[1],
                                        number: parseInt(fetchedData[key][0].number, 10)
                                    });
                                }
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        // graphql-request does not guarantee same ordering of batched requests subqueries, hence manual sorting
                        return [
                            2,
                            orderBy_default()(blocks, function(block) {
                                return block.number;
                            }, sortDirection)
                        ];
                    }
                    return [
                        2,
                        blocks
                    ];
            }
        });
    });
    return function getBlocksFromTimestamps(timestamps) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./src/views/Info/utils/infoDataHelpers.ts
/**
 * Get increase/decrease of value compared to the previous value (e.g. 24h volume compared to 24h volume the day before )
 * @param valueNow - more recent value
 * @param valueBefore - value to compare with
 */ var infoDataHelpers_getAmountChange = function(valueNow, valueBefore) {
    if (valueNow && valueBefore) {
        return valueNow - valueBefore;
    }
    if (valueNow) {
        return valueNow;
    }
    return 0;
};
/**
 * Get increase/decrease of value compared to the previous value as a percentage
 * @param valueNow - more recent value
 * @param valueBefore - value to compare with
 */ var infoDataHelpers_getPercentChange = function(valueNow, valueBefore) {
    if (valueNow && valueBefore) {
        return (valueNow - valueBefore) / valueBefore * 100;
    }
    return 0;
};

;// CONCATENATED MODULE: ./src/utils/getChangeForPeriod.ts

/**
 * Given current value and value 1 and 2 periods (e.g. 1day + 2days, 1week - 2weeks) returns the amount change for latest period
 * and percentage change compared to the previous period.
 * @param valueNow - current value
 * @param valueOnePeriodAgo - value 1 period ago (e.g. 1 day or 1 week ago), period unit must be same as valueTwoPeriodsAgo
 * @param valueTwoPeriodsAgo - value 2 periods ago (e.g. 2 days or 2 weeks ago), period unit must be same as valueOnePeriodAgo
 * @returns amount change for the latest period and percentage change compared to previous period
 */ var getChangeForPeriod_getChangeForPeriod = function(valueNow, valueOnePeriodAgo, valueTwoPeriodsAgo) {
    var currentPeriodAmount = infoDataHelpers_getAmountChange(valueNow, valueOnePeriodAgo);
    var previousPeriodAmount = infoDataHelpers_getAmountChange(valueOnePeriodAgo, valueTwoPeriodsAgo);
    var percentageChange = infoDataHelpers_getPercentChange(currentPeriodAmount, previousPeriodAmount);
    return [
        currentPeriodAmount,
        percentageChange
    ];
};

// EXTERNAL MODULE: ./src/config/constants/info.ts
var info = __webpack_require__(7269);
;// CONCATENATED MODULE: ./src/utils/getLpFeesAndApr.ts

var getLpFeesAndApr_getLpFeesAndApr = function(volumeUSD, volumeUSDWeek, liquidityUSD) {
    var totalFees24h = volumeUSD * info/* TOTAL_FEE */.om;
    var totalFees7d = volumeUSDWeek * info/* TOTAL_FEE */.om;
    var lpFees24h = volumeUSD * info/* LP_HOLDERS_FEE */.BY;
    var lpFees7d = volumeUSDWeek * info/* LP_HOLDERS_FEE */.BY;
    var lpApr7d = liquidityUSD > 0 ? volumeUSDWeek * info/* LP_HOLDERS_FEE */.BY * info/* WEEKS_IN_YEAR */.MV * 100 / liquidityUSD : 0;
    return {
        totalFees24h: totalFees24h,
        totalFees7d: totalFees7d,
        lpFees24h: lpFees24h,
        lpFees7d: lpFees7d,
        lpApr7d: lpApr7d !== Infinity ? lpApr7d : 0
    };
};

// EXTERNAL MODULE: ./src/hooks/useNativeCurrency.ts
var useNativeCurrency = __webpack_require__(19915);
// EXTERNAL MODULE: ./src/utils/exchange.ts + 1 modules
var utils_exchange = __webpack_require__(17937);
// EXTERNAL MODULE: ./packages/tokens/src/index.ts + 8 modules
var tokens_src = __webpack_require__(30693);
// EXTERNAL MODULE: ./src/utils/getLpAddress.ts
var utils_getLpAddress = __webpack_require__(80462);
;// CONCATENATED MODULE: ./src/views/Swap/components/Chart/constants.ts
// BNB Address
var BNB_ADDRESS = "0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c";


;// CONCATENATED MODULE: ./src/views/Swap/components/Chart/utils.ts

var MIN_VALUE_DISPLAYED = 0.001;
var getTimeWindowChange = function(lineChartData) {
    if (lineChartData.length > 0) {
        var ref;
        var ref1;
        var firstValue = (ref1 = (ref = lineChartData.find(function(param) {
            var value = param.value;
            return !!value && value > 0;
        })) === null || ref === void 0 ? void 0 : ref.value) !== null && ref1 !== void 0 ? ref1 : 0;
        var lastValue = lineChartData[lineChartData.length - 1].value;
        var changeValue = lastValue - firstValue;
        return {
            changeValue: changeValue > 0 ? Math.max(changeValue, MIN_VALUE_DISPLAYED) : Math.min(changeValue, MIN_VALUE_DISPLAYED * -1),
            changePercentage: (changeValue / firstValue * 100).toFixed(2)
        };
    }
    return {
        changeValue: 0,
        changePercentage: 0
    };
};
var getTokenAddress = function(tokenAddress) {
    if (!tokenAddress) {
        return "";
    }
    var lowerCaseAddress = tokenAddress.toLowerCase();
    if (lowerCaseAddress === "bnb") {
        return BNB_ADDRESS;
    }
    return lowerCaseAddress;
};

// EXTERNAL MODULE: ./packages/utils/tryParseAmount.ts
var tryParseAmount = __webpack_require__(68492);
// EXTERNAL MODULE: ./src/state/index.ts + 32 modules
var state = __webpack_require__(106);
// EXTERNAL MODULE: ./src/state/wallet/hooks.ts
var hooks = __webpack_require__(5460);
// EXTERNAL MODULE: ./src/state/swap/actions.ts
var actions = __webpack_require__(15103);
// EXTERNAL MODULE: ./src/state/user/hooks/index.tsx
var user_hooks = __webpack_require__(921);
;// CONCATENATED MODULE: ./src/state/swap/queries/lastPairDayId.ts

function lastPairDayId_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query lastPairDayId($pairId: String) {\n    pairDayDatas(first: 1, where: { pairAddress: $pairId }, orderBy: date, orderDirection: desc) {\n      id\n    }\n  }\n"
    ]);
    lastPairDayId_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var lastPairDayId = (0,esm/* gql */.Ps)(lastPairDayId_templateObject());
/* harmony default export */ var queries_lastPairDayId = (lastPairDayId);

;// CONCATENATED MODULE: ./src/state/swap/queries/pairHourDatas.ts

function pairHourDatas_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query pairHourDatas($pairId: String, $first: Int) {\n    pairHourDatas(first: $first, where: { pair: $pairId }, orderBy: hourStartUnix, orderDirection: desc) {\n      id\n      hourStartUnix\n      reserve0\n      reserve1\n      reserveUSD\n      pair {\n        token0 {\n          id\n        }\n        token1 {\n          id\n        }\n      }\n    }\n  }\n"
    ]);
    pairHourDatas_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var pairHourDatas = (0,esm/* gql */.Ps)(pairHourDatas_templateObject());
/* harmony default export */ var queries_pairHourDatas = (pairHourDatas);

;// CONCATENATED MODULE: ./src/state/swap/queries/pairDayDatasByIdsQuery.ts

function pairDayDatasByIdsQuery_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query pairDayDatasByIdsQuery($pairIds: [String]) {\n    pairDayDatas(where: { id_in: $pairIds }, orderBy: date, orderDirection: desc) {\n      id\n      date\n      reserve0\n      reserve1\n      reserveUSD\n      pairAddress {\n        token0 {\n          id\n        }\n        token1 {\n          id\n        }\n      }\n    }\n  }\n"
    ]);
    pairDayDatasByIdsQuery_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var pairDayDatasByIdsQuery = (0,esm/* gql */.Ps)(pairDayDatasByIdsQuery_templateObject());
/* harmony default export */ var queries_pairDayDatasByIdsQuery = (pairDayDatasByIdsQuery);

;// CONCATENATED MODULE: ./src/state/swap/types.ts
var types_PairDataTimeWindowEnum;
(function(PairDataTimeWindowEnum) {
    PairDataTimeWindowEnum[PairDataTimeWindowEnum["DAY"] = 0] = "DAY";
    PairDataTimeWindowEnum[PairDataTimeWindowEnum["WEEK"] = 1] = "WEEK";
    PairDataTimeWindowEnum[PairDataTimeWindowEnum["MONTH"] = 2] = "MONTH";
    PairDataTimeWindowEnum[PairDataTimeWindowEnum["YEAR"] = 3] = "YEAR";
})(types_PairDataTimeWindowEnum || (types_PairDataTimeWindowEnum = {}));

;// CONCATENATED MODULE: ./src/state/swap/fetch/constants.ts


var _obj;
// Specifies the amount of data points to query for specific time window
var timeWindowIdsCountMapping = (_obj = {}, (0,_define_property/* default */.Z)(_obj, types_PairDataTimeWindowEnum.DAY, 24), (0,_define_property/* default */.Z)(_obj, types_PairDataTimeWindowEnum.WEEK, 28), (0,_define_property/* default */.Z)(_obj, types_PairDataTimeWindowEnum.MONTH, 30), (0,_define_property/* default */.Z)(_obj, types_PairDataTimeWindowEnum.YEAR, 24), _obj);
var _obj1;
// How many StreamingFast ids to skip when querying the data
var timeWindowGapMapping = (_obj1 = {}, (0,_define_property/* default */.Z)(_obj1, types_PairDataTimeWindowEnum.DAY, null), (0,_define_property/* default */.Z)(_obj1, types_PairDataTimeWindowEnum.WEEK, 6), (0,_define_property/* default */.Z)(_obj1, types_PairDataTimeWindowEnum.MONTH, 1), (0,_define_property/* default */.Z)(_obj1, types_PairDataTimeWindowEnum.YEAR, 15), _obj1);

// EXTERNAL MODULE: ./node_modules/lodash/times.js
var times = __webpack_require__(98913);
var times_default = /*#__PURE__*/__webpack_require__.n(times);
;// CONCATENATED MODULE: ./src/state/swap/fetch/utils.ts



var getPairSequentialId = function(param) {
    var id = param.id, pairId = param.pairId;
    return id.replace("".concat(pairId, "-"), "");
};
var getIdsByTimeWindow = function(param) {
    var pairAddress = param.pairAddress, pairLastId = param.pairLastId, timeWindow = param.timeWindow, idsCount = param.idsCount;
    var pairLastIdAsNumber = Number(pairLastId);
    if (timeWindow === types_PairDataTimeWindowEnum.DAY) {
        return [];
    }
    return times_default()(idsCount, function(value) {
        return "".concat(pairAddress, "-").concat(pairLastIdAsNumber - value * timeWindowGapMapping[timeWindow]);
    });
};
var utils_pairHasEnoughLiquidity = function(data, timeWindow) {
    var liquidityThreshold = 10000;
    switch(timeWindow){
        case PairDataTimeWindowEnum.DAY:
        case PairDataTimeWindowEnum.WEEK:
            {
                var ref, ref1;
                var ref2;
                var amountOfDataPoints = (ref2 = data === null || data === void 0 ? void 0 : (ref = data.pairHourDatas) === null || ref === void 0 ? void 0 : ref.length) !== null && ref2 !== void 0 ? ref2 : 1;
                var totalUSD = data === null || data === void 0 ? void 0 : (ref1 = data.pairHourDatas) === null || ref1 === void 0 ? void 0 : ref1.reduce(function(totalLiquidity, fetchPairEntry) {
                    return totalLiquidity + parseFloat(fetchPairEntry.reserveUSD);
                }, 0);
                return totalUSD / amountOfDataPoints > liquidityThreshold;
            }
        case PairDataTimeWindowEnum.MONTH:
        case PairDataTimeWindowEnum.YEAR:
            {
                var ref3, ref4;
                var ref5;
                var amountOfDataPoints1 = (ref5 = data === null || data === void 0 ? void 0 : (ref3 = data.pairDayDatas) === null || ref3 === void 0 ? void 0 : ref3.length) !== null && ref5 !== void 0 ? ref5 : 1;
                var totalUSD1 = data === null || data === void 0 ? void 0 : (ref4 = data.pairDayDatas) === null || ref4 === void 0 ? void 0 : ref4.reduce(function(totalLiquidity, fetchPairEntry) {
                    return totalLiquidity + parseFloat(fetchPairEntry.reserveUSD);
                }, 0);
                return totalUSD1 / amountOfDataPoints1 > liquidityThreshold;
            }
        default:
            return null;
    }
};

;// CONCATENATED MODULE: ./src/state/swap/queries/pairDayDatas.ts

function pairDayDatas_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query pairDayDatas($pairId: String, $first: Int) {\n    pairDayDatas(first: $first, where: { pairAddress: $pairId }, orderBy: date, orderDirection: desc) {\n      id\n      date\n      reserve0\n      reserve1\n      reserveUSD\n      pairAddress {\n        token0 {\n          id\n        }\n        token1 {\n          id\n        }\n      }\n    }\n  }\n"
    ]);
    pairDayDatas_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var pairDayDatas = (0,esm/* gql */.Ps)(pairDayDatas_templateObject());
/* harmony default export */ var queries_pairDayDatas = (pairDayDatas);

;// CONCATENATED MODULE: ./src/state/swap/queries/pairHourDatasByIds.ts

function pairHourDatasByIds_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query pairHourDatasByIds($pairIds: [String]) {\n    pairHourDatas(where: { id_in: $pairIds }, orderBy: hourStartUnix, orderDirection: desc) {\n      id\n      hourStartUnix\n      reserve0\n      reserve1\n      reserveUSD\n      pair {\n        token0 {\n          id\n        }\n        token1 {\n          id\n        }\n      }\n    }\n  }\n"
    ]);
    pairHourDatasByIds_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var pairHourDatasByIds = (0,esm/* gql */.Ps)(pairHourDatasByIds_templateObject());
/* harmony default export */ var queries_pairHourDatasByIds = (pairHourDatasByIds);

;// CONCATENATED MODULE: ./src/state/swap/queries/lastPairHourId.ts

function lastPairHourId_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query lastPairHourId($pairId: String) {\n    pairHourDatas(first: 1, where: { pair: $pairId }, orderBy: hourStartUnix, orderDirection: desc) {\n      id\n    }\n  }\n"
    ]);
    lastPairHourId_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var lastPairHourId = (0,esm/* gql */.Ps)(lastPairHourId_templateObject());
/* harmony default export */ var queries_lastPairHourId = (lastPairHourId);

;// CONCATENATED MODULE: ./src/state/swap/fetch/fetchPairPriceData.ts













var fetchPairPriceData_fetchPairPriceData = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(param) {
        var pairId, timeWindow, client, data, ref, lastPairHourIdData, lastId, pairHourId, pairHourIds, pairHoursData, data1, ref1, lastPairDayIdData, lastId1, pairLastId, pairDayIds, pairDayData, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    pairId = param.pairId, timeWindow = param.timeWindow;
                    client = graphql/* infoClient */.dQ;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        14,
                        ,
                        15
                    ]);
                    switch(timeWindow){
                        case types_PairDataTimeWindowEnum.DAY:
                            return [
                                3,
                                2
                            ];
                        case types_PairDataTimeWindowEnum.WEEK:
                            return [
                                3,
                                4
                            ];
                        case types_PairDataTimeWindowEnum.MONTH:
                            return [
                                3,
                                7
                            ];
                        case types_PairDataTimeWindowEnum.YEAR:
                            return [
                                3,
                                9
                            ];
                    }
                    return [
                        3,
                        12
                    ];
                case 2:
                    return [
                        4,
                        utils_requestWithTimeout(client, queries_pairHourDatas, {
                            pairId: pairId,
                            first: timeWindowIdsCountMapping[timeWindow]
                        })
                    ];
                case 3:
                    data = _state.sent();
                    return [
                        2,
                        {
                            data: data,
                            error: false
                        }
                    ];
                case 4:
                    return [
                        4,
                        utils_requestWithTimeout(client, queries_lastPairHourId, {
                            pairId: pairId
                        })
                    ];
                case 5:
                    lastPairHourIdData = _state.sent();
                    lastId = (lastPairHourIdData === null || lastPairHourIdData === void 0 ? void 0 : lastPairHourIdData.pairHourDatas) ? (ref = lastPairHourIdData.pairHourDatas[0]) === null || ref === void 0 ? void 0 : ref.id : null;
                    if (!lastId) {
                        return [
                            2,
                            {
                                data: {
                                    pairHourDatas: []
                                },
                                error: false
                            }
                        ];
                    }
                    pairHourId = getPairSequentialId({
                        id: lastId,
                        pairId: pairId
                    });
                    pairHourIds = getIdsByTimeWindow({
                        pairAddress: pairId,
                        pairLastId: pairHourId,
                        timeWindow: timeWindow,
                        idsCount: timeWindowIdsCountMapping[timeWindow]
                    });
                    return [
                        4,
                        utils_requestWithTimeout(client, queries_pairHourDatasByIds, {
                            pairIds: pairHourIds
                        })
                    ];
                case 6:
                    pairHoursData = _state.sent();
                    return [
                        2,
                        {
                            data: pairHoursData,
                            error: false
                        }
                    ];
                case 7:
                    return [
                        4,
                        utils_requestWithTimeout(client, queries_pairDayDatas, {
                            pairId: pairId,
                            first: timeWindowIdsCountMapping[timeWindow]
                        })
                    ];
                case 8:
                    data1 = _state.sent();
                    return [
                        2,
                        {
                            data: data1,
                            error: false
                        }
                    ];
                case 9:
                    return [
                        4,
                        utils_requestWithTimeout(client, queries_lastPairDayId, {
                            pairId: pairId
                        })
                    ];
                case 10:
                    lastPairDayIdData = _state.sent();
                    lastId1 = (lastPairDayIdData === null || lastPairDayIdData === void 0 ? void 0 : lastPairDayIdData.pairDayDatas) ? (ref1 = lastPairDayIdData.pairDayDatas[0]) === null || ref1 === void 0 ? void 0 : ref1.id : null;
                    if (!lastId1) {
                        return [
                            2,
                            {
                                data: {
                                    pairDayDatas: []
                                },
                                error: false
                            }
                        ];
                    }
                    pairLastId = getPairSequentialId({
                        id: lastId1,
                        pairId: pairId
                    });
                    pairDayIds = getIdsByTimeWindow({
                        pairAddress: pairId,
                        pairLastId: pairLastId,
                        timeWindow: timeWindow,
                        idsCount: timeWindowIdsCountMapping[timeWindow]
                    });
                    return [
                        4,
                        utils_requestWithTimeout(client, queries_pairDayDatasByIdsQuery, {
                            pairIds: pairDayIds
                        })
                    ];
                case 11:
                    pairDayData = _state.sent();
                    return [
                        2,
                        {
                            data: pairDayData,
                            error: false
                        }
                    ];
                case 12:
                    return [
                        2,
                        {
                            data: null,
                            error: false
                        }
                    ];
                case 13:
                    return [
                        3,
                        15
                    ];
                case 14:
                    error = _state.sent();
                    console.error("Failed to fetch price chart data", error);
                    return [
                        2,
                        {
                            error: true
                        }
                    ];
                case 15:
                    return [
                        2
                    ];
            }
        });
    });
    return function fetchPairPriceData(_) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var fetch_fetchPairPriceData = ((/* unused pure expression or super */ null && (fetchPairPriceData_fetchPairPriceData)));

// EXTERNAL MODULE: ./node_modules/lodash/fromPairs.js
var lodash_fromPairs = __webpack_require__(17204);
var fromPairs_default = /*#__PURE__*/__webpack_require__.n(lodash_fromPairs);
;// CONCATENATED MODULE: ./src/state/swap/normalizers.ts



var normalizers_normalizeChartData = function(data, timeWindow) {
    switch(timeWindow){
        case PairDataTimeWindowEnum.DAY:
        case PairDataTimeWindowEnum.WEEK:
            var ref;
            return data === null || data === void 0 ? void 0 : (ref = data.pairHourDatas) === null || ref === void 0 ? void 0 : ref.map(function(fetchPairEntry) {
                return {
                    time: fetchPairEntry.hourStartUnix,
                    token0Id: fetchPairEntry.pair.token0.id,
                    token1Id: fetchPairEntry.pair.token1.id,
                    reserve0: parseFloat(fetchPairEntry.reserve0),
                    reserve1: parseFloat(fetchPairEntry.reserve1)
                };
            });
        case PairDataTimeWindowEnum.MONTH:
        case PairDataTimeWindowEnum.YEAR:
            var ref1;
            return data === null || data === void 0 ? void 0 : (ref1 = data.pairDayDatas) === null || ref1 === void 0 ? void 0 : ref1.map(function(fetchPairEntry) {
                return {
                    time: fetchPairEntry.date,
                    token0Id: fetchPairEntry.pairAddress.token0.id,
                    token1Id: fetchPairEntry.pairAddress.token1.id,
                    reserve0: parseFloat(fetchPairEntry.reserve0),
                    reserve1: parseFloat(fetchPairEntry.reserve1)
                };
            });
        default:
            return null;
    }
};
var normalizers_normalizeDerivedChartData = function(data) {
    var ref;
    if (!(data === null || data === void 0 ? void 0 : data.token0DerivedBnb) || (data === null || data === void 0 ? void 0 : data.token0DerivedBnb.length) === 0) {
        return [];
    }
    var ref1;
    var token1DerivedBnbEntryMap = fromPairs((ref1 = data === null || data === void 0 ? void 0 : (ref = data.token1DerivedBnb) === null || ref === void 0 ? void 0 : ref.map(function(entry) {
        return [
            entry.timestamp,
            entry
        ];
    })) !== null && ref1 !== void 0 ? ref1 : []);
    return data === null || data === void 0 ? void 0 : data.token0DerivedBnb.reduce(function(acc, token0DerivedBnbEntry) {
        var token1DerivedBnbEntry = token1DerivedBnbEntryMap[token0DerivedBnbEntry.timestamp];
        if (token1DerivedBnbEntry) {
            acc.push({
                time: parseInt(token0DerivedBnbEntry.timestamp, 10),
                token0Id: token0DerivedBnbEntry.tokenAddress,
                token1Id: token1DerivedBnbEntry.tokenAddress,
                token0DerivedBNB: token0DerivedBnbEntry.derivedBNB,
                token1DerivedBNB: token1DerivedBnbEntry.derivedBNB
            });
        }
        return acc;
    }, []);
};
var normalizers_normalizePairDataByActiveToken = function(param) {
    var pairData = param.pairData, activeToken = param.activeToken;
    return pairData === null || pairData === void 0 ? void 0 : pairData.map(function(pairPrice) {
        return {
            time: fromUnixTime(pairPrice.time),
            value: activeToken === (pairPrice === null || pairPrice === void 0 ? void 0 : pairPrice.token0Id) ? pairPrice.reserve1 / pairPrice.reserve0 : pairPrice.reserve0 / pairPrice.reserve1
        };
    }).reverse();
};
var normalizers_normalizeDerivedPairDataByActiveToken = function(param) {
    var pairData = param.pairData, activeToken = param.activeToken;
    return pairData === null || pairData === void 0 ? void 0 : pairData.map(function(pairPrice) {
        return {
            time: fromUnixTime(pairPrice.time),
            value: activeToken === (pairPrice === null || pairPrice === void 0 ? void 0 : pairPrice.token0Id) ? pairPrice.token0DerivedBNB / pairPrice.token1DerivedBNB : pairPrice.token1DerivedBNB / pairPrice.token0DerivedBNB
        };
    });
};

// EXTERNAL MODULE: ./node_modules/lodash/get.js
var lodash_get = __webpack_require__(27361);
;// CONCATENATED MODULE: ./src/state/swap/selectors.ts

var selectors_pairByDataIdSelector = function(param) {
    var pairId = param.pairId, timeWindow = param.timeWindow;
    return function(state) {
        return get(state, [
            "swap",
            "pairDataById",
            pairId,
            timeWindow
        ]);
    };
};
var selectors_derivedPairByDataIdSelector = function(param) {
    var pairId = param.pairId, timeWindow = param.timeWindow;
    return function(state) {
        return get(state, [
            "swap",
            "derivedPairDataById",
            pairId,
            timeWindow
        ]);
    };
};

// EXTERNAL MODULE: ./src/config/constants/endpoints.ts
var endpoints = __webpack_require__(6680);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/startOfHour/index.js
var esm_startOfHour = __webpack_require__(12383);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/sub/index.js + 2 modules
var esm_sub = __webpack_require__(84686);
;// CONCATENATED MODULE: ./src/state/swap/queries/getDerivedPrices.ts

function getDerivedPrices_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      query derivedTokenPriceData {\n        ",
        "\n      }\n    "
    ]);
    getDerivedPrices_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var getDerivedPrices = function(tokenAddress, blocks) {
    return blocks.map(function(block) {
        return "\n    t".concat(block.timestamp, ':token(id:"').concat(tokenAddress, '", block: { number: ').concat(block.number, " }) { \n        derivedBNB\n      }\n    ");
    });
};
var getDerivedPricesQueryConstructor = function(subqueries) {
    return (0,esm/* gql */.Ps)(getDerivedPrices_templateObject(), subqueries);
};

;// CONCATENATED MODULE: ./src/state/swap/fetch/fetchDerivedPriceData.ts











var getTokenDerivedBnbPrices = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(tokenAddress, blocks) {
        var prices, tokenPrices;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        multiQuery(getDerivedPricesQueryConstructor, getDerivedPrices(tokenAddress, blocks), endpoints/* INFO_CLIENT */.JY, 200)
                    ];
                case 1:
                    prices = _state.sent();
                    if (!prices) {
                        console.error("Price data failed to load");
                        return [
                            2,
                            null
                        ];
                    }
                    tokenPrices = [];
                    // Get Token prices in BNB
                    Object.keys(prices).forEach(function(priceKey) {
                        var timestamp = priceKey.split("t")[1];
                        if (timestamp) {
                            var ref;
                            tokenPrices.push({
                                tokenAddress: tokenAddress,
                                timestamp: timestamp,
                                derivedBNB: ((ref = prices[priceKey]) === null || ref === void 0 ? void 0 : ref.derivedBNB) ? parseFloat(prices[priceKey].derivedBNB) : 0
                            });
                        }
                    });
                    return [
                        2,
                        orderBy_default()(tokenPrices, function(tokenPrice) {
                            return parseInt(tokenPrice.timestamp, 10);
                        })
                    ];
            }
        });
    });
    return function getTokenDerivedBnbPrices(tokenAddress, blocks) {
        return _ref.apply(this, arguments);
    };
}();
var getInterval = function(timeWindow) {
    switch(timeWindow){
        case types_PairDataTimeWindowEnum.DAY:
            return info/* ONE_HOUR_SECONDS */.Tb;
        case types_PairDataTimeWindowEnum.WEEK:
            return info/* ONE_HOUR_SECONDS */.Tb * 4;
        case types_PairDataTimeWindowEnum.MONTH:
            return info/* ONE_DAY_UNIX */.Bq;
        case types_PairDataTimeWindowEnum.YEAR:
            return info/* ONE_DAY_UNIX */.Bq * 15;
        default:
            return info/* ONE_HOUR_SECONDS */.Tb * 4;
    }
};
var getSkipDaysToStart = function(timeWindow) {
    switch(timeWindow){
        case types_PairDataTimeWindowEnum.DAY:
            return 1;
        case types_PairDataTimeWindowEnum.WEEK:
            return 7;
        case types_PairDataTimeWindowEnum.MONTH:
            return 30;
        case types_PairDataTimeWindowEnum.YEAR:
            return 365;
        default:
            return 7;
    }
};
// Fetches derivedBnb values for tokens to calculate derived price
// Used when no direct pool is available
var fetchDerivedPriceData_fetchDerivedPriceData = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(token0Address, token1Address, timeWindow) {
        var interval, endTimestamp, startTimestamp, timestamps, time, blocks, ref, token0DerivedBnb, token1DerivedBnb, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    interval = getInterval(timeWindow);
                    endTimestamp = (0,esm_getUnixTime/* default */.Z)(new Date());
                    startTimestamp = (0,esm_getUnixTime/* default */.Z)((0,esm_startOfHour/* default */.Z)((0,esm_sub/* default */.Z)(endTimestamp * 1000, {
                        days: getSkipDaysToStart(timeWindow)
                    })));
                    timestamps = [];
                    time = startTimestamp;
                    while(time <= endTimestamp){
                        timestamps.push(time);
                        time += interval;
                    }
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4,
                        getBlocksFromTimestamps_getBlocksFromTimestamps(timestamps, "asc", 500)
                    ];
                case 2:
                    blocks = _state.sent();
                    if (!blocks || blocks.length === 0) {
                        console.error("Error fetching blocks for timestamps", timestamps);
                        return [
                            2,
                            null
                        ];
                    }
                    return [
                        4,
                        Promise.all([
                            getTokenDerivedBnbPrices(token0Address, blocks),
                            getTokenDerivedBnbPrices(token1Address, blocks)
                        ])
                    ];
                case 3:
                    ref = src_sliced_to_array/* default.apply */.Z.apply(void 0, [
                        _state.sent(),
                        2
                    ]), token0DerivedBnb = ref[0], token1DerivedBnb = ref[1];
                    return [
                        2,
                        {
                            token0DerivedBnb: token0DerivedBnb,
                            token1DerivedBnb: token1DerivedBnb
                        }
                    ];
                case 4:
                    error = _state.sent();
                    console.error("Failed to fetched derived price data for chart", error);
                    return [
                        2,
                        null
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return function fetchDerivedPriceData(token0Address, token1Address, timeWindow) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var fetch_fetchDerivedPriceData = ((/* unused pure expression or super */ null && (fetchDerivedPriceData_fetchDerivedPriceData)));

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
;// CONCATENATED MODULE: ./src/state/info/types.ts
var TransactionType;
(function(TransactionType) {
    TransactionType[TransactionType["SWAP"] = 0] = "SWAP";
    TransactionType[TransactionType["MINT"] = 1] = "MINT";
    TransactionType[TransactionType["BURN"] = 2] = "BURN";
})(TransactionType || (TransactionType = {}));

;// CONCATENATED MODULE: ./src/state/info/queries/helpers.ts







var mapMints = function(mint) {
    return {
        type: TransactionType.MINT,
        hash: mint.id.split("-")[0],
        timestamp: mint.timestamp,
        sender: mint.to,
        token0Symbol: mint.pair.token0.symbol,
        token1Symbol: mint.pair.token1.symbol,
        token0Address: mint.pair.token0.id,
        token1Address: mint.pair.token1.id,
        amountUSD: parseFloat(mint.amountUSD),
        amountToken0: parseFloat(mint.amount0),
        amountToken1: parseFloat(mint.amount1)
    };
};
var mapBurns = function(burn) {
    return {
        type: TransactionType.BURN,
        hash: burn.id.split("-")[0],
        timestamp: burn.timestamp,
        sender: burn.sender,
        token0Symbol: burn.pair.token0.symbol,
        token1Symbol: burn.pair.token1.symbol,
        token0Address: burn.pair.token0.id,
        token1Address: burn.pair.token1.id,
        amountUSD: parseFloat(burn.amountUSD),
        amountToken0: parseFloat(burn.amount0),
        amountToken1: parseFloat(burn.amount1)
    };
};
var mapSwaps = function(swap) {
    return {
        type: TransactionType.SWAP,
        hash: swap.id.split("-")[0],
        timestamp: swap.timestamp,
        sender: swap.from,
        token0Symbol: swap.pair.token0.symbol,
        token1Symbol: swap.pair.token1.symbol,
        token0Address: swap.pair.token0.id,
        token1Address: swap.pair.token1.id,
        amountUSD: parseFloat(swap.amountUSD),
        amountToken0: parseFloat(swap.amount0In) - parseFloat(swap.amount0Out),
        amountToken1: parseFloat(swap.amount1In) - parseFloat(swap.amount1Out)
    };
};
var mapDayData = function(tokenDayData) {
    return {
        date: tokenDayData.date,
        volumeUSD: parseFloat(tokenDayData.dailyVolumeUSD),
        liquidityUSD: parseFloat(tokenDayData.totalLiquidityUSD)
    };
};
var mapPairDayData = function(pairDayData) {
    return {
        date: pairDayData.date,
        volumeUSD: parseFloat(pairDayData.dailyVolumeUSD),
        liquidityUSD: parseFloat(pairDayData.reserveUSD)
    };
};
// Common helper function to retrieve chart data
// Used for both Pool and Token charts
var helpers_fetchChartData = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(chainName, getEntityDayDatas) {
        var chartEntries, error, skip, allFound, ref, data, fetchError, formattedDayDatas, availableDays, firstAvailableDayData, ref1, timestamp, ref2, latestLiquidityUSD, endTimestamp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    chartEntries = [];
                    error = false;
                    skip = 0;
                    allFound = false;
                    _state.label = 1;
                case 1:
                    if (!!allFound) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        getEntityDayDatas(chainName, skip)
                    ];
                case 2:
                    ref = _state.sent(), data = ref.data, fetchError = ref.error;
                    skip += 1000;
                    allFound = (data === null || data === void 0 ? void 0 : data.length) < 1000;
                    error = fetchError;
                    if (data) {
                        chartEntries = chartEntries.concat(data);
                    }
                    return [
                        3,
                        1
                    ];
                case 3:
                    if (error || chartEntries.length === 0) {
                        return [
                            2,
                            {
                                error: true
                            }
                        ];
                    }
                    formattedDayDatas = fromPairs_default()(chartEntries.map(function(dayData) {
                        // At this stage we track unix day ordinal for each data point to check for empty days later
                        var dayOrdinal = parseInt((dayData.date / info/* ONE_DAY_UNIX */.Bq).toFixed(0));
                        return [
                            dayOrdinal,
                            dayData
                        ];
                    }));
                    console.warn(formattedDayDatas);
                    availableDays = Object.keys(formattedDayDatas).map(function(dayOrdinal) {
                        return parseInt(dayOrdinal, 10);
                    });
                    firstAvailableDayData = formattedDayDatas[availableDays[0]];
                    timestamp = (ref1 = firstAvailableDayData === null || firstAvailableDayData === void 0 ? void 0 : firstAvailableDayData.date) !== null && ref1 !== void 0 ? ref1 : constant/* multiChainStartTime */.YM[chainName];
                    latestLiquidityUSD = (ref2 = firstAvailableDayData === null || firstAvailableDayData === void 0 ? void 0 : firstAvailableDayData.liquidityUSD) !== null && ref2 !== void 0 ? ref2 : 0;
                    endTimestamp = (0,esm_getUnixTime/* default */.Z)(new Date());
                    while(timestamp < endTimestamp - info/* ONE_DAY_UNIX */.Bq){
                        timestamp += info/* ONE_DAY_UNIX */.Bq;
                        var dayOrdinal = parseInt((timestamp / info/* ONE_DAY_UNIX */.Bq).toFixed(0), 10);
                        if (!Object.keys(formattedDayDatas).includes(dayOrdinal.toString())) {
                            formattedDayDatas[dayOrdinal] = {
                                date: timestamp,
                                volumeUSD: 0,
                                liquidityUSD: latestLiquidityUSD
                            };
                        } else {
                            latestLiquidityUSD = formattedDayDatas[dayOrdinal].liquidityUSD;
                        }
                    }
                    return [
                        2,
                        {
                            data: Object.values(formattedDayDatas),
                            error: false
                        }
                    ];
            }
        });
    });
    return function fetchChartData(chainName, getEntityDayDatas) {
        return _ref.apply(this, arguments);
    };
}();
var fetchChartDataWithAddress = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(chainName, getEntityDayDatas, address) {
        var chartEntries, error, skip, allFound, ref, data, fetchError, formattedDayDatas, availableDays, firstAvailableDayData, ref1, timestamp, ref2, latestLiquidityUSD, endTimestamp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    chartEntries = [];
                    error = false;
                    skip = 0;
                    allFound = false;
                    _state.label = 1;
                case 1:
                    if (!!allFound) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        getEntityDayDatas(chainName, skip, address)
                    ];
                case 2:
                    ref = _state.sent(), data = ref.data, fetchError = ref.error;
                    skip += 1000;
                    allFound = (data === null || data === void 0 ? void 0 : data.length) < 1000;
                    error = fetchError;
                    if (data) {
                        chartEntries = chartEntries.concat(data);
                    }
                    return [
                        3,
                        1
                    ];
                case 3:
                    if (error || chartEntries.length === 0) {
                        return [
                            2,
                            {
                                error: true
                            }
                        ];
                    }
                    formattedDayDatas = fromPairs_default()(chartEntries.map(function(dayData) {
                        // At this stage we track unix day ordinal for each data point to check for empty days later
                        var dayOrdinal = parseInt((dayData.date / info/* ONE_DAY_UNIX */.Bq).toFixed(0));
                        return [
                            dayOrdinal,
                            dayData
                        ];
                    }));
                    console.warn(formattedDayDatas);
                    availableDays = Object.keys(formattedDayDatas).map(function(dayOrdinal) {
                        return parseInt(dayOrdinal, 10);
                    });
                    firstAvailableDayData = formattedDayDatas[availableDays[0]];
                    timestamp = (ref1 = firstAvailableDayData === null || firstAvailableDayData === void 0 ? void 0 : firstAvailableDayData.date) !== null && ref1 !== void 0 ? ref1 : constant/* multiChainStartTime */.YM[chainName];
                    latestLiquidityUSD = (ref2 = firstAvailableDayData === null || firstAvailableDayData === void 0 ? void 0 : firstAvailableDayData.liquidityUSD) !== null && ref2 !== void 0 ? ref2 : 0;
                    endTimestamp = (0,esm_getUnixTime/* default */.Z)(new Date());
                    while(timestamp < endTimestamp - info/* ONE_DAY_UNIX */.Bq){
                        timestamp += info/* ONE_DAY_UNIX */.Bq;
                        var dayOrdinal = parseInt((timestamp / info/* ONE_DAY_UNIX */.Bq).toFixed(0), 10);
                        if (!Object.keys(formattedDayDatas).includes(dayOrdinal.toString())) {
                            formattedDayDatas[dayOrdinal] = {
                                date: timestamp,
                                volumeUSD: 0,
                                liquidityUSD: latestLiquidityUSD
                            };
                        } else {
                            latestLiquidityUSD = formattedDayDatas[dayOrdinal].liquidityUSD;
                        }
                    }
                    return [
                        2,
                        {
                            data: Object.values(formattedDayDatas),
                            error: false
                        }
                    ];
            }
        });
    });
    return function fetchChartDataWithAddress(chainName, getEntityDayDatas, address) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./src/state/info/queries/pools/chartData.ts



function chartData_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      query pairDayDatas($startTime: Int!, $skip: Int!, $address: Bytes!) {\n        pairDayDatas(\n          first: 1000\n          skip: $skip\n          where: { pairAddress: $address, date_gt: $startTime }\n          orderBy: date\n          orderDirection: asc\n        ) {\n          date\n          dailyVolumeUSD\n          reserveUSD\n        }\n      }\n    "
    ]);
    chartData_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var getPoolChartData = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(chainName, skip, address) {
        var query, pairDayDatas, data, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    query = (0,esm/* gql */.Ps)(chartData_templateObject());
                    return [
                        4,
                        (0,constant/* getMultiChainQueryEndPointWithStableSwap */.rf)(chainName).request(query, {
                            startTime: constant/* multiChainStartTime */.YM[chainName],
                            skip: skip,
                            address: address
                        })
                    ];
                case 1:
                    pairDayDatas = _state.sent().pairDayDatas;
                    data = pairDayDatas.map(mapPairDayData);
                    return [
                        2,
                        {
                            data: data,
                            error: false
                        }
                    ];
                case 2:
                    error = _state.sent();
                    console.error("Failed to fetch pool chart data", error);
                    return [
                        2,
                        {
                            error: true
                        }
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function getPoolChartData(chainName, skip, address) {
        return _ref.apply(this, arguments);
    };
}();
var chartData_fetchPoolChartData = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(chainName, address) {
        return (0,tslib_es6.__generator)(this, function(_state) {
            return [
                2,
                fetchChartDataWithAddress(chainName, getPoolChartData, address)
            ];
        });
    });
    return function fetchPoolChartData(chainName, address) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var chartData = ((/* unused pure expression or super */ null && (chartData_fetchPoolChartData)));

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var src_to_consumable_array = __webpack_require__(36305);
;// CONCATENATED MODULE: ./src/state/info/queries/pools/transactions.ts




function transactions_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query poolTransactions($address: Bytes!) {\n    mints(first: 35, orderBy: timestamp, orderDirection: desc, where: { pair: $address }) {\n      id\n      timestamp\n      pair {\n        token0 {\n          id\n          symbol\n        }\n        token1 {\n          id\n          symbol\n        }\n      }\n      to\n      amount0\n      amount1\n      amountUSD\n    }\n    swaps(first: 35, orderBy: timestamp, orderDirection: desc, where: { pair: $address }) {\n      id\n      timestamp\n      pair {\n        token0 {\n          id\n          symbol\n        }\n        token1 {\n          id\n          symbol\n        }\n      }\n      from\n      amount0In\n      amount1In\n      amount0Out\n      amount1Out\n      amountUSD\n    }\n    burns(first: 35, orderBy: timestamp, orderDirection: desc, where: { pair: $address }) {\n      id\n      timestamp\n      pair {\n        token0 {\n          id\n          symbol\n        }\n        token1 {\n          id\n          symbol\n        }\n      }\n      sender\n      amount0\n      amount1\n      amountUSD\n    }\n  }\n"
    ]);
    transactions_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



/**
 * Transactions of the given pool, used on Pool page
 */ var POOL_TRANSACTIONS = (0,esm/* gql */.Ps)(transactions_templateObject());
var transactions_fetchPoolTransactions = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(chainName, address) {
        var data, mints, burns, swaps, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        (0,constant/* getMultiChainQueryEndPointWithStableSwap */.rf)(chainName).request(POOL_TRANSACTIONS, {
                            address: address
                        })
                    ];
                case 1:
                    data = _state.sent();
                    mints = data.mints.map(mapMints);
                    burns = data.burns.map(mapBurns);
                    swaps = data.swaps.map(mapSwaps);
                    return [
                        2,
                        {
                            data: (0,src_to_consumable_array/* default */.Z)(mints).concat((0,src_to_consumable_array/* default */.Z)(burns), (0,src_to_consumable_array/* default */.Z)(swaps)),
                            error: false
                        }
                    ];
                case 2:
                    error = _state.sent();
                    console.error("Failed to fetch transactions for pool ".concat(address), error);
                    return [
                        2,
                        {
                            error: true
                        }
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function fetchPoolTransactions(chainName, address) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var transactions = ((/* unused pure expression or super */ null && (transactions_fetchPoolTransactions)));

;// CONCATENATED MODULE: ./src/state/info/queries/protocol/chart.ts
/* eslint-disable no-await-in-loop */ 


function chart_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query overviewCharts($startTime: Int!, $skip: Int!) {\n    pancakeDayDatas(first: 1000, skip: $skip, where: { date_gt: $startTime }, orderBy: date, orderDirection: asc) {\n      date\n      dailyVolumeUSD\n      totalLiquidityUSD\n    }\n  }\n"
    ]);
    chart_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





/**
 * Data for displaying Liquidity and Volume charts on Overview page
 */ var PANCAKE_DAY_DATAS = (0,esm/* gql */.Ps)(chart_templateObject());
var getOverviewChartData = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(chainName, skip) {
        var pancakeDayDatas, data, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        (0,constant/* getMultiChainQueryEndPointWithStableSwap */.rf)(chainName).request(PANCAKE_DAY_DATAS, {
                            startTime: constant/* multiChainStartTime */.YM[chainName],
                            skip: skip
                        })
                    ];
                case 1:
                    pancakeDayDatas = _state.sent().pancakeDayDatas;
                    data = pancakeDayDatas.map(mapDayData);
                    return [
                        2,
                        {
                            data: data,
                            error: false
                        }
                    ];
                case 2:
                    error = _state.sent();
                    console.error("Failed to fetch overview chart data", error);
                    return [
                        2,
                        {
                            error: true
                        }
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function getOverviewChartData(chainName, skip) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * Fetch historic chart data
 */ var useFetchGlobalChartData = function() {
    var ref = useState(), overviewChartData = ref[0], setOverviewChartData = ref[1];
    var ref1 = useState(false), error = ref1[0], setError = ref1[1];
    var chainName = useGetChainName();
    useEffect(function() {
        var fetch = function() {
            var _ref = _async_to_generator(function() {
                var data;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                fetchChartData(chainName, getOverviewChartData)
                            ];
                        case 1:
                            data = _state.sent().data;
                            if (data) {
                                setOverviewChartData(data);
                            } else {
                                setError(true);
                            }
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetch() {
                return _ref.apply(this, arguments);
            };
        }();
        if (!overviewChartData && !error) {
            fetch();
        }
    }, [
        overviewChartData,
        error,
        chainName
    ]);
    return {
        error: error,
        data: overviewChartData
    };
};
var chart_fetchGlobalChartData = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(chainName) {
        var data;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        helpers_fetchChartData(chainName, getOverviewChartData)
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function fetchGlobalChartData(chainName) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var chart = ((/* unused pure expression or super */ null && (useFetchGlobalChartData)));

;// CONCATENATED MODULE: ./src/state/info/queries/protocol/overview.ts




function overview_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "query overview {\n      ",
        "(\n        ",
        "\n        first: 1) {\n        totalTransactions\n        totalVolumeUSD\n        totalLiquidityUSD\n      }\n    }"
    ]);
    overview_templateObject = function _templateObject() {
        return data;
    };
    return data;
}








/**
 * Latest Liquidity, Volume and Transaction count
 */ var getOverviewData = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(chainName, block) {
        var factoryString, query, data, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    factoryString = (0,constant/* checkIsStableSwap */.J5)() ? "factories" : "pancakeFactories";
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    query = (0,esm/* gql */.Ps)(overview_templateObject(), factoryString, block ? "block: { number: ".concat(block, "}") : "");
                    return [
                        4,
                        (0,constant/* getMultiChainQueryEndPointWithStableSwap */.rf)(chainName).request(query)
                    ];
                case 2:
                    data = _state.sent();
                    return [
                        2,
                        {
                            data: data,
                            error: false
                        }
                    ];
                case 3:
                    error = _state.sent();
                    console.error("Failed to fetch info overview", error);
                    return [
                        2,
                        {
                            data: null,
                            error: true
                        }
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function getOverviewData(chainName, block) {
        return _ref.apply(this, arguments);
    };
}();
var formatPancakeFactoryResponse = function(rawPancakeFactory) {
    if (rawPancakeFactory) {
        return {
            totalTransactions: parseFloat(rawPancakeFactory.totalTransactions),
            totalVolumeUSD: parseFloat(rawPancakeFactory.totalVolumeUSD),
            totalLiquidityUSD: parseFloat(rawPancakeFactory.totalLiquidityUSD)
        };
    }
    return null;
};
var useFetchProtocolData = function() {
    var ref = useState({
        error: false
    }), fetchState = ref[0], setFetchState = ref[1];
    var ref1 = _sliced_to_array(getDeltaTimestamps(), 2), t24 = ref1[0], t48 = ref1[1];
    var ref2 = useBlocksFromTimestamps([
        t24,
        t48
    ]), blocks = ref2.blocks, blockError = ref2.error;
    var ref3 = _sliced_to_array(blocks !== null && blocks !== void 0 ? blocks : [], 2), block24 = ref3[0], block48 = ref3[1];
    var chainName = useGetChainName();
    useEffect(function() {
        var fetchData = function() {
            var _ref = _async_to_generator(function() {
                var ref, ref1, ref2, ref3, ref4, ref5, ref6, error, data, ref7, error24, data24, ref8, error48, data48, anyError, overviewData, overviewData24, overviewData48, allDataAvailable, ref9, volumeUSD, volumeUSDChange, liquidityUSDChange, ref10, txCount, txCountChange, protocolData;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                Promise.all([
                                    getOverviewData(chainName),
                                    getOverviewData(chainName, (ref3 = block24 === null || block24 === void 0 ? void 0 : block24.number) !== null && ref3 !== void 0 ? ref3 : undefined),
                                    getOverviewData(chainName, (ref4 = block48 === null || block48 === void 0 ? void 0 : block48.number) !== null && ref4 !== void 0 ? ref4 : undefined)
                                ])
                            ];
                        case 1:
                            ref5 = _sliced_to_array.apply(void 0, [
                                _state.sent(),
                                3
                            ]), ref6 = ref5[0], error = ref6.error, data = ref6.data, ref7 = ref5[1], error24 = ref7.error, data24 = ref7.data, ref8 = ref5[2], error48 = ref8.error, data48 = ref8.data;
                            anyError = error || error24 || error48;
                            overviewData = formatPancakeFactoryResponse(data === null || data === void 0 ? void 0 : (ref = data.pancakeFactories) === null || ref === void 0 ? void 0 : ref[0]);
                            overviewData24 = formatPancakeFactoryResponse(data24 === null || data24 === void 0 ? void 0 : (ref1 = data24.pancakeFactories) === null || ref1 === void 0 ? void 0 : ref1[0]);
                            overviewData48 = formatPancakeFactoryResponse(data48 === null || data48 === void 0 ? void 0 : (ref2 = data48.pancakeFactories) === null || ref2 === void 0 ? void 0 : ref2[0]);
                            allDataAvailable = overviewData && overviewData24 && overviewData48;
                            if (anyError || !allDataAvailable) {
                                setFetchState({
                                    error: true
                                });
                            } else {
                                ref9 = _sliced_to_array(getChangeForPeriod(overviewData.totalVolumeUSD, overviewData24.totalVolumeUSD, overviewData48.totalVolumeUSD), 2), volumeUSD = ref9[0], volumeUSDChange = ref9[1];
                                liquidityUSDChange = getPercentChange(overviewData.totalLiquidityUSD, overviewData24.totalLiquidityUSD);
                                ref10 = _sliced_to_array(getChangeForPeriod(overviewData.totalTransactions, overviewData24.totalTransactions, overviewData48.totalTransactions), 2), txCount = ref10[0], txCountChange = ref10[1];
                                protocolData = {
                                    volumeUSD: volumeUSD,
                                    volumeUSDChange: typeof volumeUSDChange === "number" ? volumeUSDChange : 0,
                                    liquidityUSD: overviewData.totalLiquidityUSD,
                                    liquidityUSDChange: liquidityUSDChange,
                                    txCount: txCount,
                                    txCountChange: txCountChange
                                };
                                setFetchState({
                                    error: false,
                                    data: protocolData
                                });
                            }
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetchData() {
                return _ref.apply(this, arguments);
            };
        }();
        var allBlocksAvailable = (block24 === null || block24 === void 0 ? void 0 : block24.number) && (block48 === null || block48 === void 0 ? void 0 : block48.number);
        if (allBlocksAvailable && !blockError && !fetchState.data) {
            fetchData();
        }
    }, [
        block24,
        block48,
        blockError,
        fetchState,
        chainName
    ]);
    return fetchState;
};
var overview_fetchProtocolData = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(chainName, block24, block48) {
        var ref, ref1, ref2, ref3, ref4, ref5, data, ref6, data24, ref7, data48, overviewData, overviewData24, overviewData48, ref8, volumeUSD, volumeUSDChange, liquidityUSDChange, ref9, txCount, txCountChange, protocolData;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        Promise.all([
                            getOverviewData(chainName),
                            getOverviewData(chainName, (ref3 = block24 === null || block24 === void 0 ? void 0 : block24.number) !== null && ref3 !== void 0 ? ref3 : undefined),
                            getOverviewData(chainName, (ref4 = block48 === null || block48 === void 0 ? void 0 : block48.number) !== null && ref4 !== void 0 ? ref4 : undefined)
                        ])
                    ];
                case 1:
                    ref5 = src_sliced_to_array/* default.apply */.Z.apply(void 0, [
                        _state.sent(),
                        3
                    ]), data = ref5[0].data, ref6 = ref5[1], data24 = ref6.data, ref7 = ref5[2], data48 = ref7.data;
                    if (data.factories && data.factories.length > 0) data.pancakeFactories = data.factories;
                    if (data24.factories && data24.factories.length > 0) data24.pancakeFactories = data24.factories;
                    if (data48.factories && data48.factories.length > 0) data48.pancakeFactories = data48.factories;
                    overviewData = formatPancakeFactoryResponse(data === null || data === void 0 ? void 0 : (ref = data.pancakeFactories) === null || ref === void 0 ? void 0 : ref[0]);
                    overviewData24 = formatPancakeFactoryResponse(data24 === null || data24 === void 0 ? void 0 : (ref1 = data24.pancakeFactories) === null || ref1 === void 0 ? void 0 : ref1[0]);
                    overviewData48 = formatPancakeFactoryResponse(data48 === null || data48 === void 0 ? void 0 : (ref2 = data48.pancakeFactories) === null || ref2 === void 0 ? void 0 : ref2[0]);
                    ref8 = (0,src_sliced_to_array/* default */.Z)(getChangeForPeriod_getChangeForPeriod(overviewData.totalVolumeUSD, overviewData24.totalVolumeUSD, overviewData48.totalVolumeUSD), 2), volumeUSD = ref8[0], volumeUSDChange = ref8[1];
                    liquidityUSDChange = infoDataHelpers_getPercentChange(overviewData.totalLiquidityUSD, overviewData24.totalLiquidityUSD);
                    ref9 = (0,src_sliced_to_array/* default */.Z)(getChangeForPeriod_getChangeForPeriod(overviewData.totalTransactions, overviewData24.totalTransactions, overviewData48.totalTransactions), 2), txCount = ref9[0], txCountChange = ref9[1];
                    protocolData = {
                        volumeUSD: volumeUSD,
                        volumeUSDChange: typeof volumeUSDChange === "number" ? volumeUSDChange : 0,
                        liquidityUSD: overviewData.totalLiquidityUSD,
                        liquidityUSDChange: liquidityUSDChange,
                        txCount: txCount,
                        txCountChange: txCountChange
                    };
                    return [
                        2,
                        protocolData
                    ];
            }
        });
    });
    return function fetchProtocolData(chainName, block24, block48) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var overview = ((/* unused pure expression or super */ null && (useFetchProtocolData)));

;// CONCATENATED MODULE: ./src/state/info/queries/protocol/transactions.ts




function protocol_transactions_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query overviewTransactions {\n    mints: mints(first: 33, orderBy: timestamp, orderDirection: desc) {\n      id\n      timestamp\n      pair {\n        token0 {\n          id\n          symbol\n        }\n        token1 {\n          id\n          symbol\n        }\n      }\n      to\n      amount0\n      amount1\n      amountUSD\n    }\n    swaps: swaps(first: 33, orderBy: timestamp, orderDirection: desc) {\n      id\n      timestamp\n      pair {\n        token0 {\n          id\n          symbol\n        }\n        token1 {\n          id\n          symbol\n        }\n      }\n      from\n      amount0In\n      amount1In\n      amount0Out\n      amount1Out\n      amountUSD\n    }\n    burns: burns(first: 33, orderBy: timestamp, orderDirection: desc) {\n      id\n      timestamp\n      pair {\n        token0 {\n          id\n          symbol\n        }\n        token1 {\n          id\n          symbol\n        }\n      }\n      sender\n      amount0\n      amount1\n      amountUSD\n    }\n  }\n"
    ]);
    protocol_transactions_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



/**
 * Transactions for Transaction table on the Home page
 */ var GLOBAL_TRANSACTIONS = (0,esm/* gql */.Ps)(protocol_transactions_templateObject());
var transactions_fetchTopTransactions = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(chainName) {
        var data, mints, burns, swaps, e;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        (0,constant/* getMultiChainQueryEndPointWithStableSwap */.rf)(chainName).request(GLOBAL_TRANSACTIONS)
                    ];
                case 1:
                    data = _state.sent();
                    if (!data) {
                        return [
                            2,
                            undefined
                        ];
                    }
                    mints = data.mints.map(mapMints);
                    burns = data.burns.map(mapBurns);
                    swaps = data.swaps.map(mapSwaps);
                    return [
                        2,
                        (0,src_to_consumable_array/* default */.Z)(mints).concat((0,src_to_consumable_array/* default */.Z)(burns), (0,src_to_consumable_array/* default */.Z)(swaps)).sort(function(a, b) {
                            return parseInt(b.timestamp, 10) - parseInt(a.timestamp, 10);
                        })
                    ];
                case 2:
                    e = _state.sent();
                    return [
                        2,
                        undefined
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function fetchTopTransactions(chainName) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var protocol_transactions = ((/* unused pure expression or super */ null && (transactions_fetchTopTransactions)));

;// CONCATENATED MODULE: ./src/state/info/queries/tokens/chartData.ts



function tokens_chartData_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      query tokenDayDatas($startTime: Int!, $skip: Int!, $address: Bytes!) {\n        tokenDayDatas(\n          first: 1000\n          skip: $skip\n          where: { token: $address, date_gt: $startTime }\n          orderBy: date\n          orderDirection: asc\n        ) {\n          date\n          dailyVolumeUSD\n          totalLiquidityUSD\n        }\n      }\n    "
    ]);
    tokens_chartData_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var getTokenChartData = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(chainName, skip, address) {
        var query, tokenDayDatas, data, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    query = (0,esm/* gql */.Ps)(tokens_chartData_templateObject());
                    return [
                        4,
                        (0,constant/* getMultiChainQueryEndPointWithStableSwap */.rf)(chainName).request(query, {
                            startTime: constant/* multiChainStartTime */.YM[chainName],
                            skip: skip,
                            address: address
                        })
                    ];
                case 1:
                    tokenDayDatas = _state.sent().tokenDayDatas;
                    data = tokenDayDatas.map(mapDayData);
                    return [
                        2,
                        {
                            data: data,
                            error: false
                        }
                    ];
                case 2:
                    error = _state.sent();
                    console.error("Failed to fetch token chart data", error);
                    return [
                        2,
                        {
                            error: true
                        }
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function getTokenChartData(chainName, skip, address) {
        return _ref.apply(this, arguments);
    };
}();
var chartData_fetchTokenChartData = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(chainName, address) {
        return (0,tslib_es6.__generator)(this, function(_state) {
            return [
                2,
                fetchChartDataWithAddress(chainName, getTokenChartData, address)
            ];
        });
    });
    return function fetchTokenChartData(chainName, address) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var tokens_chartData = ((/* unused pure expression or super */ null && (chartData_fetchTokenChartData)));

;// CONCATENATED MODULE: ./src/state/info/queries/tokens/poolsForToken.ts



function poolsForToken_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query poolsForToken($address: Bytes!, $blacklist: [String!]) {\n    asToken0: pairs(\n      first: 15\n      orderBy: trackedReserve",
        "\n      orderDirection: desc\n      where: { totalTransactions_gt: ",
        ", token0: $address, token1_not_in: $blacklist }\n    ) {\n      id\n    }\n    asToken1: pairs(\n      first: 15\n      orderBy: trackedReserve",
        "\n      orderDirection: desc\n      where: { totalTransactions_gt: ",
        ", token1: $address, token0_not_in: $blacklist }\n    ) {\n      id\n    }\n  }\n"
    ]);
    poolsForToken_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



/**
 * Data for showing Pools table on the Token page
 */ var POOLS_FOR_TOKEN = function(chainName) {
    var transactionGT = chainName === "ETH" ? 1 : 100;
    return (0,esm/* gql */.Ps)(poolsForToken_templateObject(), constant/* multiChainQueryMainToken */.WR[chainName], transactionGT, constant/* multiChainQueryMainToken */.WR[chainName], transactionGT);
};
var poolsForToken_fetchPoolsForToken = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(chainName, address) {
        var data, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        (0,constant/* getMultiChainQueryEndPointWithStableSwap */.rf)(chainName).request(POOLS_FOR_TOKEN(chainName), {
                            address: address,
                            blacklist: info/* TOKEN_BLACKLIST */.tE
                        })
                    ];
                case 1:
                    data = _state.sent();
                    return [
                        2,
                        {
                            error: false,
                            addresses: data.asToken0.concat(data.asToken1).map(function(p) {
                                return p.id;
                            })
                        }
                    ];
                case 2:
                    error = _state.sent();
                    console.error("Failed to fetch pools for token ".concat(address), error);
                    return [
                        2,
                        {
                            error: true
                        }
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function fetchPoolsForToken(chainName, address) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var poolsForToken = ((/* unused pure expression or super */ null && (poolsForToken_fetchPoolsForToken)));

;// CONCATENATED MODULE: ./src/state/info/queries/tokens/priceData.ts



function priceData_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query tokenPriceData {\n      ",
        "\n    }\n  "
    ]);
    priceData_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var getPriceSubqueries = function(chainName, tokenAddress, blocks) {
    return blocks.map(function(block) {
        return "\n      t".concat(block.timestamp, ':token(id:"').concat(tokenAddress, '", block: { number: ').concat(block.number, " }) { \n        derived").concat(constant/* multiChainQueryMainToken */.WR[chainName], "\n      }\n      b").concat(block.timestamp, ': bundle(id:"1", block: { number: ').concat(block.number, " }) { \n        ").concat(constant/* multiChainQueryMainToken */.WR[chainName].toLowerCase(), "Price\n      }\n    ");
    });
};
/**
 * Price data for token and bnb based on block number
 */ var priceQueryConstructor = function(subqueries) {
    return (0,esm/* gql */.Ps)(priceData_templateObject(), subqueries);
};
var priceData_fetchTokenPriceData = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(chainName, address, interval, startTimestamp) {
        var endTimestamp, timestamps, time, blocks, prices, tokenPrices, mainToken, sortedTokenPrices, formattedHistory, i, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    endTimestamp = (0,esm_getUnixTime/* default */.Z)(new Date());
                    timestamps = [];
                    time = startTimestamp;
                    while(time <= endTimestamp){
                        timestamps.push(time);
                        time += interval;
                    }
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4,
                        getBlocksFromTimestamps_getBlocksFromTimestamps(timestamps, "asc", 500, chainName)
                    ];
                case 2:
                    blocks = _state.sent();
                    if (!blocks || blocks.length === 0) {
                        console.error("Error fetching blocks for timestamps", timestamps);
                        return [
                            2,
                            {
                                error: false
                            }
                        ];
                    }
                    return [
                        4,
                        multiQuery(priceQueryConstructor, getPriceSubqueries(chainName, address, blocks), constant/* multiChainQueryEndPoint */.Ho[chainName], 200)
                    ];
                case 3:
                    prices = _state.sent();
                    console.warn("fetchTokenPriceData", {
                        chainName: chainName,
                        prices: prices
                    });
                    if (!prices) {
                        console.error("Price data failed to load");
                        return [
                            2,
                            {
                                error: false
                            }
                        ];
                    }
                    tokenPrices = [];
                    mainToken = constant/* multiChainQueryMainToken */.WR[chainName];
                    // Get Token prices in BNB
                    Object.keys(prices).forEach(function(priceKey) {
                        var timestamp = priceKey.split("t")[1];
                        // if its BNB price e.g. `b123` split('t')[1] will be undefined and skip BNB price entry
                        if (timestamp) {
                            var ref;
                            tokenPrices.push({
                                timestamp: timestamp,
                                derivedBNB: ((ref = prices[priceKey]) === null || ref === void 0 ? void 0 : ref["derived".concat(mainToken)]) ? parseFloat(prices[priceKey]["derived".concat(mainToken)]) : 0,
                                priceUSD: 0
                            });
                        }
                    });
                    console.warn("pricesPart1", tokenPrices);
                    // Go through BNB USD prices and calculate Token price based on it
                    Object.keys(prices).forEach(function(priceKey) {
                        var timestamp = priceKey.split("b")[1];
                        // if its Token price e.g. `t123` split('b')[1] will be undefined and skip Token price entry
                        if (timestamp) {
                            var tokenPriceIndex = tokenPrices.findIndex(function(tokenPrice) {
                                return tokenPrice.timestamp === timestamp;
                            });
                            if (tokenPriceIndex >= 0) {
                                var ref;
                                var derivedBNB = tokenPrices[tokenPriceIndex].derivedBNB;
                                var ref1;
                                tokenPrices[tokenPriceIndex].priceUSD = parseFloat((ref1 = (ref = prices[priceKey]) === null || ref === void 0 ? void 0 : ref["".concat(mainToken.toLowerCase(), "Price")]) !== null && ref1 !== void 0 ? ref1 : 0) * derivedBNB;
                            }
                        }
                    });
                    sortedTokenPrices = orderBy_default()(tokenPrices, function(tokenPrice) {
                        return parseInt(tokenPrice.timestamp, 10);
                    });
                    formattedHistory = [];
                    // for each timestamp, construct the open and close price
                    for(i = 0; i < sortedTokenPrices.length - 1; i++){
                        formattedHistory.push({
                            time: parseFloat(sortedTokenPrices[i].timestamp),
                            open: sortedTokenPrices[i].priceUSD,
                            close: sortedTokenPrices[i + 1].priceUSD,
                            high: sortedTokenPrices[i + 1].priceUSD,
                            low: sortedTokenPrices[i].priceUSD
                        });
                    }
                    return [
                        2,
                        {
                            data: formattedHistory,
                            error: false
                        }
                    ];
                case 4:
                    error = _state.sent();
                    console.error("Failed to fetch price data for token ".concat(address), error);
                    return [
                        2,
                        {
                            error: true
                        }
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return function fetchTokenPriceData(chainName, address, interval, startTimestamp) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var priceData = ((/* unused pure expression or super */ null && (priceData_fetchTokenPriceData)));

;// CONCATENATED MODULE: ./src/state/info/queries/tokens/topTokens.ts




function topTokens_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      query topTokens($blacklist: [String!]) {\n        tokenDayDatas(\n          first: ",
        "\n          ",
        "\n          orderBy: dailyVolumeUSD\n          orderDirection: desc\n        ) {\n          id\n        }\n      }\n    "
    ]);
    topTokens_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





/**
 * Tokens to display on Home page
 * The actual data is later requested in tokenData.ts
 * Note: dailyTxns_gt: 300 is there to prevent fetching incorrectly priced tokens with high dailyVolumeUSD
 */ var fetchTopTokens = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(chainName, timestamp24hAgo) {
        var whereCondition, firstCount, query, data, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    whereCondition = chainName === "ETH" ? "where: { date_gt: ".concat(timestamp24hAgo, ", token_not_in: $blacklist, dailyVolumeUSD_gt:2000 }") : (0,constant/* checkIsStableSwap */.J5)() ? "" : "where: { dailyTxns_gt: 300, id_not_in: $blacklist, date_gt: ".concat(timestamp24hAgo, "}");
                    firstCount = 30;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    query = (0,esm/* gql */.Ps)(topTokens_templateObject(), firstCount, whereCondition);
                    return [
                        4,
                        (0,constant/* getMultiChainQueryEndPointWithStableSwap */.rf)(chainName).request(query, {
                            blacklist: constant/* multiChainTokenBlackList */.z2[chainName]
                        })
                    ];
                case 2:
                    data = _state.sent();
                    // tokenDayDatas id has compound id "0xTOKENADDRESS-NUMBERS", extracting token address with .split('-')
                    return [
                        2,
                        data.tokenDayDatas.map(function(t) {
                            return t.id.split("-")[0];
                        })
                    ];
                case 3:
                    error = _state.sent();
                    console.warn("fetchTopTokens", {
                        chainName: chainName,
                        timestamp24hAgo: timestamp24hAgo
                    });
                    console.error("Failed to fetch top tokens", error);
                    return [
                        2,
                        []
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function fetchTopTokens(chainName, timestamp24hAgo) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * Fetch top addresses by volume
 */ var useTopTokenAddresses = function() {
    var ref = useState([]), topTokenAddresses = ref[0], setTopTokenAddresses = ref[1];
    var ref1 = _sliced_to_array(getDeltaTimestamps(), 1), timestamp24hAgo = ref1[0];
    var chainName = useGetChainName();
    var fetch = useCallback(/*#__PURE__*/ _async_to_generator(function() {
        var addresses;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        fetchTopTokens(chainName, timestamp24hAgo)
                    ];
                case 1:
                    addresses = _state.sent();
                    if (addresses.length > 0) setTopTokenAddresses(addresses);
                    return [
                        2
                    ];
            }
        });
    }), [
        timestamp24hAgo,
        chainName
    ]);
    useEffect(function() {
        fetch();
    }, [
        chainName,
        fetch
    ]);
    return topTokenAddresses;
};
var fetchTokenAddresses = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(chainName) {
        var ref, timestamp24hAgo, addresses;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ref = (0,src_sliced_to_array/* default */.Z)(getDeltaTimestamps_getDeltaTimestamps(), 1), timestamp24hAgo = ref[0];
                    return [
                        4,
                        fetchTopTokens(chainName, timestamp24hAgo)
                    ];
                case 1:
                    addresses = _state.sent();
                    return [
                        2,
                        addresses
                    ];
            }
        });
    });
    return function fetchTokenAddresses(chainName) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var topTokens = ((/* unused pure expression or super */ null && (useTopTokenAddresses)));

;// CONCATENATED MODULE: ./src/state/info/queries/tokens/tokenData.ts
/* eslint-disable no-param-reassign */ 





function tokenData_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      query tokens {\n        now: ",
        "\n        oneDayAgo: ",
        "\n        twoDaysAgo: ",
        "\n        oneWeekAgo: ",
        "\n        ",
        "\n      }\n    "
    ]);
    tokenData_templateObject = function _templateObject() {
        return data;
    };
    return data;
}








/**
 * Main token data to display on Token page
 */ var TOKEN_AT_BLOCK = function(chainName, block, tokens) {
    var addressesString = '["'.concat(tokens.join('","'), '"]');
    var blockString = block ? "block: {number: ".concat(block, "}") : "";
    return "tokens(\n      where: {id_in: ".concat(addressesString, "}\n      ").concat(blockString, "\n      orderBy: tradeVolumeUSD\n      orderDirection: desc\n    ) {\n      id\n      symbol\n      name\n      derived").concat(constant/* multiChainQueryMainToken */.WR[chainName], "\n      derivedUSD\n      tradeVolumeUSD\n      totalTransactions\n      totalLiquidity\n    }\n  ");
};
var fetchTokenData = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(chainName, block24h, block48h, block7d, block14d, tokenAddresses) {
        var weeksQuery, query, data, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    weeksQuery = chainName === "BSC" ? "twoWeeksAgo: ".concat(TOKEN_AT_BLOCK(chainName, block14d, tokenAddresses)) : "";
                    query = (0,esm/* gql */.Ps)(tokenData_templateObject(), TOKEN_AT_BLOCK(chainName, null, tokenAddresses), TOKEN_AT_BLOCK(chainName, block24h, tokenAddresses), TOKEN_AT_BLOCK(chainName, block48h, tokenAddresses), TOKEN_AT_BLOCK(chainName, block7d, tokenAddresses), weeksQuery);
                    return [
                        4,
                        (0,constant/* getMultiChainQueryEndPointWithStableSwap */.rf)(chainName).request(query)
                    ];
                case 1:
                    data = _state.sent();
                    return [
                        2,
                        {
                            data: data,
                            error: false
                        }
                    ];
                case 2:
                    error = _state.sent();
                    console.error("Failed to fetch token data", error);
                    return [
                        2,
                        {
                            error: true
                        }
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function fetchTokenData(chainName, block24h, block48h, block7d, block14d, tokenAddresses) {
        return _ref.apply(this, arguments);
    };
}();
// Transforms tokens into "0xADDRESS: { ...TokenFields }" format and cast strings to numbers
var parseTokenData = function(tokens) {
    if (!tokens) {
        return {};
    }
    return tokens.reduce(function(accum, tokenData) {
        var derivedBNB = tokenData.derivedBNB, derivedUSD = tokenData.derivedUSD, tradeVolumeUSD = tokenData.tradeVolumeUSD, totalTransactions = tokenData.totalTransactions, totalLiquidity = tokenData.totalLiquidity, derivedETH = tokenData.derivedETH;
        accum[tokenData.id] = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, tokenData), {
            derivedBNB: derivedBNB ? 0 : parseFloat(derivedBNB),
            derivedETH: derivedETH ? 0 : parseFloat(derivedETH),
            derivedUSD: parseFloat(derivedUSD),
            tradeVolumeUSD: parseFloat(tradeVolumeUSD),
            totalTransactions: parseFloat(totalTransactions),
            totalLiquidity: parseFloat(totalLiquidity)
        });
        return accum;
    }, {});
};
/**
 * Fetch top addresses by volume
 */ var useFetchedTokenDatas = function(chainName, tokenAddresses) {
    var ref = useState({
        error: false
    }), fetchState = ref[0], setFetchState = ref[1];
    var ref1 = _sliced_to_array(getDeltaTimestamps(), 4), t24h = ref1[0], t48h = ref1[1], t7d = ref1[2], t14d = ref1[3];
    var ref2 = useBlocksFromTimestamps([
        t24h,
        t48h,
        t7d,
        t14d
    ]), blocks = ref2.blocks, blockError = ref2.error;
    var ref3 = _sliced_to_array(blocks !== null && blocks !== void 0 ? blocks : [], 4), block24h = ref3[0], block48h = ref3[1], block7d = ref3[2], block14d = ref3[3];
    useEffect(function() {
        var fetch = function() {
            var _ref = _async_to_generator(function() {
                var ref, error, data, parsed, parsed24, parsed48, parsed7d, parsed14d, formatted;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                fetchTokenData(chainName, block24h.number, block48h.number, block7d.number, block14d.number, tokenAddresses)
                            ];
                        case 1:
                            ref = _state.sent(), error = ref.error, data = ref.data;
                            if (error) {
                                setFetchState({
                                    error: true
                                });
                            } else {
                                parsed = parseTokenData(data === null || data === void 0 ? void 0 : data.now);
                                parsed24 = parseTokenData(data === null || data === void 0 ? void 0 : data.oneDayAgo);
                                parsed48 = parseTokenData(data === null || data === void 0 ? void 0 : data.twoDaysAgo);
                                parsed7d = parseTokenData(data === null || data === void 0 ? void 0 : data.oneWeekAgo);
                                parsed14d = parseTokenData(data === null || data === void 0 ? void 0 : data.twoWeeksAgo);
                                formatted = tokenAddresses.reduce(function(accum, address) {
                                    var current = parsed[address];
                                    var oneDay = parsed24[address];
                                    var twoDays = parsed48[address];
                                    var week = parsed7d[address];
                                    var twoWeeks = parsed14d[address];
                                    var ref = _sliced_to_array(getChangeForPeriod(current === null || current === void 0 ? void 0 : current.tradeVolumeUSD, oneDay === null || oneDay === void 0 ? void 0 : oneDay.tradeVolumeUSD, twoDays === null || twoDays === void 0 ? void 0 : twoDays.tradeVolumeUSD), 2), volumeUSD = ref[0], volumeUSDChange = ref[1];
                                    var ref1 = _sliced_to_array(getChangeForPeriod(current === null || current === void 0 ? void 0 : current.tradeVolumeUSD, week === null || week === void 0 ? void 0 : week.tradeVolumeUSD, twoWeeks === null || twoWeeks === void 0 ? void 0 : twoWeeks.tradeVolumeUSD), 1), volumeUSDWeek = ref1[0];
                                    var liquidityUSD = current ? current.totalLiquidity * current.derivedUSD : 0;
                                    var liquidityUSDOneDayAgo = oneDay ? oneDay.totalLiquidity * oneDay.derivedUSD : 0;
                                    var liquidityUSDChange = getPercentChange(liquidityUSD, liquidityUSDOneDayAgo);
                                    var liquidityToken = current ? current.totalLiquidity : 0;
                                    // Prices of tokens for now, 24h ago and 7d ago
                                    var priceUSD = current ? current.derivedUSD : 0;
                                    var priceUSDOneDay = oneDay ? oneDay.derivedUSD : 0;
                                    var priceUSDWeek = week ? week.derivedUSD : 0;
                                    var priceUSDChange = getPercentChange(priceUSD, priceUSDOneDay);
                                    var priceUSDChangeWeek = getPercentChange(priceUSD, priceUSDWeek);
                                    var txCount = getAmountChange(current === null || current === void 0 ? void 0 : current.totalTransactions, oneDay === null || oneDay === void 0 ? void 0 : oneDay.totalTransactions);
                                    accum[address] = {
                                        exists: !!current,
                                        address: address,
                                        name: current ? current.name : "",
                                        symbol: current ? current.symbol : "",
                                        volumeUSD: volumeUSD,
                                        volumeUSDChange: volumeUSDChange,
                                        volumeUSDWeek: volumeUSDWeek,
                                        txCount: txCount,
                                        liquidityUSD: liquidityUSD,
                                        liquidityUSDChange: liquidityUSDChange,
                                        liquidityToken: liquidityToken,
                                        priceUSD: priceUSD,
                                        priceUSDChange: priceUSDChange,
                                        priceUSDChangeWeek: priceUSDChangeWeek
                                    };
                                    return accum;
                                }, {});
                                setFetchState({
                                    data: formatted,
                                    error: false
                                });
                            }
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetch() {
                return _ref.apply(this, arguments);
            };
        }();
        var allBlocksAvailable = (block24h === null || block24h === void 0 ? void 0 : block24h.number) && (block48h === null || block48h === void 0 ? void 0 : block48h.number) && (block7d === null || block7d === void 0 ? void 0 : block7d.number) && (block14d === null || block14d === void 0 ? void 0 : block14d.number);
        if (tokenAddresses.length > 0 && allBlocksAvailable && !blockError) {
            fetch();
        }
    }, [
        tokenAddresses,
        block24h,
        block48h,
        block7d,
        block14d,
        blockError,
        chainName
    ]);
    return fetchState;
};
var tokenData_fetchAllTokenDataByAddresses = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(chainName, blocks, tokenAddresses) {
        var ref, block24h, block48h, block7d, block14d, data, parsed, parsed24, parsed48, parsed7d, parsed14d, formatted;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ref = (0,src_sliced_to_array/* default */.Z)(blocks !== null && blocks !== void 0 ? blocks : [], 4), block24h = ref[0], block48h = ref[1], block7d = ref[2], block14d = ref[3];
                    return [
                        4,
                        fetchTokenData(chainName, block24h.number, block48h.number, block7d.number, block14d.number, tokenAddresses)
                    ];
                case 1:
                    data = _state.sent().data;
                    parsed = parseTokenData(data === null || data === void 0 ? void 0 : data.now);
                    parsed24 = parseTokenData(data === null || data === void 0 ? void 0 : data.oneDayAgo);
                    parsed48 = parseTokenData(data === null || data === void 0 ? void 0 : data.twoDaysAgo);
                    parsed7d = parseTokenData(data === null || data === void 0 ? void 0 : data.oneWeekAgo);
                    parsed14d = parseTokenData(data === null || data === void 0 ? void 0 : data.twoWeeksAgo);
                    formatted = tokenAddresses.reduce(function(accum, address) {
                        var current = parsed[address];
                        var oneDay = parsed24[address];
                        var twoDays = parsed48[address];
                        var week = parsed7d[address];
                        var twoWeeks = parsed14d[address];
                        var ref = (0,src_sliced_to_array/* default */.Z)(getChangeForPeriod_getChangeForPeriod(current === null || current === void 0 ? void 0 : current.tradeVolumeUSD, oneDay === null || oneDay === void 0 ? void 0 : oneDay.tradeVolumeUSD, twoDays === null || twoDays === void 0 ? void 0 : twoDays.tradeVolumeUSD), 2), volumeUSD = ref[0], volumeUSDChange = ref[1];
                        var ref1 = (0,src_sliced_to_array/* default */.Z)(getChangeForPeriod_getChangeForPeriod(current === null || current === void 0 ? void 0 : current.tradeVolumeUSD, week === null || week === void 0 ? void 0 : week.tradeVolumeUSD, twoWeeks === null || twoWeeks === void 0 ? void 0 : twoWeeks.tradeVolumeUSD), 1), volumeUSDWeek = ref1[0];
                        var liquidityUSD = current ? current.totalLiquidity * current.derivedUSD : 0;
                        var liquidityUSDOneDayAgo = oneDay ? oneDay.totalLiquidity * oneDay.derivedUSD : 0;
                        var liquidityUSDChange = infoDataHelpers_getPercentChange(liquidityUSD, liquidityUSDOneDayAgo);
                        var liquidityToken = current ? current.totalLiquidity : 0;
                        // Prices of tokens for now, 24h ago and 7d ago
                        var priceUSD = current ? current.derivedUSD : 0;
                        var priceUSDOneDay = oneDay ? oneDay.derivedUSD : 0;
                        var priceUSDWeek = week ? week.derivedUSD : 0;
                        var priceUSDChange = infoDataHelpers_getPercentChange(priceUSD, priceUSDOneDay);
                        var priceUSDChangeWeek = infoDataHelpers_getPercentChange(priceUSD, priceUSDWeek);
                        var txCount = infoDataHelpers_getAmountChange(current === null || current === void 0 ? void 0 : current.totalTransactions, oneDay === null || oneDay === void 0 ? void 0 : oneDay.totalTransactions);
                        accum[address] = {
                            data: {
                                exists: !!current,
                                address: address,
                                name: current ? current.name : "",
                                symbol: current ? current.symbol : "",
                                volumeUSD: volumeUSD,
                                volumeUSDChange: volumeUSDChange,
                                volumeUSDWeek: volumeUSDWeek,
                                txCount: txCount,
                                liquidityUSD: liquidityUSD,
                                liquidityUSDChange: liquidityUSDChange,
                                liquidityToken: liquidityToken,
                                priceUSD: priceUSD,
                                priceUSDChange: priceUSDChange,
                                priceUSDChangeWeek: priceUSDChangeWeek
                            }
                        };
                        return accum;
                    }, {});
                    return [
                        2,
                        formatted
                    ];
            }
        });
    });
    return function fetchAllTokenDataByAddresses(chainName, blocks, tokenAddresses) {
        return _ref.apply(this, arguments);
    };
}();
var tokenData_fetchAllTokenData = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(chainName, blocks) {
        var tokenAddresses, data;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        fetchTokenAddresses(chainName)
                    ];
                case 1:
                    tokenAddresses = _state.sent();
                    return [
                        4,
                        tokenData_fetchAllTokenDataByAddresses(chainName, blocks, tokenAddresses)
                    ];
                case 2:
                    data = _state.sent();
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function fetchAllTokenData(chainName, blocks) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var tokenData = ((/* unused pure expression or super */ null && (useFetchedTokenDatas)));

;// CONCATENATED MODULE: ./src/state/info/queries/tokens/transactions.ts




function tokens_transactions_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query tokenTransactions($address: Bytes!) {\n      mintsAs0: mints(first: 10, orderBy: timestamp, orderDirection: desc, where: { ",
        " }) {\n        id\n        timestamp\n        pair {\n          token0 {\n            id\n            symbol\n          }\n          token1 {\n            id\n            symbol\n          }\n        }\n        to\n        amount0\n        amount1\n        amountUSD\n      }\n      mintsAs1: mints(first: 10, orderBy: timestamp, orderDirection: desc, where: { ",
        " }) {\n        id\n        timestamp\n        pair {\n          token0 {\n            id\n            symbol\n          }\n          token1 {\n            id\n            symbol\n          }\n        }\n        to\n        amount0\n        amount1\n        amountUSD\n      }\n      swapsAs0: swaps(first: 10, orderBy: timestamp, orderDirection: desc, where: { ",
        " }) {\n        id\n        timestamp\n        pair {\n          token0 {\n            id\n            symbol\n          }\n          token1 {\n            id\n            symbol\n          }\n        }\n        from\n        amount0In\n        amount1In\n        amount0Out\n        amount1Out\n        amountUSD\n      }\n      swapsAs1: swaps(first: 10, orderBy: timestamp, orderDirection: desc, where: { ",
        " }) {\n        id\n        timestamp\n        pair {\n          token0 {\n            id\n            symbol\n          }\n          token1 {\n            id\n            symbol\n          }\n        }\n        from\n        amount0In\n        amount1In\n        amount0Out\n        amount1Out\n        amountUSD\n      }\n      burnsAs0: burns(first: 10, orderBy: timestamp, orderDirection: desc, where: { ",
        " }) {\n        id\n        timestamp\n        pair {\n          token0 {\n            id\n            symbol\n          }\n          token1 {\n            id\n            symbol\n          }\n        }\n        sender\n        amount0\n        amount1\n        amountUSD\n      }\n      burnsAs1: burns(first: 10, orderBy: timestamp, orderDirection: desc, where: { ",
        " }) {\n        id\n        timestamp\n        pair {\n          token0 {\n            id\n            symbol\n          }\n          token1 {\n            id\n            symbol\n          }\n        }\n        sender\n        amount0\n        amount1\n        amountUSD\n      }\n    }\n  "
    ]);
    tokens_transactions_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



/**
 * Data to display transaction table on Token page
 */ var TOKEN_TRANSACTIONS = function() {
    var isStableSwap = (0,constant/* checkIsStableSwap */.J5)();
    var whereToken0 = isStableSwap ? "pair_: {token0: $address}" : "token0: $address";
    var whereToken1 = isStableSwap ? "pair_: {token1: $address}" : "token1: $address";
    return (0,esm/* gql */.Ps)(tokens_transactions_templateObject(), whereToken0, whereToken1, whereToken0, whereToken1, whereToken0, whereToken1);
};
var transactions_fetchTokenTransactions = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(chainName, address) {
        var data, mints0, mints1, burns0, burns1, swaps0, swaps1, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        (0,constant/* getMultiChainQueryEndPointWithStableSwap */.rf)(chainName).request(TOKEN_TRANSACTIONS(), {
                            address: address
                        })
                    ];
                case 1:
                    data = _state.sent();
                    mints0 = data.mintsAs0.map(mapMints);
                    mints1 = data.mintsAs1.map(mapMints);
                    burns0 = data.burnsAs0.map(mapBurns);
                    burns1 = data.burnsAs1.map(mapBurns);
                    swaps0 = data.swapsAs0.map(mapSwaps);
                    swaps1 = data.swapsAs1.map(mapSwaps);
                    return [
                        2,
                        {
                            data: (0,src_to_consumable_array/* default */.Z)(mints0).concat((0,src_to_consumable_array/* default */.Z)(mints1), (0,src_to_consumable_array/* default */.Z)(burns0), (0,src_to_consumable_array/* default */.Z)(burns1), (0,src_to_consumable_array/* default */.Z)(swaps0), (0,src_to_consumable_array/* default */.Z)(swaps1)),
                            error: false
                        }
                    ];
                case 2:
                    error = _state.sent();
                    console.error("Failed to fetch transactions for token ".concat(address), error);
                    return [
                        2,
                        {
                            error: true
                        }
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function fetchTokenTransactions(chainName, address) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var tokens_transactions = ((/* unused pure expression or super */ null && (transactions_fetchTokenTransactions)));

;// CONCATENATED MODULE: ./src/state/info/hooks.ts



















// Protocol hooks
var refreshIntervalForInfo = 15000 // 10s
;
var SWR_SETTINGS = {
    refreshInterval: refreshIntervalForInfo
};
var useProtocolDataSWR = function() {
    var chainName = hooks_useGetChainName();
    var ref = _sliced_to_array(getDeltaTimestamps(), 2), t24 = ref[0], t48 = ref[1];
    var blocks = useBlockFromTimeStampSWR([
        t24,
        t48
    ]).blocks;
    var ref1 = _sliced_to_array(blocks !== null && blocks !== void 0 ? blocks : [], 2), block24 = ref1[0], block48 = ref1[1];
    var type = checkIsStableSwap() ? "stableSwap" : "swap";
    var ref2 = useSWRImmutable(chainName && block24 && block48 ? [
        "info/protocol/updateProtocolData/".concat(type),
        chainName
    ] : null, function() {
        return fetchProtocolData(chainName, block24, block48);
    }, SWR_SETTINGS), protocolData = ref2.data;
    return protocolData !== null && protocolData !== void 0 ? protocolData : undefined;
};
var useProtocolChartDataSWR = function() {
    var chainName = hooks_useGetChainName();
    var type = checkIsStableSwap() ? "stableSwap" : "swap";
    var ref = useSWRImmutable([
        "info/protocol/updateProtocolChartData/".concat(type),
        chainName
    ], function() {
        return fetchGlobalChartData(chainName);
    }, SWR_SETTINGS), chartData = ref.data;
    return chartData !== null && chartData !== void 0 ? chartData : undefined;
};
var useProtocolTransactionsSWR = function() {
    var chainName = hooks_useGetChainName();
    var type = checkIsStableSwap() ? "stableSwap" : "swap";
    var ref = useSWRImmutable([
        "info/protocol/updateProtocolTransactionsData/".concat(type),
        chainName
    ], function() {
        return fetchTopTransactions(chainName);
    }, SWR_SETTINGS), transactions = ref.data;
    return transactions !== null && transactions !== void 0 ? transactions : undefined;
};
var useAllPoolDataSWR = function() {
    var chainName = hooks_useGetChainName();
    var ref = _sliced_to_array(getDeltaTimestamps(), 4), t24h = ref[0], t48h = ref[1], t7d = ref[2], t14d = ref[3];
    var blocks = useBlockFromTimeStampSWR([
        t24h,
        t48h,
        t7d,
        t14d
    ]).blocks;
    var type = checkIsStableSwap() ? "stableSwap" : "swap";
    var data = useSWRImmutable(blocks && chainName && [
        "info/pools/data/".concat(type),
        chainName
    ], function() {
        return fetchAllPoolData(blocks, chainName);
    }, SWR_SETTINGS).data;
    return data !== null && data !== void 0 ? data : {};
};
var usePoolDatasSWR = function(poolAddresses) {
    var name = poolAddresses.join("");
    var chainName = hooks_useGetChainName();
    var ref = _sliced_to_array(getDeltaTimestamps(), 4), t24h = ref[0], t48h = ref[1], t7d = ref[2], t14d = ref[3];
    var blocks = useBlockFromTimeStampSWR([
        t24h,
        t48h,
        t7d,
        t14d
    ]).blocks;
    var data = useSWRImmutable(blocks && chainName && [
        "info/pool/data/".concat(name),
        chainName
    ], function() {
        return fetchAllPoolDataWithAddress(blocks, chainName, poolAddresses);
    }, SWR_SETTINGS).data;
    var poolsWithData = poolAddresses.map(function(address) {
        var ref;
        return data === null || data === void 0 ? void 0 : (ref = data[address]) === null || ref === void 0 ? void 0 : ref.data;
    }).filter(function(pool) {
        return pool;
    });
    return poolsWithData;
};
var usePoolChartDataSWR = function(address) {
    var chainName = hooks_useGetChainName();
    var type = checkIsStableSwap() ? "stableSwap" : "swap";
    var data = useSWRImmutable([
        "info/pool/chartData/".concat(address, "/").concat(type),
        chainName
    ], function() {
        return fetchPoolChartData(chainName, address);
    }).data;
    var ref;
    return (ref = data === null || data === void 0 ? void 0 : data.data) !== null && ref !== void 0 ? ref : undefined;
};
var usePoolTransactionsSWR = function(address) {
    var chainName = hooks_useGetChainName();
    var type = checkIsStableSwap() ? "stableSwap" : "swap";
    var data = useSWRImmutable([
        "info/pool/transactionsData/".concat(address, "/").concat(type),
        chainName
    ], function() {
        return fetchPoolTransactions(chainName, address);
    }, SWR_SETTINGS).data;
    var ref;
    return (ref = data === null || data === void 0 ? void 0 : data.data) !== null && ref !== void 0 ? ref : undefined;
};
// Tokens hooks
var useAllTokenDataSWR = function() {
    var chainName = hooks_useGetChainName();
    var ref = _sliced_to_array(getDeltaTimestamps(), 4), t24h = ref[0], t48h = ref[1], t7d = ref[2], t14d = ref[3];
    var blocks = useBlockFromTimeStampSWR([
        t24h,
        t48h,
        t7d,
        t14d
    ]).blocks;
    var type = checkIsStableSwap() ? "stableSwap" : "swap";
    var data = useSWRImmutable(blocks && chainName && [
        "info/token/data/".concat(type),
        chainName
    ], function() {
        return fetchAllTokenData(chainName, blocks);
    }, SWR_SETTINGS).data;
    return data !== null && data !== void 0 ? data : {};
};
var useTokenDatasSWR = function(addresses) {
    // const allTokenData = useAllTokenDataSWR()
    var name = addresses.join("");
    var chainName = hooks_useGetChainName();
    var ref = _sliced_to_array(getDeltaTimestamps(), 4), t24h = ref[0], t48h = ref[1], t7d = ref[2], t14d = ref[3];
    var blocks = useBlockFromTimeStampSWR([
        t24h,
        t48h,
        t7d,
        t14d
    ]).blocks;
    var data = useSWRImmutable(blocks && chainName && [
        "info/token/data/".concat(name),
        chainName
    ], function() {
        return fetchAllTokenDataByAddresses(chainName, blocks, addresses);
    }, SWR_SETTINGS).data;
    var tokensWithData = useMemo(function() {
        if (!addresses) {
            return undefined;
        }
        return addresses.map(function(a) {
            var ref;
            return data === null || data === void 0 ? void 0 : (ref = data[a]) === null || ref === void 0 ? void 0 : ref.data;
        }).filter(function(d) {
            return d && d.exists;
        });
    }, [
        addresses,
        data
    ]);
    return tokensWithData !== null && tokensWithData !== void 0 ? tokensWithData : undefined;
};
var useTokenDataSWR = function(address) {
    var allTokenData = useTokenDatasSWR([
        address
    ]);
    var ref;
    return (ref = allTokenData.find(function(d) {
        return d.address === address;
    })) !== null && ref !== void 0 ? ref : undefined;
};
var usePoolsForTokenSWR = function(address) {
    var chainName = hooks_useGetChainName();
    var type = checkIsStableSwap() ? "stableSwap" : "swap";
    var data = useSWRImmutable([
        "info/token/poolAddress/".concat(address, "/").concat(type),
        chainName
    ], function() {
        return fetchPoolsForToken(chainName, address);
    }, SWR_SETTINGS).data;
    var ref;
    return (ref = data === null || data === void 0 ? void 0 : data.addresses) !== null && ref !== void 0 ? ref : undefined;
};
var useTokenChartDataSWR = function(address) {
    var chainName = hooks_useGetChainName();
    var type = checkIsStableSwap() ? "stableSwap" : "swap";
    var data = useSWRImmutable(address && chainName && [
        "info/token/chartData/".concat(address, "/").concat(type),
        chainName
    ], function() {
        return fetchTokenChartData(chainName, address);
    }, SWR_SETTINGS).data;
    var ref;
    return (ref = data === null || data === void 0 ? void 0 : data.data) !== null && ref !== void 0 ? ref : undefined;
};
var useTokenPriceDataSWR = function(address, interval, timeWindow) {
    var utcCurrentTime = getUnixTime(new Date()) * 1000;
    var startTimestamp = getUnixTime(startOfHour(sub(utcCurrentTime, timeWindow)));
    var chainName = hooks_useGetChainName();
    var type = checkIsStableSwap() ? "stableSwap" : "swap";
    var data = useSWRImmutable([
        "info/token/priceData/".concat(address, "/").concat(type),
        chainName
    ], function() {
        return fetchTokenPriceData(chainName, address, interval, startTimestamp);
    }, SWR_SETTINGS).data;
    var ref;
    return (ref = data === null || data === void 0 ? void 0 : data.data) !== null && ref !== void 0 ? ref : undefined;
};
var useTokenTransactionsSWR = function(address) {
    var chainName = hooks_useGetChainName();
    var type = checkIsStableSwap() ? "stableSwap" : "swap";
    var data = useSWRImmutable([
        "info/token/transactionsData/".concat(address, "/").concat(type),
        chainName
    ], function() {
        return fetchTokenTransactions(chainName, address);
    }, SWR_SETTINGS).data;
    var ref;
    return (ref = data === null || data === void 0 ? void 0 : data.data) !== null && ref !== void 0 ? ref : undefined;
};
var hooks_useGetChainName = function() {
    var path = window.location.href;
    var getChain = useCallback(function() {
        if (path.includes("eth") || path.includes("chainId=1")) return "ETH";
        return "BSC";
    }, [
        path
    ]);
    var ref = useState(getChain()), name = ref[0], setName = ref[1];
    var result = useMemo(function() {
        return name;
    }, [
        name
    ]);
    useEffect(function() {
        setName(getChain());
    }, [
        getChain
    ]);
    return result;
};
var useMultiChainPath = function() {
    var router = useRouter();
    var chainName = router.query.chainName;
    return chainName ? "/".concat(chainName) : "";
};
var useStableSwapPath = function() {
    return checkIsStableSwap() ? "?type=stableSwap" : "";
};

;// CONCATENATED MODULE: ./src/views/Info/hooks/useBlocksFromTimestamps.ts






/**
 * for a given array of timestamps, returns block entities
 * @param timestamps
 * @param sortDirection
 * @param skipCount
 */ var useBlocksFromTimestamps_useBlocksFromTimestamps = function(timestamps) {
    var sortDirection = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "desc", skipCount = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1000;
    var ref = useState(), blocks = ref[0], setBlocks = ref[1];
    var ref1 = useState(false), error = ref1[0], setError = ref1[1];
    var timestampsString = JSON.stringify(timestamps);
    var blocksString = blocks ? JSON.stringify(blocks) : undefined;
    var chainName = useGetChainName();
    useEffect(function() {
        var fetchData = function() {
            var _ref = _async_to_generator(function() {
                var timestampsArray, result;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            timestampsArray = JSON.parse(timestampsString);
                            return [
                                4,
                                getBlocksFromTimestamps(timestampsArray, sortDirection, skipCount, chainName)
                            ];
                        case 1:
                            result = _state.sent();
                            if (result.length === 0) {
                                setError(true);
                            } else {
                                setBlocks(result);
                            }
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetchData() {
                return _ref.apply(this, arguments);
            };
        }();
        var blocksArray = blocksString ? JSON.parse(blocksString) : undefined;
        if (!blocksArray && !error && chainName) {
            fetchData();
        }
    }, [
        blocksString,
        error,
        skipCount,
        sortDirection,
        timestampsString,
        chainName
    ]);
    return {
        blocks: blocks,
        error: error
    };
};
var useBlocksFromTimestamps_useBlockFromTimeStampSWR = function(timestamps) {
    var sortDirection = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "desc", skipCount = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1000;
    var chainName = useGetChainName();
    var timestampsString = JSON.stringify(timestamps);
    var timestampsArray = JSON.parse(timestampsString);
    var data = useSWRImmutable([
        "info/blocks/".concat(timestampsString),
        chainName
    ], function() {
        return getBlocksFromTimestamps(timestampsArray, sortDirection, skipCount, chainName);
    }).data;
    return {
        blocks: data
    };
};

;// CONCATENATED MODULE: ./src/state/info/queries/pools/topPools.ts




function topPools_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      query topPools($blacklist: [String!]) {\n        pairDayDatas(\n          first: 30\n          ",
        "\n          orderBy: dailyVolumeUSD\n          orderDirection: desc\n        ) {\n          id\n        }\n      }\n    "
    ]);
    topPools_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





/**
 * Initial pools to display on the home page
 */ var fetchTopPools = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(chainName, timestamp24hAgo) {
        var isStableSwap, whereCondition, query, data, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    isStableSwap = (0,constant/* checkIsStableSwap */.J5)();
                    whereCondition = chainName === "BSC" ? "where: { dailyTxns_gt: 300, token0_not_in: $blacklist, token1_not_in: $blacklist, date_gt: ".concat(timestamp24hAgo, " }") : "where: { date_gt: ".concat(timestamp24hAgo, ", token0_not_in: $blacklist, token1_not_in: $blacklist, dailyVolumeUSD_gt: 2000 }");
                    if (isStableSwap) whereCondition = "";
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    query = (0,esm/* gql */.Ps)(topPools_templateObject(), whereCondition);
                    return [
                        4,
                        (0,constant/* getMultiChainQueryEndPointWithStableSwap */.rf)(chainName).request(query, {
                            blacklist: constant/* multiChainTokenBlackList */.z2[chainName]
                        })
                    ];
                case 2:
                    data = _state.sent();
                    // pairDayDatas id has compound id "0xPOOLADDRESS-NUMBERS", extracting pool address with .split('-')
                    return [
                        2,
                        data.pairDayDatas.map(function(p) {
                            return p.id.split("-")[0];
                        })
                    ];
                case 3:
                    error = _state.sent();
                    console.error("Failed to fetch top pools", error);
                    return [
                        2,
                        []
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function fetchTopPools(chainName, timestamp24hAgo) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * Fetch top addresses by volume
 */ var useTopPoolAddresses = function() {
    var ref = useState([]), topPoolAddresses = ref[0], setTopPoolAddresses = ref[1];
    var ref1 = _sliced_to_array(getDeltaTimestamps(), 1), timestamp24hAgo = ref1[0];
    var chainName = useGetChainName();
    useEffect(function() {
        var fetch = function() {
            var _ref = _async_to_generator(function() {
                var addresses;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                fetchTopPools(chainName, timestamp24hAgo)
                            ];
                        case 1:
                            addresses = _state.sent();
                            setTopPoolAddresses(addresses);
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetch() {
                return _ref.apply(this, arguments);
            };
        }();
        if (topPoolAddresses.length === 0) {
            fetch();
        }
    }, [
        topPoolAddresses,
        timestamp24hAgo,
        chainName
    ]);
    return topPoolAddresses;
};
var fetchTopPoolAddresses = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(chainName) {
        var ref, timestamp24hAgo, addresses;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ref = (0,src_sliced_to_array/* default */.Z)(getDeltaTimestamps_getDeltaTimestamps(), 1), timestamp24hAgo = ref[0];
                    return [
                        4,
                        fetchTopPools(chainName, timestamp24hAgo)
                    ];
                case 1:
                    addresses = _state.sent();
                    return [
                        2,
                        addresses
                    ];
            }
        });
    });
    return function fetchTopPoolAddresses(chainName) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var topPools = ((/* unused pure expression or super */ null && (useTopPoolAddresses)));

;// CONCATENATED MODULE: ./src/state/info/queries/pools/poolData.ts
/* eslint-disable no-param-reassign */ 





function poolData_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      query pools {\n        now: ",
        "\n        oneDayAgo: ",
        "\n        twoDaysAgo: ",
        "\n        oneWeekAgo: ",
        "\n        ",
        "\n      }\n    "
    ]);
    poolData_templateObject = function _templateObject() {
        return data;
    };
    return data;
}










/**
 * Data for displaying pool tables (on multiple pages, used throughout the site)
 * Note: Don't try to refactor it to use variables, server throws error if blocks passed as undefined variable
 * only works if its hard-coded into query string
 */ var POOL_AT_BLOCK = function(chainName, block, pools) {
    var blockString = block ? "block: {number: ".concat(block, "}") : "";
    var addressesString = '["'.concat(pools.join('","'), '"]');
    return "pairs(\n    where: { id_in: ".concat(addressesString, " }\n    ").concat(blockString, "\n    orderBy: trackedReserve").concat(constant/* multiChainQueryMainToken */.WR[chainName], "\n    orderDirection: desc\n  ) {\n    id\n    reserve0\n    reserve1\n    reserveUSD\n    volumeUSD\n    token0Price\n    token1Price\n    token0 {\n      id\n      symbol\n      name\n    }\n    token1 {\n      id\n      symbol\n      name\n    }\n  }");
};
var fetchPoolData = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(block24h, block48h, block7d, block14d, poolAddresses) {
        var chainName, weeksQuery, query, data, error;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    chainName = _arguments.length > 5 && _arguments[5] !== void 0 ? _arguments[5] : "BSC";
                    weeksQuery = chainName === "BSC" ? "twoWeeksAgo: ".concat(POOL_AT_BLOCK(chainName, block14d, poolAddresses)) : "";
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    query = (0,esm/* gql */.Ps)(poolData_templateObject(), POOL_AT_BLOCK(chainName, null, poolAddresses), POOL_AT_BLOCK(chainName, block24h, poolAddresses), POOL_AT_BLOCK(chainName, block48h, poolAddresses), POOL_AT_BLOCK(chainName, block7d, poolAddresses), weeksQuery);
                    return [
                        4,
                        (0,constant/* getMultiChainQueryEndPointWithStableSwap */.rf)(chainName).request(query)
                    ];
                case 2:
                    data = _state.sent();
                    return [
                        2,
                        {
                            data: data,
                            error: false
                        }
                    ];
                case 3:
                    error = _state.sent();
                    console.error("Failed to fetch pool data", error);
                    return [
                        2,
                        {
                            error: true
                        }
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function fetchPoolData(block24h, block48h, block7d, block14d, poolAddresses) {
        return _ref.apply(this, arguments);
    };
}();
// Transforms pools into "0xADDRESS: { ...PoolFields }" format and cast strings to numbers
var parsePoolData = function(pairs) {
    if (!pairs) {
        return {};
    }
    return pairs.reduce(function(accum, poolData) {
        var volumeUSD = poolData.volumeUSD, reserveUSD = poolData.reserveUSD, reserve0 = poolData.reserve0, reserve1 = poolData.reserve1, token0Price = poolData.token0Price, token1Price = poolData.token1Price;
        accum[poolData.id] = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, poolData), {
            volumeUSD: parseFloat(volumeUSD),
            reserveUSD: parseFloat(reserveUSD),
            reserve0: parseFloat(reserve0),
            reserve1: parseFloat(reserve1),
            token0Price: parseFloat(token0Price),
            token1Price: parseFloat(token1Price)
        });
        return accum;
    }, {});
};
/**
 * Fetch top pools by liquidity
 */ var usePoolDatas = function(poolAddresses) {
    var ref = useState({
        error: false
    }), fetchState = ref[0], setFetchState = ref[1];
    var ref1 = _sliced_to_array(getDeltaTimestamps(), 4), t24h = ref1[0], t48h = ref1[1], t7d = ref1[2], t14d = ref1[3];
    var ref2 = useBlocksFromTimestamps([
        t24h,
        t48h,
        t7d,
        t14d
    ]), blocks = ref2.blocks, blockError = ref2.error;
    var ref3 = _sliced_to_array(blocks !== null && blocks !== void 0 ? blocks : [], 4), block24h = ref3[0], block48h = ref3[1], block7d = ref3[2], block14d = ref3[3];
    var chainName = useGetChainName();
    useEffect(function() {
        var fetch = function() {
            var _ref = _async_to_generator(function() {
                var ref, error, data, formattedPoolData, formattedPoolData24h, formattedPoolData48h, formattedPoolData7d, formattedPoolData14d, formatted;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                fetchPoolData(block24h.number, block48h.number, block7d.number, block14d.number, poolAddresses, chainName)
                            ];
                        case 1:
                            ref = _state.sent(), error = ref.error, data = ref.data;
                            if (error) {
                                setFetchState({
                                    error: true
                                });
                            } else {
                                formattedPoolData = parsePoolData(data === null || data === void 0 ? void 0 : data.now);
                                formattedPoolData24h = parsePoolData(data === null || data === void 0 ? void 0 : data.oneDayAgo);
                                formattedPoolData48h = parsePoolData(data === null || data === void 0 ? void 0 : data.twoDaysAgo);
                                formattedPoolData7d = parsePoolData(data === null || data === void 0 ? void 0 : data.oneWeekAgo);
                                formattedPoolData14d = parsePoolData(data === null || data === void 0 ? void 0 : data.twoWeeksAgo);
                                formatted = poolAddresses.reduce(function(accum, address) {
                                    // Undefined data is possible if pool is brand new and didn't exist one day ago or week ago.
                                    var current = formattedPoolData[address];
                                    var oneDay = formattedPoolData24h[address];
                                    var twoDays = formattedPoolData48h[address];
                                    var week = formattedPoolData7d[address];
                                    var twoWeeks = formattedPoolData14d[address];
                                    var ref = _sliced_to_array(getChangeForPeriod(current === null || current === void 0 ? void 0 : current.volumeUSD, oneDay === null || oneDay === void 0 ? void 0 : oneDay.volumeUSD, twoDays === null || twoDays === void 0 ? void 0 : twoDays.volumeUSD), 2), volumeUSD = ref[0], volumeUSDChange = ref[1];
                                    var ref1 = _sliced_to_array(getChangeForPeriod(current === null || current === void 0 ? void 0 : current.volumeUSD, week === null || week === void 0 ? void 0 : week.volumeUSD, twoWeeks === null || twoWeeks === void 0 ? void 0 : twoWeeks.volumeUSD), 2), volumeUSDWeek = ref1[0], volumeUSDChangeWeek = ref1[1];
                                    var liquidityUSD = current ? current.reserveUSD : 0;
                                    var liquidityUSDChange = getPercentChange(current === null || current === void 0 ? void 0 : current.reserveUSD, oneDay === null || oneDay === void 0 ? void 0 : oneDay.reserveUSD);
                                    var liquidityToken0 = current ? current.reserve0 : 0;
                                    var liquidityToken1 = current ? current.reserve1 : 0;
                                    var ref2 = getLpFeesAndApr(volumeUSD, volumeUSDWeek, liquidityUSD), totalFees24h = ref2.totalFees24h, totalFees7d = ref2.totalFees7d, lpFees24h = ref2.lpFees24h, lpFees7d = ref2.lpFees7d, lpApr7d = ref2.lpApr7d;
                                    if (current) {
                                        accum[address] = {
                                            address: address,
                                            token0: {
                                                address: current.token0.id,
                                                name: current.token0.name,
                                                symbol: current.token0.symbol
                                            },
                                            token1: {
                                                address: current.token1.id,
                                                name: current.token1.name,
                                                symbol: current.token1.symbol
                                            },
                                            token0Price: current.token0Price,
                                            token1Price: current.token1Price,
                                            volumeUSD: volumeUSD,
                                            volumeUSDChange: volumeUSDChange,
                                            volumeUSDWeek: volumeUSDWeek,
                                            volumeUSDChangeWeek: volumeUSDChangeWeek,
                                            totalFees24h: totalFees24h,
                                            totalFees7d: totalFees7d,
                                            lpFees24h: lpFees24h,
                                            lpFees7d: lpFees7d,
                                            lpApr7d: lpApr7d,
                                            liquidityUSD: liquidityUSD,
                                            liquidityUSDChange: liquidityUSDChange,
                                            liquidityToken0: liquidityToken0,
                                            liquidityToken1: liquidityToken1
                                        };
                                    }
                                    return accum;
                                }, {});
                                setFetchState({
                                    data: formatted,
                                    error: false
                                });
                            }
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetch() {
                return _ref.apply(this, arguments);
            };
        }();
        var allBlocksAvailable = (block24h === null || block24h === void 0 ? void 0 : block24h.number) && (block48h === null || block48h === void 0 ? void 0 : block48h.number) && (block7d === null || block7d === void 0 ? void 0 : block7d.number) && (block14d === null || block14d === void 0 ? void 0 : block14d.number);
        if (poolAddresses.length > 0 && allBlocksAvailable && !blockError) {
            fetch();
        }
    }, [
        poolAddresses,
        block24h,
        block48h,
        block7d,
        block14d,
        blockError,
        chainName
    ]);
    return fetchState;
};
var poolData_fetchAllPoolDataWithAddress = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(blocks, chainName, poolAddresses) {
        var ref, block24h, block48h, block7d, block14d, data, formattedPoolData, formattedPoolData24h, formattedPoolData48h, formattedPoolData7d, formattedPoolData14d, formatted;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ref = (0,src_sliced_to_array/* default */.Z)(blocks !== null && blocks !== void 0 ? blocks : [], 4), block24h = ref[0], block48h = ref[1], block7d = ref[2], block14d = ref[3];
                    return [
                        4,
                        fetchPoolData(block24h.number, block48h.number, block7d.number, block14d.number, poolAddresses, chainName)
                    ];
                case 1:
                    data = _state.sent().data;
                    formattedPoolData = parsePoolData(data === null || data === void 0 ? void 0 : data.now);
                    formattedPoolData24h = parsePoolData(data === null || data === void 0 ? void 0 : data.oneDayAgo);
                    formattedPoolData48h = parsePoolData(data === null || data === void 0 ? void 0 : data.twoDaysAgo);
                    formattedPoolData7d = parsePoolData(data === null || data === void 0 ? void 0 : data.oneWeekAgo);
                    formattedPoolData14d = parsePoolData(data === null || data === void 0 ? void 0 : data.twoWeeksAgo);
                    formatted = poolAddresses.reduce(function(accum, address) {
                        // Undefined data is possible if pool is brand new and didn't exist one day ago or week ago.
                        var current = formattedPoolData[address];
                        var oneDay = formattedPoolData24h[address];
                        var twoDays = formattedPoolData48h[address];
                        var week = formattedPoolData7d[address];
                        var twoWeeks = formattedPoolData14d[address];
                        var ref = (0,src_sliced_to_array/* default */.Z)(getChangeForPeriod_getChangeForPeriod(current === null || current === void 0 ? void 0 : current.volumeUSD, oneDay === null || oneDay === void 0 ? void 0 : oneDay.volumeUSD, twoDays === null || twoDays === void 0 ? void 0 : twoDays.volumeUSD), 2), volumeUSD = ref[0], volumeUSDChange = ref[1];
                        var ref1 = (0,src_sliced_to_array/* default */.Z)(getChangeForPeriod_getChangeForPeriod(current === null || current === void 0 ? void 0 : current.volumeUSD, week === null || week === void 0 ? void 0 : week.volumeUSD, twoWeeks === null || twoWeeks === void 0 ? void 0 : twoWeeks.volumeUSD), 2), volumeUSDWeek = ref1[0], volumeUSDChangeWeek = ref1[1];
                        var liquidityUSD = current ? current.reserveUSD : 0;
                        var liquidityUSDChange = infoDataHelpers_getPercentChange(current === null || current === void 0 ? void 0 : current.reserveUSD, oneDay === null || oneDay === void 0 ? void 0 : oneDay.reserveUSD);
                        var liquidityToken0 = current ? current.reserve0 : 0;
                        var liquidityToken1 = current ? current.reserve1 : 0;
                        var ref2 = getLpFeesAndApr_getLpFeesAndApr(volumeUSD, volumeUSDWeek, liquidityUSD), totalFees24h = ref2.totalFees24h, totalFees7d = ref2.totalFees7d, lpFees24h = ref2.lpFees24h, lpFees7d = ref2.lpFees7d, lpApr7d = ref2.lpApr7d;
                        if (current) {
                            accum[address] = {
                                data: {
                                    address: address,
                                    token0: {
                                        address: current.token0.id,
                                        name: current.token0.name,
                                        symbol: current.token0.symbol
                                    },
                                    token1: {
                                        address: current.token1.id,
                                        name: current.token1.name,
                                        symbol: current.token1.symbol
                                    },
                                    token0Price: current.token0Price,
                                    token1Price: current.token1Price,
                                    volumeUSD: volumeUSD,
                                    volumeUSDChange: volumeUSDChange,
                                    volumeUSDWeek: volumeUSDWeek,
                                    volumeUSDChangeWeek: volumeUSDChangeWeek,
                                    totalFees24h: totalFees24h,
                                    totalFees7d: totalFees7d,
                                    lpFees24h: lpFees24h,
                                    lpFees7d: lpFees7d,
                                    lpApr7d: lpApr7d,
                                    liquidityUSD: liquidityUSD,
                                    liquidityUSDChange: liquidityUSDChange,
                                    liquidityToken0: liquidityToken0,
                                    liquidityToken1: liquidityToken1
                                }
                            };
                        }
                        return accum;
                    }, {});
                    return [
                        2,
                        formatted
                    ];
            }
        });
    });
    return function fetchAllPoolDataWithAddress(blocks, chainName, poolAddresses) {
        return _ref.apply(this, arguments);
    };
}();
var poolData_fetchAllPoolData = function() {
    var _ref = (0,src_async_to_generator/* default */.Z)(function(blocks, chainName) {
        var poolAddresses;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        fetchTopPoolAddresses(chainName)
                    ];
                case 1:
                    poolAddresses = _state.sent();
                    return [
                        2,
                        poolData_fetchAllPoolDataWithAddress(blocks, chainName, poolAddresses)
                    ];
            }
        });
    });
    return function fetchAllPoolData(blocks, chainName) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var poolData = ((/* unused pure expression or super */ null && (usePoolDatas)));

;// CONCATENATED MODULE: ./src/state/swap/hooks.ts





































function useSwapState() {
    return (0,es/* useSelector */.v9)(function(state) {
        return state.swap;
    });
}
// TODO: update
var BAD_RECIPIENT_ADDRESSES = [
    "0x5C69bEe701ef814a2B6a3EDD4B1652CB9cc5aA6f",
    "0xf164fC0Ec4E93095b804a4795bBe1e041497b92a",
    "0x7a250d5630B4cF539739dF2C5dAcb4c659F2488D"
];
/**
 * Returns true if any of the pairs or tokens in a trade have the given checksummed address
 * @param trade to check for the given address
 * @param checksummedAddress address to check in the pairs and tokens
 */ function involvesAddress(trade, checksummedAddress) {
    return trade.route.path.some(function(token) {
        return token.address === checksummedAddress;
    }) || trade.route.pairs.some(function(pair) {
        return pair.liquidityToken.address === checksummedAddress;
    });
}
// Get swap price for single token disregarding slippage and price impact
function useSingleTokenSwapInfo(inputCurrencyId, inputCurrency, outputCurrencyId, outputCurrency) {
    var ref;
    var token0Address = getTokenAddress(inputCurrencyId);
    var token1Address = getTokenAddress(outputCurrencyId);
    var parsedAmount = (0,tryParseAmount/* default */.Z)("1", inputCurrency !== null && inputCurrency !== void 0 ? inputCurrency : undefined);
    var bestTradeExactIn = (0,Trades/* useTradeExactIn */.AU)(parsedAmount, outputCurrency !== null && outputCurrency !== void 0 ? outputCurrency : undefined);
    if (!inputCurrency || !outputCurrency || !bestTradeExactIn) {
        return null;
    }
    var inputTokenPrice = parseFloat(bestTradeExactIn === null || bestTradeExactIn === void 0 ? void 0 : (ref = bestTradeExactIn.executionPrice) === null || ref === void 0 ? void 0 : ref.toSignificant(6));
    var outputTokenPrice = 1 / inputTokenPrice;
    var _obj;
    return _obj = {}, (0,_define_property/* default */.Z)(_obj, token0Address, inputTokenPrice), (0,_define_property/* default */.Z)(_obj, token1Address, outputTokenPrice), _obj;
}
// from the current swap inputs, compute the best trade and return it.
function useDerivedSwapInfo(independentField, typedValue, inputCurrency, outputCurrency, recipient) {
    var account = (0,src/* useWeb3React */.Ge)().account;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var ref;
    var to = (ref = recipient === null ? account : (0,utils/* isAddress */.UJ)(recipient) || null) !== null && ref !== void 0 ? ref : null;
    var relevantTokenBalances = (0,hooks/* useCurrencyBalances */.K5)(account !== null && account !== void 0 ? account : undefined, [
        inputCurrency !== null && inputCurrency !== void 0 ? inputCurrency : undefined,
        outputCurrency !== null && outputCurrency !== void 0 ? outputCurrency : undefined, 
    ]);
    var isExactIn = independentField === actions/* Field.INPUT */.gN.INPUT;
    var ref1;
    var parsedAmount = (0,tryParseAmount/* default */.Z)(typedValue, (ref1 = isExactIn ? inputCurrency : outputCurrency) !== null && ref1 !== void 0 ? ref1 : undefined);
    var bestTradeExactIn = (0,Trades/* useTradeExactIn */.AU)(isExactIn ? parsedAmount : undefined, outputCurrency !== null && outputCurrency !== void 0 ? outputCurrency : undefined);
    var bestTradeExactOut = (0,Trades/* useTradeExactOut */["in"])(inputCurrency !== null && inputCurrency !== void 0 ? inputCurrency : undefined, !isExactIn ? parsedAmount : undefined);
    var v2Trade = isExactIn ? bestTradeExactIn : bestTradeExactOut;
    var _obj;
    var currencyBalances = (_obj = {}, (0,_define_property/* default */.Z)(_obj, actions/* Field.INPUT */.gN.INPUT, relevantTokenBalances[0]), (0,_define_property/* default */.Z)(_obj, actions/* Field.OUTPUT */.gN.OUTPUT, relevantTokenBalances[1]), _obj);
    var _obj1;
    var currencies = (_obj1 = {}, (0,_define_property/* default */.Z)(_obj1, actions/* Field.INPUT */.gN.INPUT, inputCurrency !== null && inputCurrency !== void 0 ? inputCurrency : undefined), (0,_define_property/* default */.Z)(_obj1, actions/* Field.OUTPUT */.gN.OUTPUT, outputCurrency !== null && outputCurrency !== void 0 ? outputCurrency : undefined), _obj1);
    var inputError;
    if (!account) {
        inputError = t("Connect Wallet");
    }
    if (!parsedAmount) {
        inputError = inputError !== null && inputError !== void 0 ? inputError : t("Enter an amount");
    }
    if (!currencies[actions/* Field.INPUT */.gN.INPUT] || !currencies[actions/* Field.OUTPUT */.gN.OUTPUT]) {
        inputError = inputError !== null && inputError !== void 0 ? inputError : t("Select a token");
    }
    var formattedTo = (0,utils/* isAddress */.UJ)(to);
    if (!to || !formattedTo) {
        inputError = inputError !== null && inputError !== void 0 ? inputError : t("Enter a recipient");
    } else if (BAD_RECIPIENT_ADDRESSES.indexOf(formattedTo) !== -1 || bestTradeExactIn && involvesAddress(bestTradeExactIn, formattedTo) || bestTradeExactOut && involvesAddress(bestTradeExactOut, formattedTo)) {
        inputError = inputError !== null && inputError !== void 0 ? inputError : t("Invalid recipient");
    }
    var ref2 = (0,src_sliced_to_array/* default */.Z)((0,user_hooks/* useUserSlippageTolerance */.$2)(), 1), allowedSlippage = ref2[0];
    var slippageAdjustedAmounts = v2Trade && allowedSlippage && (0,utils_exchange/* computeSlippageAdjustedAmounts */.b5)(v2Trade, allowedSlippage);
    // compare input balance to max input based on version
    var ref3 = [
        currencyBalances[actions/* Field.INPUT */.gN.INPUT],
        slippageAdjustedAmounts ? slippageAdjustedAmounts[actions/* Field.INPUT */.gN.INPUT] : null, 
    ], balanceIn = ref3[0], amountIn = ref3[1];
    if (balanceIn && amountIn && balanceIn.lessThan(amountIn)) {
        inputError = t("Insufficient %symbol% balance", {
            symbol: amountIn.currency.symbol
        });
    }
    return {
        currencies: currencies,
        currencyBalances: currencyBalances,
        parsedAmount: parsedAmount,
        v2Trade: v2Trade !== null && v2Trade !== void 0 ? v2Trade : undefined,
        inputError: inputError
    };
}
function parseTokenAmountURLParameter(urlParam) {
    return typeof urlParam === "string" && !Number.isNaN(parseFloat(urlParam)) ? urlParam : "";
}
function parseIndependentFieldURLParameter(urlParam) {
    return typeof urlParam === "string" && urlParam.toLowerCase() === "output" ? actions/* Field.OUTPUT */.gN.OUTPUT : actions/* Field.INPUT */.gN.INPUT;
}
var ADDRESS_REGEX = /^0x[a-fA-F0-9]{40}$/;
function validatedRecipient(recipient) {
    if (typeof recipient !== "string") return null;
    var address = (0,utils/* isAddress */.UJ)(recipient);
    if (address) return address;
    if (ADDRESS_REGEX.test(recipient)) return recipient;
    return null;
}
function queryParametersToSwapState(parsedQs, nativeSymbol, defaultOutputCurrency) {
    var inputCurrency = (0,utils/* isAddress */.UJ)(parsedQs.inputCurrency) || (nativeSymbol !== null && nativeSymbol !== void 0 ? nativeSymbol : exchange/* DEFAULT_INPUT_CURRENCY */.VN);
    var outputCurrency = typeof parsedQs.outputCurrency === "string" ? (0,utils/* isAddress */.UJ)(parsedQs.outputCurrency) || nativeSymbol : defaultOutputCurrency !== null && defaultOutputCurrency !== void 0 ? defaultOutputCurrency : exchange/* DEFAULT_OUTPUT_CURRENCY */.g$;
    if (inputCurrency === outputCurrency) {
        if (typeof parsedQs.outputCurrency === "string") {
            inputCurrency = "";
        } else {
            outputCurrency = "";
        }
    }
    var recipient = validatedRecipient(parsedQs.recipient);
    var _obj;
    return _obj = {}, (0,_define_property/* default */.Z)(_obj, actions/* Field.INPUT */.gN.INPUT, {
        currencyId: inputCurrency
    }), (0,_define_property/* default */.Z)(_obj, actions/* Field.OUTPUT */.gN.OUTPUT, {
        currencyId: outputCurrency
    }), (0,_define_property/* default */.Z)(_obj, "typedValue", parseTokenAmountURLParameter(parsedQs.exactAmount)), (0,_define_property/* default */.Z)(_obj, "independentField", parseIndependentFieldURLParameter(parsedQs.exactField)), (0,_define_property/* default */.Z)(_obj, "recipient", recipient), (0,_define_property/* default */.Z)(_obj, "pairDataById", {}), (0,_define_property/* default */.Z)(_obj, "derivedPairDataById", {}), _obj;
}
// updates the swap state to use the defaults for a given network
function useDefaultsFromURLSearch() {
    var chainId = (0,useActiveWeb3React/* default */.Z)().chainId;
    var dispatch = (0,state/* useAppDispatch */.TL)();
    var native = (0,useNativeCurrency/* default */.Z)();
    var query = (0,router.useRouter)().query;
    var ref = (0,react.useState)(), result = ref[0], setResult = ref[1];
    (0,react.useEffect)(function() {
        var ref, ref1;
        if (!chainId || !native) return;
        var ref2;
        var parsed = queryParametersToSwapState(query, native.symbol, (ref2 = (ref = tokens_src/* PIBRIDGE */.py[chainId]) === null || ref === void 0 ? void 0 : ref.address) !== null && ref2 !== void 0 ? ref2 : (ref1 = tokens_src/* USDC */.gn[chainId]) === null || ref1 === void 0 ? void 0 : ref1.address);
        dispatch((0,actions/* replaceSwapState */.mV)({
            typedValue: parsed.typedValue,
            field: parsed.independentField,
            inputCurrencyId: parsed[actions/* Field.INPUT */.gN.INPUT].currencyId,
            outputCurrencyId: parsed[actions/* Field.OUTPUT */.gN.OUTPUT].currencyId,
            recipient: null
        }));
        setResult({
            inputCurrencyId: parsed[actions/* Field.INPUT */.gN.INPUT].currencyId,
            outputCurrencyId: parsed[actions/* Field.OUTPUT */.gN.OUTPUT].currencyId
        });
    }, [
        dispatch,
        chainId,
        query,
        native
    ]);
    return result;
}
var useFetchPairPrices = function(param) {
    var token0Address = param.token0Address, token1Address = param.token1Address, timeWindow = param.timeWindow, currentSwapPrice = param.currentSwapPrice;
    var ref = useState(null), pairId = ref[0], setPairId = ref[1];
    var ref1 = useState(false), isLoading = ref1[0], setIsLoading = ref1[1];
    var pairData = useSelector(pairByDataIdSelector({
        pairId: pairId,
        timeWindow: timeWindow
    }));
    var derivedPairData = useSelector(derivedPairByDataIdSelector({
        pairId: pairId,
        timeWindow: timeWindow
    }));
    var dispatch = useDispatch();
    useEffect(function() {
        var fetchDerivedData = function() {
            var _ref = _async_to_generator(function() {
                var derivedData, normalizedDerivedData, error;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            console.info("[Price Chart]: Not possible to retrieve price data from single pool, trying to fetch derived prices");
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                4,
                                5
                            ]);
                            return [
                                4,
                                fetchDerivedPriceData(token0Address, token1Address, timeWindow)
                            ];
                        case 2:
                            derivedData = _state.sent();
                            if (derivedData) {
                                normalizedDerivedData = normalizeDerivedChartData(derivedData);
                                dispatch(updateDerivedPairData({
                                    pairData: normalizedDerivedData,
                                    pairId: pairId,
                                    timeWindow: timeWindow
                                }));
                            } else {
                                dispatch(updateDerivedPairData({
                                    pairData: [],
                                    pairId: pairId,
                                    timeWindow: timeWindow
                                }));
                            }
                            return [
                                3,
                                5
                            ];
                        case 3:
                            error = _state.sent();
                            console.error("Failed to fetch derived prices for chart", error);
                            dispatch(updateDerivedPairData({
                                pairData: [],
                                pairId: pairId,
                                timeWindow: timeWindow
                            }));
                            return [
                                3,
                                5
                            ];
                        case 4:
                            setIsLoading(false);
                            return [
                                7
                            ];
                        case 5:
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetchDerivedData() {
                return _ref.apply(this, arguments);
            };
        }();
        var fetchAndUpdatePairPrice = function() {
            var _ref = _async_to_generator(function() {
                var data, hasEnoughLiquidity, newPairData;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            setIsLoading(true);
                            return [
                                4,
                                fetchPairPriceData({
                                    pairId: pairId,
                                    timeWindow: timeWindow
                                })
                            ];
                        case 1:
                            data = _state.sent().data;
                            if (data) {
                                hasEnoughLiquidity = pairHasEnoughLiquidity(data, timeWindow);
                                newPairData = normalizeChartData(data, timeWindow) || [];
                                if (newPairData.length > 0 && hasEnoughLiquidity) {
                                    dispatch(updatePairData({
                                        pairData: newPairData,
                                        pairId: pairId,
                                        timeWindow: timeWindow
                                    }));
                                    setIsLoading(false);
                                } else {
                                    console.info("[Price Chart]: Liquidity too low for ".concat(pairId));
                                    dispatch(updatePairData({
                                        pairData: [],
                                        pairId: pairId,
                                        timeWindow: timeWindow
                                    }));
                                    fetchDerivedData();
                                }
                            } else {
                                dispatch(updatePairData({
                                    pairData: [],
                                    pairId: pairId,
                                    timeWindow: timeWindow
                                }));
                                fetchDerivedData();
                            }
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetchAndUpdatePairPrice() {
                return _ref.apply(this, arguments);
            };
        }();
        if (!pairData && !derivedPairData && pairId && !isLoading) {
            fetchAndUpdatePairPrice();
        }
    }, [
        pairId,
        timeWindow,
        pairData,
        currentSwapPrice,
        token0Address,
        token1Address,
        derivedPairData,
        dispatch,
        isLoading, 
    ]);
    useEffect(function() {
        var updatePairId = function() {
            try {
                var ref;
                var pairAddress = (ref = getLpAddress(token0Address, token1Address)) === null || ref === void 0 ? void 0 : ref.toLowerCase();
                if (pairAddress !== pairId) {
                    setPairId(pairAddress);
                }
            } catch (error) {
                setPairId(null);
            }
        };
        updatePairId();
    }, [
        token0Address,
        token1Address,
        pairId
    ]);
    var normalizedPairData = useMemo(function() {
        return normalizePairDataByActiveToken({
            activeToken: token0Address,
            pairData: pairData
        });
    }, [
        token0Address,
        pairData
    ]);
    var normalizedDerivedPairData = useMemo(function() {
        return normalizeDerivedPairDataByActiveToken({
            activeToken: token0Address,
            pairData: derivedPairData
        });
    }, [
        token0Address,
        derivedPairData
    ]);
    var hasSwapPrice = currentSwapPrice && currentSwapPrice[token0Address] > 0;
    var normalizedPairDataWithCurrentSwapPrice = (normalizedPairData === null || normalizedPairData === void 0 ? void 0 : normalizedPairData.length) > 0 && hasSwapPrice ? _to_consumable_array(normalizedPairData).concat([
        {
            time: new Date(),
            value: currentSwapPrice[token0Address]
        }
    ]) : normalizedPairData;
    var normalizedDerivedPairDataWithCurrentSwapPrice = (normalizedDerivedPairData === null || normalizedDerivedPairData === void 0 ? void 0 : normalizedDerivedPairData.length) > 0 && hasSwapPrice ? _to_consumable_array(normalizedDerivedPairData).concat([
        {
            time: new Date(),
            value: currentSwapPrice[token0Address]
        }
    ]) : normalizedDerivedPairData;
    var hasNoDirectData = normalizedPairDataWithCurrentSwapPrice && (normalizedPairDataWithCurrentSwapPrice === null || normalizedPairDataWithCurrentSwapPrice === void 0 ? void 0 : normalizedPairDataWithCurrentSwapPrice.length) === 0;
    var hasNoDerivedData = normalizedDerivedPairDataWithCurrentSwapPrice && (normalizedDerivedPairDataWithCurrentSwapPrice === null || normalizedDerivedPairDataWithCurrentSwapPrice === void 0 ? void 0 : normalizedDerivedPairDataWithCurrentSwapPrice.length) === 0;
    // undefined is used for loading
    var pairPrices = hasNoDirectData && hasNoDerivedData ? [] : undefined;
    if (normalizedPairDataWithCurrentSwapPrice && (normalizedPairDataWithCurrentSwapPrice === null || normalizedPairDataWithCurrentSwapPrice === void 0 ? void 0 : normalizedPairDataWithCurrentSwapPrice.length) > 0) {
        pairPrices = normalizedPairDataWithCurrentSwapPrice;
    } else if (normalizedDerivedPairDataWithCurrentSwapPrice && (normalizedDerivedPairDataWithCurrentSwapPrice === null || normalizedDerivedPairDataWithCurrentSwapPrice === void 0 ? void 0 : normalizedDerivedPairDataWithCurrentSwapPrice.length) > 0) {
        pairPrices = normalizedDerivedPairDataWithCurrentSwapPrice;
    }
    return {
        pairPrices: pairPrices,
        pairId: pairId
    };
};
var useLPApr = function(pair) {
    var ref = (0,dist/* default */.Z)(pair && pair.chainId === swap_sdk_src/* ChainId.BSC */.a_.BSC ? [
        "LP7dApr",
        pair.liquidityToken.address
    ] : null, /*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
        var ref, ref1, ref2, ref3, ref4, ref5, timestampsArray, blocks, ref6, block24h, block48h, block7d, block14d, lowerCasedAddress, ref7, error, data, current, currentReserveUSD, oneDay, twoDays, week, twoWeeks, ref8, volumeUSD, ref9, volumeUSDWeek, liquidityUSD, lpApr7d;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    timestampsArray = getDeltaTimestamps_getDeltaTimestamps();
                    return [
                        4,
                        getBlocksFromTimestamps_getBlocksFromTimestamps(timestampsArray, "desc", 1000)
                    ];
                case 1:
                    blocks = _state.sent();
                    ref6 = (0,src_sliced_to_array/* default */.Z)(blocks !== null && blocks !== void 0 ? blocks : [], 4), block24h = ref6[0], block48h = ref6[1], block7d = ref6[2], block14d = ref6[3];
                    lowerCasedAddress = pair.liquidityToken.address.toLowerCase();
                    return [
                        4,
                        fetchPoolData(block24h.number, block48h.number, block7d.number, block14d.number, [
                            lowerCasedAddress
                        ])
                    ];
                case 2:
                    ref7 = _state.sent(), error = ref7.error, data = ref7.data;
                    if (error) return [
                        2,
                        null
                    ];
                    current = parseFloat((ref = data === null || data === void 0 ? void 0 : data.now[0]) === null || ref === void 0 ? void 0 : ref.volumeUSD);
                    currentReserveUSD = parseFloat((ref1 = data === null || data === void 0 ? void 0 : data.now[0]) === null || ref1 === void 0 ? void 0 : ref1.reserveUSD);
                    oneDay = parseFloat((ref2 = data === null || data === void 0 ? void 0 : data.oneDayAgo[0]) === null || ref2 === void 0 ? void 0 : ref2.volumeUSD);
                    twoDays = parseFloat((ref3 = data === null || data === void 0 ? void 0 : data.twoDaysAgo[0]) === null || ref3 === void 0 ? void 0 : ref3.volumeUSD);
                    week = parseFloat((ref4 = data === null || data === void 0 ? void 0 : data.oneWeekAgo[0]) === null || ref4 === void 0 ? void 0 : ref4.volumeUSD);
                    twoWeeks = parseFloat((ref5 = data === null || data === void 0 ? void 0 : data.twoWeeksAgo[0]) === null || ref5 === void 0 ? void 0 : ref5.volumeUSD);
                    ref8 = (0,src_sliced_to_array/* default */.Z)(getChangeForPeriod_getChangeForPeriod(current, oneDay, twoDays), 1), volumeUSD = ref8[0];
                    ref9 = (0,src_sliced_to_array/* default */.Z)(getChangeForPeriod_getChangeForPeriod(current, week, twoWeeks), 1), volumeUSDWeek = ref9[0];
                    liquidityUSD = currentReserveUSD || 0;
                    lpApr7d = getLpFeesAndApr_getLpFeesAndApr(volumeUSD, volumeUSDWeek, liquidityUSD).lpApr7d;
                    return [
                        2,
                        lpApr7d ? {
                            lpApr7d: lpApr7d
                        } : null
                    ];
            }
        });
    }), {
        refreshInterval: constants/* SLOW_INTERVAL */.KI
    }), poolData = ref.data;
    return poolData;
};


/***/ }),

/***/ 1999:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ useSwapActionHandlers; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _actions__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15103);
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(106);



function useSwapActionHandlers() {
    var dispatch = (0,_index__WEBPACK_IMPORTED_MODULE_2__/* .useAppDispatch */ .TL)();
    var onSwitchTokens = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        dispatch((0,_actions__WEBPACK_IMPORTED_MODULE_1__/* .switchCurrencies */ .KS)());
    }, [
        dispatch
    ]);
    var onCurrencySelection = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(field, currency) {
        dispatch((0,_actions__WEBPACK_IMPORTED_MODULE_1__/* .selectCurrency */ .j)({
            field: field,
            currencyId: (currency === null || currency === void 0 ? void 0 : currency.isToken) ? currency.address : (currency === null || currency === void 0 ? void 0 : currency.isNative) ? currency.symbol : ""
        }));
    }, [
        dispatch
    ]);
    var onUserInput = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(field, typedValue) {
        dispatch((0,_actions__WEBPACK_IMPORTED_MODULE_1__/* .typeInput */ .LC)({
            field: field,
            typedValue: typedValue
        }));
    }, [
        dispatch
    ]);
    var onChangeRecipient = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(recipient) {
        dispatch((0,_actions__WEBPACK_IMPORTED_MODULE_1__/* .setRecipient */ .He)({
            recipient: recipient
        }));
    }, [
        dispatch
    ]);
    return {
        onSwitchTokens: onSwitchTokens,
        onCurrencySelection: onCurrencySelection,
        onUserInput: onUserInput,
        onChangeRecipient: onChangeRecipient
    };
}


/***/ }),

/***/ 5460:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K5": function() { return /* binding */ useCurrencyBalances; },
/* harmony export */   "Z": function() { return /* binding */ useTokenBalances; },
/* harmony export */   "_h": function() { return /* binding */ useCurrencyBalance; },
/* harmony export */   "mM": function() { return /* binding */ useTokenBalance; },
/* harmony export */   "uD": function() { return /* binding */ useAllTokenBalances; },
/* harmony export */   "v2": function() { return /* binding */ useTokenBalancesWithLoadingIndicator; }
/* harmony export */ });
/* unused harmony export useNativeBalances */
/* harmony import */ var _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1505);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _pancakeswap_wagmi__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29315);
/* harmony import */ var config_abi_erc20__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(56309);
/* harmony import */ var hooks_Tokens__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41166);
/* harmony import */ var hooks_useContract__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(80070);
/* harmony import */ var utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(97119);
/* harmony import */ var lodash_orderBy__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(75472);
/* harmony import */ var lodash_orderBy__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(lodash_orderBy__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var hooks_useNativeCurrency__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(19915);
/* harmony import */ var _multicall_hooks__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(410);










/**
 * Returns a map of the given addresses to their eventually consistent BNB balances.
 */ function useNativeBalances(uncheckedAddresses) {
    var native = (0,hooks_useNativeCurrency__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)();
    var multicallContract = (0,hooks_useContract__WEBPACK_IMPORTED_MODULE_5__/* .useMulticallContract */ .gq)();
    var addresses = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return uncheckedAddresses ? lodash_orderBy__WEBPACK_IMPORTED_MODULE_7___default()(uncheckedAddresses.map(utils__WEBPACK_IMPORTED_MODULE_6__/* .isAddress */ .UJ).filter(function(a) {
            return a !== false;
        })) : [];
    }, [
        uncheckedAddresses
    ]);
    var results = (0,_multicall_hooks__WEBPACK_IMPORTED_MODULE_9__/* .useSingleContractMultipleData */ .es)(multicallContract, "getEthBalance", (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return addresses.map(function(address) {
            return [
                address
            ];
        });
    }, [
        addresses
    ]));
    return (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return addresses.reduce(function(memo, address, i) {
            var ref, ref1;
            var value = results === null || results === void 0 ? void 0 : (ref = results[i]) === null || ref === void 0 ? void 0 : (ref1 = ref.result) === null || ref1 === void 0 ? void 0 : ref1[0];
            if (value) memo[address] = _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .CurrencyAmount.fromRawAmount */ .ih.fromRawAmount(native, _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .JSBI.BigInt */ .QA.BigInt(value.toString()));
            return memo;
        }, {});
    }, [
        addresses,
        results,
        native
    ]);
}
/**
 * Returns a map of token addresses to their eventually consistent token balances for a single account.
 */ function useTokenBalancesWithLoadingIndicator(address, tokens) {
    var ref;
    var validatedTokens = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return (ref = tokens === null || tokens === void 0 ? void 0 : tokens.filter(function(t) {
            return (0,utils__WEBPACK_IMPORTED_MODULE_6__/* .isAddress */ .UJ)(t === null || t === void 0 ? void 0 : t.address) !== false;
        })) !== null && ref !== void 0 ? ref : [];
    }, [
        tokens
    ]);
    var validatedTokenAddresses = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return validatedTokens.map(function(vt) {
            return vt.address;
        });
    }, [
        validatedTokens
    ]);
    var balances = (0,_multicall_hooks__WEBPACK_IMPORTED_MODULE_9__/* .useMultipleContractSingleData */ ._Y)(validatedTokenAddresses, config_abi_erc20__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, "balanceOf", (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return [
            address
        ];
    }, [
        address
    ]));
    var anyLoading = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return balances.some(function(callState) {
            return callState.loading;
        });
    }, [
        balances
    ]);
    return [
        (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
            return address && validatedTokens.length > 0 ? validatedTokens.reduce(function(memo, token, i) {
                var ref, ref1;
                var value = balances === null || balances === void 0 ? void 0 : (ref = balances[i]) === null || ref === void 0 ? void 0 : (ref1 = ref.result) === null || ref1 === void 0 ? void 0 : ref1[0];
                var amount = value ? _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .JSBI.BigInt */ .QA.BigInt(value.toString()) : undefined;
                if (amount) {
                    memo[token.address] = _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .CurrencyAmount.fromRawAmount */ .ih.fromRawAmount(token, amount);
                }
                return memo;
            }, {}) : {};
        }, [
            address,
            validatedTokens,
            balances
        ]),
        anyLoading, 
    ];
}
function useTokenBalances(address, tokens) {
    return useTokenBalancesWithLoadingIndicator(address, tokens)[0];
}
// get the balance for a single token/account combo
function useTokenBalance(account, token) {
    var tokenBalances = useTokenBalances(account, [
        token
    ]);
    if (!token) return undefined;
    return tokenBalances[token.address];
}
function useCurrencyBalances(account, currencies) {
    var ref;
    var tokens = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return (ref = currencies === null || currencies === void 0 ? void 0 : currencies.filter(function(currency) {
            return currency === null || currency === void 0 ? void 0 : currency.isToken;
        })) !== null && ref !== void 0 ? ref : [];
    }, [
        currencies
    ]);
    var tokenBalances = useTokenBalances(account, tokens);
    var ref1;
    var containsNative = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return (ref1 = currencies === null || currencies === void 0 ? void 0 : currencies.some(function(currency) {
            return currency === null || currency === void 0 ? void 0 : currency.isNative;
        })) !== null && ref1 !== void 0 ? ref1 : false;
    }, [
        currencies
    ]);
    var uncheckedAddresses = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return containsNative ? [
            account
        ] : [];
    }, [
        containsNative,
        account
    ]);
    var nativeBalance = useNativeBalances(uncheckedAddresses);
    var ref2;
    return (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return (ref2 = currencies === null || currencies === void 0 ? void 0 : currencies.map(function(currency) {
            if (!account || !currency) return undefined;
            if (currency === null || currency === void 0 ? void 0 : currency.isToken) return tokenBalances[currency.address];
            if (currency === null || currency === void 0 ? void 0 : currency.isNative) return nativeBalance[account];
            return undefined;
        })) !== null && ref2 !== void 0 ? ref2 : [];
    }, [
        account,
        currencies,
        nativeBalance,
        tokenBalances
    ]);
}
function useCurrencyBalance(account, currency) {
    return useCurrencyBalances(account, [
        currency
    ])[0];
}
// mimics useAllBalances
function useAllTokenBalances() {
    var account = (0,_pancakeswap_wagmi__WEBPACK_IMPORTED_MODULE_2__/* .useWeb3React */ .Ge)().account;
    var allTokens = (0,hooks_Tokens__WEBPACK_IMPORTED_MODULE_4__/* .useAllTokens */ .e_)();
    var allTokensArray = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return Object.values(allTokens !== null && allTokens !== void 0 ? allTokens : {});
    }, [
        allTokens
    ]);
    var balances = useTokenBalances(account !== null && account !== void 0 ? account : undefined, allTokensArray);
    return balances !== null && balances !== void 0 ? balances : {};
}


/***/ }),

/***/ 29159:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ currencyId; }
/* harmony export */ });
function currencyId(currency) {
    var ref;
    if (currency === null || currency === void 0 ? void 0 : currency.isNative) return (ref = currency.symbol) === null || ref === void 0 ? void 0 : ref.toUpperCase();
    if (currency === null || currency === void 0 ? void 0 : currency.isToken) return currency.address;
    throw new Error("invalid currency");
}
/* harmony default export */ __webpack_exports__["Z"] = (currencyId);


/***/ }),

/***/ 17937:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "P4": function() { return /* binding */ basisPointsToPercent; },
  "uc": function() { return /* binding */ calculateSlippageAmount; },
  "b5": function() { return /* binding */ computeSlippageAdjustedAmounts; },
  "U7": function() { return /* binding */ computeTradePriceBreakdown; },
  "Kh": function() { return /* binding */ formatExecutionPrice; },
  "Ti": function() { return /* binding */ useRouterContract; },
  "oX": function() { return /* binding */ warningSeverity; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./packages/swap-sdk/src/index.ts + 21 modules
var src = __webpack_require__(1505);
;// CONCATENATED MODULE: ./src/config/abi/IPancakeRouter02.json
var IPancakeRouter02_namespaceObject = JSON.parse('[{"inputs":[],"name":"WETH","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"pure","type":"function"},{"inputs":[{"internalType":"address","name":"tokenA","type":"address"},{"internalType":"address","name":"tokenB","type":"address"},{"internalType":"uint256","name":"amountADesired","type":"uint256"},{"internalType":"uint256","name":"amountBDesired","type":"uint256"},{"internalType":"uint256","name":"amountAMin","type":"uint256"},{"internalType":"uint256","name":"amountBMin","type":"uint256"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"deadline","type":"uint256"}],"name":"addLiquidity","outputs":[{"internalType":"uint256","name":"amountA","type":"uint256"},{"internalType":"uint256","name":"amountB","type":"uint256"},{"internalType":"uint256","name":"liquidity","type":"uint256"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"token","type":"address"},{"internalType":"uint256","name":"amountTokenDesired","type":"uint256"},{"internalType":"uint256","name":"amountTokenMin","type":"uint256"},{"internalType":"uint256","name":"amountETHMin","type":"uint256"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"deadline","type":"uint256"}],"name":"addLiquidityETH","outputs":[{"internalType":"uint256","name":"amountToken","type":"uint256"},{"internalType":"uint256","name":"amountETH","type":"uint256"},{"internalType":"uint256","name":"liquidity","type":"uint256"}],"stateMutability":"payable","type":"function"},{"inputs":[],"name":"factory","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"pure","type":"function"},{"inputs":[{"internalType":"uint256","name":"amountOut","type":"uint256"},{"internalType":"uint256","name":"reserveIn","type":"uint256"},{"internalType":"uint256","name":"reserveOut","type":"uint256"}],"name":"getAmountIn","outputs":[{"internalType":"uint256","name":"amountIn","type":"uint256"}],"stateMutability":"pure","type":"function"},{"inputs":[{"internalType":"uint256","name":"amountIn","type":"uint256"},{"internalType":"uint256","name":"reserveIn","type":"uint256"},{"internalType":"uint256","name":"reserveOut","type":"uint256"}],"name":"getAmountOut","outputs":[{"internalType":"uint256","name":"amountOut","type":"uint256"}],"stateMutability":"pure","type":"function"},{"inputs":[{"internalType":"uint256","name":"amountOut","type":"uint256"},{"internalType":"address[]","name":"path","type":"address[]"}],"name":"getAmountsIn","outputs":[{"internalType":"uint256[]","name":"amounts","type":"uint256[]"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"amountIn","type":"uint256"},{"internalType":"address[]","name":"path","type":"address[]"}],"name":"getAmountsOut","outputs":[{"internalType":"uint256[]","name":"amounts","type":"uint256[]"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"amountA","type":"uint256"},{"internalType":"uint256","name":"reserveA","type":"uint256"},{"internalType":"uint256","name":"reserveB","type":"uint256"}],"name":"quote","outputs":[{"internalType":"uint256","name":"amountB","type":"uint256"}],"stateMutability":"pure","type":"function"},{"inputs":[{"internalType":"address","name":"tokenA","type":"address"},{"internalType":"address","name":"tokenB","type":"address"},{"internalType":"uint256","name":"liquidity","type":"uint256"},{"internalType":"uint256","name":"amountAMin","type":"uint256"},{"internalType":"uint256","name":"amountBMin","type":"uint256"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"deadline","type":"uint256"}],"name":"removeLiquidity","outputs":[{"internalType":"uint256","name":"amountA","type":"uint256"},{"internalType":"uint256","name":"amountB","type":"uint256"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"token","type":"address"},{"internalType":"uint256","name":"liquidity","type":"uint256"},{"internalType":"uint256","name":"amountTokenMin","type":"uint256"},{"internalType":"uint256","name":"amountETHMin","type":"uint256"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"deadline","type":"uint256"}],"name":"removeLiquidityETH","outputs":[{"internalType":"uint256","name":"amountToken","type":"uint256"},{"internalType":"uint256","name":"amountETH","type":"uint256"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"token","type":"address"},{"internalType":"uint256","name":"liquidity","type":"uint256"},{"internalType":"uint256","name":"amountTokenMin","type":"uint256"},{"internalType":"uint256","name":"amountETHMin","type":"uint256"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"deadline","type":"uint256"}],"name":"removeLiquidityETHSupportingFeeOnTransferTokens","outputs":[{"internalType":"uint256","name":"amountETH","type":"uint256"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"token","type":"address"},{"internalType":"uint256","name":"liquidity","type":"uint256"},{"internalType":"uint256","name":"amountTokenMin","type":"uint256"},{"internalType":"uint256","name":"amountETHMin","type":"uint256"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"deadline","type":"uint256"},{"internalType":"bool","name":"approveMax","type":"bool"},{"internalType":"uint8","name":"v","type":"uint8"},{"internalType":"bytes32","name":"r","type":"bytes32"},{"internalType":"bytes32","name":"s","type":"bytes32"}],"name":"removeLiquidityETHWithPermit","outputs":[{"internalType":"uint256","name":"amountToken","type":"uint256"},{"internalType":"uint256","name":"amountETH","type":"uint256"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"token","type":"address"},{"internalType":"uint256","name":"liquidity","type":"uint256"},{"internalType":"uint256","name":"amountTokenMin","type":"uint256"},{"internalType":"uint256","name":"amountETHMin","type":"uint256"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"deadline","type":"uint256"},{"internalType":"bool","name":"approveMax","type":"bool"},{"internalType":"uint8","name":"v","type":"uint8"},{"internalType":"bytes32","name":"r","type":"bytes32"},{"internalType":"bytes32","name":"s","type":"bytes32"}],"name":"removeLiquidityETHWithPermitSupportingFeeOnTransferTokens","outputs":[{"internalType":"uint256","name":"amountETH","type":"uint256"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"tokenA","type":"address"},{"internalType":"address","name":"tokenB","type":"address"},{"internalType":"uint256","name":"liquidity","type":"uint256"},{"internalType":"uint256","name":"amountAMin","type":"uint256"},{"internalType":"uint256","name":"amountBMin","type":"uint256"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"deadline","type":"uint256"},{"internalType":"bool","name":"approveMax","type":"bool"},{"internalType":"uint8","name":"v","type":"uint8"},{"internalType":"bytes32","name":"r","type":"bytes32"},{"internalType":"bytes32","name":"s","type":"bytes32"}],"name":"removeLiquidityWithPermit","outputs":[{"internalType":"uint256","name":"amountA","type":"uint256"},{"internalType":"uint256","name":"amountB","type":"uint256"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"amountOut","type":"uint256"},{"internalType":"address[]","name":"path","type":"address[]"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"deadline","type":"uint256"}],"name":"swapETHForExactTokens","outputs":[{"internalType":"uint256[]","name":"amounts","type":"uint256[]"}],"stateMutability":"payable","type":"function"},{"inputs":[{"internalType":"uint256","name":"amountOutMin","type":"uint256"},{"internalType":"address[]","name":"path","type":"address[]"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"deadline","type":"uint256"}],"name":"swapExactETHForTokens","outputs":[{"internalType":"uint256[]","name":"amounts","type":"uint256[]"}],"stateMutability":"payable","type":"function"},{"inputs":[{"internalType":"uint256","name":"amountOutMin","type":"uint256"},{"internalType":"address[]","name":"path","type":"address[]"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"deadline","type":"uint256"}],"name":"swapExactETHForTokensSupportingFeeOnTransferTokens","outputs":[],"stateMutability":"payable","type":"function"},{"inputs":[{"internalType":"uint256","name":"amountIn","type":"uint256"},{"internalType":"uint256","name":"amountOutMin","type":"uint256"},{"internalType":"address[]","name":"path","type":"address[]"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"deadline","type":"uint256"}],"name":"swapExactTokensForETH","outputs":[{"internalType":"uint256[]","name":"amounts","type":"uint256[]"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"amountIn","type":"uint256"},{"internalType":"uint256","name":"amountOutMin","type":"uint256"},{"internalType":"address[]","name":"path","type":"address[]"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"deadline","type":"uint256"}],"name":"swapExactTokensForETHSupportingFeeOnTransferTokens","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"amountIn","type":"uint256"},{"internalType":"uint256","name":"amountOutMin","type":"uint256"},{"internalType":"address[]","name":"path","type":"address[]"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"deadline","type":"uint256"}],"name":"swapExactTokensForTokens","outputs":[{"internalType":"uint256[]","name":"amounts","type":"uint256[]"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"amountIn","type":"uint256"},{"internalType":"uint256","name":"amountOutMin","type":"uint256"},{"internalType":"address[]","name":"path","type":"address[]"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"deadline","type":"uint256"}],"name":"swapExactTokensForTokensSupportingFeeOnTransferTokens","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"amountOut","type":"uint256"},{"internalType":"uint256","name":"amountInMax","type":"uint256"},{"internalType":"address[]","name":"path","type":"address[]"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"deadline","type":"uint256"}],"name":"swapTokensForExactETH","outputs":[{"internalType":"uint256[]","name":"amounts","type":"uint256[]"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"amountOut","type":"uint256"},{"internalType":"uint256","name":"amountInMax","type":"uint256"},{"internalType":"address[]","name":"path","type":"address[]"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"deadline","type":"uint256"}],"name":"swapTokensForExactTokens","outputs":[{"internalType":"uint256[]","name":"amounts","type":"uint256[]"}],"stateMutability":"nonpayable","type":"function"}]');
// EXTERNAL MODULE: ./src/config/constants/exchange.ts
var exchange = __webpack_require__(56974);
// EXTERNAL MODULE: ./src/hooks/useActiveChainId.ts
var useActiveChainId = __webpack_require__(56797);
// EXTERNAL MODULE: ./src/hooks/useContract.ts + 13 modules
var useContract = __webpack_require__(80070);
// EXTERNAL MODULE: ./src/state/swap/actions.ts
var actions = __webpack_require__(15103);
;// CONCATENATED MODULE: ./src/utils/exchange.ts







// converts a basis points value to a sdk percent
function basisPointsToPercent(num) {
    return new src/* Percent */.gG(src/* JSBI.BigInt */.QA.BigInt(num), exchange/* BIPS_BASE */.PM);
}
function calculateSlippageAmount(value, slippage) {
    if (slippage < 0 || slippage > 10000) {
        throw Error("Unexpected slippage value: ".concat(slippage));
    }
    return [
        src/* JSBI.divide */.QA.divide(src/* JSBI.multiply */.QA.multiply(value.quotient, src/* JSBI.BigInt */.QA.BigInt(10000 - slippage)), exchange/* BIPS_BASE */.PM),
        src/* JSBI.divide */.QA.divide(src/* JSBI.multiply */.QA.multiply(value.quotient, src/* JSBI.BigInt */.QA.BigInt(10000 + slippage)), exchange/* BIPS_BASE */.PM), 
    ];
}
function useRouterContract() {
    var chainId = (0,useActiveChainId/* useActiveChainId */.g)().chainId;
    return (0,useContract/* useContract */.cq)(exchange/* ROUTER_ADDRESS */.bR[chainId], IPancakeRouter02_namespaceObject, true);
}
// computes price breakdown for the trade
function computeTradePriceBreakdown(trade) {
    // for each hop in our trade, take away the x*y=k price impact from 0.3% fees
    // e.g. for 3 tokens/2 hops: 1 - ((1 - .03) * (1-.03))
    var realizedLPFee = !trade ? undefined : exchange/* ONE_HUNDRED_PERCENT.subtract */.yC.subtract(trade.route.pairs.reduce(function(currentFee) {
        return currentFee.multiply(exchange/* INPUT_FRACTION_AFTER_FEE */.Zw);
    }, exchange/* ONE_HUNDRED_PERCENT */.yC));
    // remove lp fees from price impact
    var priceImpactWithoutFeeFraction = trade && realizedLPFee ? trade.priceImpact.subtract(realizedLPFee) : undefined;
    // the x*y=k impact
    var priceImpactWithoutFeePercent = priceImpactWithoutFeeFraction ? new src/* Percent */.gG(priceImpactWithoutFeeFraction === null || priceImpactWithoutFeeFraction === void 0 ? void 0 : priceImpactWithoutFeeFraction.numerator, priceImpactWithoutFeeFraction === null || priceImpactWithoutFeeFraction === void 0 ? void 0 : priceImpactWithoutFeeFraction.denominator) : undefined;
    // the amount of the input that accrues to LPs
    var realizedLPFeeAmount = realizedLPFee && trade && src/* CurrencyAmount.fromRawAmount */.ih.fromRawAmount(trade.inputAmount.currency, realizedLPFee.multiply(trade.inputAmount.quotient).quotient);
    return {
        priceImpactWithoutFee: priceImpactWithoutFeePercent,
        realizedLPFee: realizedLPFeeAmount
    };
}
// computes the minimum amount out and maximum amount in for a trade given a user specified allowed slippage in bips
function computeSlippageAdjustedAmounts(trade, allowedSlippage) {
    var pct = basisPointsToPercent(allowedSlippage);
    var _obj;
    return _obj = {}, (0,_define_property/* default */.Z)(_obj, actions/* Field.INPUT */.gN.INPUT, trade === null || trade === void 0 ? void 0 : trade.maximumAmountIn(pct)), (0,_define_property/* default */.Z)(_obj, actions/* Field.OUTPUT */.gN.OUTPUT, trade === null || trade === void 0 ? void 0 : trade.minimumAmountOut(pct)), _obj;
}
function warningSeverity(priceImpact) {
    if (!(priceImpact === null || priceImpact === void 0 ? void 0 : priceImpact.lessThan(exchange/* BLOCKED_PRICE_IMPACT_NON_EXPERT */.lN))) return 4;
    if (!(priceImpact === null || priceImpact === void 0 ? void 0 : priceImpact.lessThan(exchange/* ALLOWED_PRICE_IMPACT_HIGH */.Uf))) return 3;
    if (!(priceImpact === null || priceImpact === void 0 ? void 0 : priceImpact.lessThan(exchange/* ALLOWED_PRICE_IMPACT_MEDIUM */.p9))) return 2;
    if (!(priceImpact === null || priceImpact === void 0 ? void 0 : priceImpact.lessThan(exchange/* ALLOWED_PRICE_IMPACT_LOW */.Bz))) return 1;
    return 0;
}
function formatExecutionPrice(trade, inverted) {
    if (!trade) {
        return "";
    }
    return inverted ? "".concat(trade.executionPrice.invert().toSignificant(6), " ").concat(trade.inputAmount.currency.symbol, " / ").concat(trade.outputAmount.currency.symbol) : "".concat(trade.executionPrice.toSignificant(6), " ").concat(trade.outputAmount.currency.symbol, " / ").concat(trade.inputAmount.currency.symbol);
}


/***/ }),

/***/ 57487:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "UA": function() { return /* binding */ StableConfigContext; },
  "ZP": function() { return /* binding */ useStableConfig; },
  "f8": function() { return /* binding */ useLPTokensWithBalanceByAccount; },
  "rS": function() { return /* binding */ useStableFarms; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./src/hooks/useContract.ts + 13 modules
var useContract = __webpack_require__(80070);
;// CONCATENATED MODULE: ./src/config/abi/stableSwap.json
var stableSwap_namespaceObject = JSON.parse('[{"inputs":[],"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"provider","type":"address"},{"indexed":false,"internalType":"uint256[2]","name":"token_amounts","type":"uint256[2]"},{"indexed":false,"internalType":"uint256[2]","name":"fees","type":"uint256[2]"},{"indexed":false,"internalType":"uint256","name":"invariant","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"token_supply","type":"uint256"}],"name":"AddLiquidity","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"uint256","name":"deadline","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"fee","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"admin_fee","type":"uint256"}],"name":"CommitNewFee","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"uint256","name":"fee","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"admin_fee","type":"uint256"}],"name":"NewFee","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"uint256","name":"old_A","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"new_A","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"initial_time","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"future_time","type":"uint256"}],"name":"RampA","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"provider","type":"address"},{"indexed":false,"internalType":"uint256[2]","name":"token_amounts","type":"uint256[2]"},{"indexed":false,"internalType":"uint256[2]","name":"fees","type":"uint256[2]"},{"indexed":false,"internalType":"uint256","name":"token_supply","type":"uint256"}],"name":"RemoveLiquidity","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"provider","type":"address"},{"indexed":false,"internalType":"uint256[2]","name":"token_amounts","type":"uint256[2]"},{"indexed":false,"internalType":"uint256[2]","name":"fees","type":"uint256[2]"},{"indexed":false,"internalType":"uint256","name":"invariant","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"token_supply","type":"uint256"}],"name":"RemoveLiquidityImbalance","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"provider","type":"address"},{"indexed":false,"internalType":"uint256","name":"token_amount","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"coin_amount","type":"uint256"}],"name":"RemoveLiquidityOne","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"uint256","name":"A","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"t","type":"uint256"}],"name":"StopRampA","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"buyer","type":"address"},{"indexed":false,"internalType":"uint256","name":"sold_id","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"tokens_sold","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"bought_id","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"tokens_bought","type":"uint256"}],"name":"TokenExchange","type":"event"},{"inputs":[],"name":"A","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"ADMIN_ACTIONS_DELAY","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"FEE_DENOMINATOR","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"KILL_DEADLINE_DT","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"MAX_A","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"MAX_ADMIN_FEE","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"MAX_A_CHANGE","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"MAX_DECIMAL","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"MAX_FEE","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"MIN_RAMP_TIME","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"N_COINS","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"PRECISION","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"","type":"uint256"}],"name":"PRECISION_MUL","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"","type":"uint256"}],"name":"RATES","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"STABLESWAP_FACTORY","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256[2]","name":"amounts","type":"uint256[2]"},{"internalType":"uint256","name":"min_mint_amount","type":"uint256"}],"name":"add_liquidity","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"admin_actions_deadline","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"i","type":"uint256"}],"name":"admin_balances","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"admin_fee","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"apply_new_fee","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"","type":"uint256"}],"name":"balances","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256[2]","name":"amounts","type":"uint256[2]"},{"internalType":"bool","name":"deposit","type":"bool"}],"name":"calc_token_amount","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"_token_amount","type":"uint256"},{"internalType":"uint256","name":"i","type":"uint256"}],"name":"calc_withdraw_one_coin","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"","type":"uint256"}],"name":"coins","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"new_fee","type":"uint256"},{"internalType":"uint256","name":"new_admin_fee","type":"uint256"}],"name":"commit_new_fee","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"donate_admin_fees","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"i","type":"uint256"},{"internalType":"uint256","name":"j","type":"uint256"},{"internalType":"uint256","name":"dx","type":"uint256"},{"internalType":"uint256","name":"min_dy","type":"uint256"}],"name":"exchange","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"fee","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"future_A","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"future_A_time","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"future_admin_fee","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"future_fee","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"i","type":"uint256"},{"internalType":"uint256","name":"j","type":"uint256"},{"internalType":"uint256","name":"dx","type":"uint256"}],"name":"get_dy","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"i","type":"uint256"},{"internalType":"uint256","name":"j","type":"uint256"},{"internalType":"uint256","name":"dx","type":"uint256"}],"name":"get_dy_underlying","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"get_virtual_price","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"initial_A","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"initial_A_time","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address[2]","name":"_coins","type":"address[2]"},{"internalType":"uint256","name":"_A","type":"uint256"},{"internalType":"uint256","name":"_fee","type":"uint256"},{"internalType":"uint256","name":"_admin_fee","type":"uint256"},{"internalType":"address","name":"_owner","type":"address"}],"name":"initialize","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"isInitialized","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"is_killed","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"kill_deadline","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"kill_me","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"_future_A","type":"uint256"},{"internalType":"uint256","name":"_future_time","type":"uint256"}],"name":"ramp_A","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"_amount","type":"uint256"},{"internalType":"uint256[2]","name":"min_amounts","type":"uint256[2]"}],"name":"remove_liquidity","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256[2]","name":"amounts","type":"uint256[2]"},{"internalType":"uint256","name":"max_burn_amount","type":"uint256"}],"name":"remove_liquidity_imbalance","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"_token_amount","type":"uint256"},{"internalType":"uint256","name":"i","type":"uint256"},{"internalType":"uint256","name":"min_amount","type":"uint256"}],"name":"remove_liquidity_one_coin","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"renounceOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"revert_new_parameters","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"stop_rampget_A","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"token","outputs":[{"internalType":"contract PancakeStableSwapLP","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"unkill_me","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"withdraw_admin_fees","outputs":[],"stateMutability":"nonpayable","type":"function"}]');
;// CONCATENATED MODULE: ./src/config/abi/infoStableSwap.json
var infoStableSwap_namespaceObject = JSON.parse('[{"inputs":[],"name":"FEE_DENOMINATOR","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"N_COINS","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"PRECISION","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"_swap","type":"address"}],"name":"PRECISION_MUL","outputs":[{"internalType":"uint256[2]","name":"swapPRECISION_MUL","type":"uint256[2]"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"_swap","type":"address"}],"name":"RATES","outputs":[{"internalType":"uint256[2]","name":"swapRATES","type":"uint256[2]"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"_swap","type":"address"},{"internalType":"uint256[2]","name":"_balances","type":"uint256[2]"}],"name":"_xp_mem","outputs":[{"internalType":"uint256[2]","name":"result","type":"uint256[2]"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"_swap","type":"address"}],"name":"balances","outputs":[{"internalType":"uint256[2]","name":"swapBalances","type":"uint256[2]"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"_swap","type":"address"},{"internalType":"uint256","name":"_amount","type":"uint256"}],"name":"calc_coins_amount","outputs":[{"internalType":"uint256[2]","name":"","type":"uint256[2]"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"_swap","type":"address"},{"internalType":"uint256[2]","name":"_balances","type":"uint256[2]"},{"internalType":"uint256","name":"amp","type":"uint256"}],"name":"get_D_mem","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"_swap","type":"address"},{"internalType":"uint256[2]","name":"amounts","type":"uint256[2]"}],"name":"get_add_liquidity_fee","outputs":[{"internalType":"uint256[2]","name":"liquidityFee","type":"uint256[2]"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"_swap","type":"address"},{"internalType":"uint256[2]","name":"amounts","type":"uint256[2]"}],"name":"get_add_liquidity_mint_amount","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"_swap","type":"address"},{"internalType":"uint256","name":"i","type":"uint256"},{"internalType":"uint256","name":"j","type":"uint256"},{"internalType":"uint256","name":"dx","type":"uint256"}],"name":"get_exchange_fee","outputs":[{"internalType":"uint256","name":"exFee","type":"uint256"},{"internalType":"uint256","name":"exAdminFee","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"_swap","type":"address"},{"internalType":"uint256[2]","name":"amounts","type":"uint256[2]"}],"name":"get_remove_liquidity_imbalance_fee","outputs":[{"internalType":"uint256[2]","name":"liquidityFee","type":"uint256[2]"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"_swap","type":"address"},{"internalType":"uint256","name":"_token_amount","type":"uint256"},{"internalType":"uint256","name":"i","type":"uint256"}],"name":"get_remove_liquidity_one_coin_fee","outputs":[{"internalType":"uint256","name":"adminFee","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"_swap","type":"address"}],"name":"token","outputs":[{"internalType":"contract IERC20","name":"","type":"address"}],"stateMutability":"view","type":"function"}]');
;// CONCATENATED MODULE: ./src/config/abi/stableLP.json
var stableLP_namespaceObject = JSON.parse('[{"inputs":[],"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"spender","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Transfer","type":"event"},{"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"address","name":"spender","type":"address"}],"name":"allowance","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"approve","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"_to","type":"address"},{"internalType":"uint256","name":"_amount","type":"uint256"}],"name":"burnFrom","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"decimals","outputs":[{"internalType":"uint8","name":"","type":"uint8"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"subtractedValue","type":"uint256"}],"name":"decreaseAllowance","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"addedValue","type":"uint256"}],"name":"increaseAllowance","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"miner","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"_to","type":"address"},{"internalType":"uint256","name":"_amount","type":"uint256"}],"name":"mint","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"name","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"totalSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transfer","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transferFrom","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"nonpayable","type":"function"}]');
// EXTERNAL MODULE: ./packages/swap-sdk/src/index.ts + 21 modules
var src = __webpack_require__(1505);
// EXTERNAL MODULE: ./src/state/wallet/hooks.ts
var hooks = __webpack_require__(5460);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/hooks/useActiveWeb3React.ts
var useActiveWeb3React = __webpack_require__(97477);
// EXTERNAL MODULE: ./node_modules/swr/immutable/dist/index.mjs
var dist = __webpack_require__(49770);
// EXTERNAL MODULE: ./packages/farms/constants/index.ts
var constants = __webpack_require__(37971);
// EXTERNAL MODULE: ./packages/tokens/src/index.ts + 8 modules
var tokens_src = __webpack_require__(30693);
;// CONCATENATED MODULE: ./src/views/Swap/StableSwap/hooks/useStableConfig.ts

















function useStableFarms() {
    var chainId = (0,useActiveWeb3React/* default */.Z)().chainId;
    var _ref = (0,dist/* default */.Z)(chainId && [
        "stable-farms",
        chainId
    ], /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var farms;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0,constants.getStableConfig)(chainId)
                    ];
                case 1:
                    farms = _state.sent();
                    return [
                        2,
                        farms.map(function(_param) {
                            var token = _param.token, quoteToken = _param.quoteToken, lpAddress = _param.lpAddress, rest = (0,_object_without_properties/* default */.Z)(_param, [
                                "token",
                                "quoteToken",
                                "lpAddress"
                            ]);
                            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, rest), {
                                liquidityToken: new src/* Token */.WU(chainId, lpAddress, 18, "Stable-LP", "Pancake StableSwap LPs"),
                                token0: (0,tokens_src/* deserializeToken */.iG)(token),
                                token1: (0,tokens_src/* deserializeToken */.iG)(quoteToken)
                            });
                        })
                    ];
            }
        });
    })), tmp = _ref.data, stableFarms = tmp === void 0 ? [] : tmp;
    return stableFarms;
}
function useFindStablePair(param) {
    var tokenA = param.tokenA, tokenB = param.tokenB;
    var stableFarms = useStableFarms();
    return (0,react.useMemo)(function() {
        return stableFarms.find(function(stablePair) {
            var ref, ref1, ref2, ref3;
            return tokenA && tokenB && ((stablePair === null || stablePair === void 0 ? void 0 : (ref = stablePair.token0) === null || ref === void 0 ? void 0 : ref.equals(tokenA)) && (stablePair === null || stablePair === void 0 ? void 0 : (ref1 = stablePair.token1) === null || ref1 === void 0 ? void 0 : ref1.equals(tokenB)) || (stablePair === null || stablePair === void 0 ? void 0 : (ref2 = stablePair.token1) === null || ref2 === void 0 ? void 0 : ref2.equals(tokenA)) && (stablePair === null || stablePair === void 0 ? void 0 : (ref3 = stablePair.token0) === null || ref3 === void 0 ? void 0 : ref3.equals(tokenB)));
        });
    }, [
        tokenA,
        tokenB,
        stableFarms
    ]);
}
function useLPTokensWithBalanceByAccount(account) {
    var lpTokens = useStableFarms();
    var ref = (0,_sliced_to_array/* default */.Z)((0,hooks/* useTokenBalancesWithLoadingIndicator */.v2)(account !== null && account !== void 0 ? account : undefined, lpTokens.map(function(param) {
        var liquidityToken = param.liquidityToken;
        return liquidityToken;
    })), 1), stableBalances = ref[0];
    var lpTokensWithBalance = (0,react.useMemo)(function() {
        return lpTokens.filter(function(param) {
            var liquidityToken = param.liquidityToken;
            var ref;
            return (ref = stableBalances[liquidityToken.address]) === null || ref === void 0 ? void 0 : ref.greaterThan("0");
        });
    }, [
        lpTokens,
        stableBalances
    ]);
    return lpTokensWithBalance.map(function(lpToken) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, lpToken), {
            tokenAmounts: [],
            reserve0: src/* CurrencyAmount.fromRawAmount */.ih.fromRawAmount(lpToken === null || lpToken === void 0 ? void 0 : lpToken.token0, "0"),
            reserve1: src/* CurrencyAmount.fromRawAmount */.ih.fromRawAmount(lpToken === null || lpToken === void 0 ? void 0 : lpToken.token1, "0"),
            getLiquidityValue: function() {
                return src/* CurrencyAmount.fromRawAmount */.ih.fromRawAmount(lpToken === null || lpToken === void 0 ? void 0 : lpToken.token0, "0");
            }
        });
    });
}
var StableConfigContext = (0,react.createContext)(null);
function useStableConfig(param) {
    var tokenA = param.tokenA, tokenB = param.tokenB;
    var stablePair = useFindStablePair({
        tokenA: tokenA,
        tokenB: tokenB
    });
    var stableSwapContract = (0,useContract/* useContract */.cq)(stablePair === null || stablePair === void 0 ? void 0 : stablePair.stableSwapAddress, stableSwap_namespaceObject);
    var stableSwapInfoContract = (0,useContract/* useContract */.cq)(stablePair === null || stablePair === void 0 ? void 0 : stablePair.infoStableSwapAddress, infoStableSwap_namespaceObject);
    var stableSwapLPContract = (0,useContract/* useContract */.cq)(stablePair === null || stablePair === void 0 ? void 0 : stablePair.liquidityToken.address, stableLP_namespaceObject);
    return (0,react.useMemo)(function() {
        return {
            stableSwapConfig: stablePair,
            stableSwapContract: stableSwapContract,
            stableSwapInfoContract: stableSwapInfoContract,
            stableSwapLPContract: stableSwapLPContract
        };
    }, [
        stablePair,
        stableSwapContract,
        stableSwapInfoContract,
        stableSwapLPContract
    ]);
}


/***/ })

}]);